var customJsIntId = setInterval(function() {
  if(typeof jQuery !== "undefined") {
    console.log("jQuery LOADED");
    clearInterval(customJsIntId);
    customJsJqueryDocumentReady();
  }
}, 100);

function forIframeScrollToTop() {
  jQuery(".title:first").get(0).scrollIntoView();
}

window.addEventListener("message", function(event) {
        console.log("Child from " + event.data);
        if(event.data == "forIframeScrollToTop") {
          forIframeScrollToTop();
        }
    });

var cartCurrSubtotal = 0;

function cartGetCurrSubtotal() {
  console.log("cartGetCurrSubtotal = " + parseFloat((jQuery(".totals__subtotal-value").text().replace("$", "")).replace(",", "")));
  var thisSubtotal = 0.00;
  $(".cart-item").each(function(i, elem) {
    console.log( $(elem).find(".price--end:last").text().replace("$", "").replace(",", "") );
    thisSubtotal += parseFloat( $(elem).find(".price--end:last").text().replace("$", "").replace(",", "") );
    console.log("curr thisSubtotal = " + thisSubtotal);
  });
  console.log("thisSubtotal = " + thisSubtotal);

  if(true || window.location.search.indexOf("subtotalfix") > -1) {
    jQuery(".totals__subtotal-value").text( '$' + thisSubtotal.toFixed(2) );
    jQuery(".totals__subtotal-value").css("visibility", "visible");
    return thisSubtotal;
  }
  return parseFloat((jQuery(".totals__subtotal-value").text().replace("$", "")).replace(",", ""));
  
	//return parseFloat((jQuery(".totals__subtotal-value").text().replace("$", "")).replace(",", ""));
}

function cartGetSubtotalWithDiscount() {
  var currSubtotalWithDiscount = parseFloat((jQuery(".subtotal-with-discount .price").text().replace("$", "")).replace(",", ""));
  console.log("cartGetSubtotalWithDiscount = " + currSubtotalWithDiscount);
  if(!currSubtotalWithDiscount || isNaN(currSubtotalWithDiscount)) {
    return 0;
  }
  return currSubtotalWithDiscount;
}

function cartGetOrderUltimateSubtotal() {
  if(cartGetSubtotalWithDiscount() >= 0.01) {
   return cartGetSubtotalWithDiscount();
  }
  return cartGetCurrSubtotal();
}

function getTotalProductsInCart() {
  var thisTotalProductsInCart = 0;
  jQuery("#cart .quantity__input").each(function(i, elem) {
    // thisTotalProductsInCart += parseInt(jQuery(elem).val());
    var skucode = jQuery(elem).closest(".cart-item.line-item").attr("data-skucode");
    if(skucode.match(/^TRAPPGC.+/)) {
              return;
            }
    
    thisTotalProductsInCart++;
  });
  console.log("thisTotalProductsInCart = " + thisTotalProductsInCart);
  return thisTotalProductsInCart;
} // getTotalProductsInCart

var detectSubtotalChangeIntId = 0;

function detectSubtotalChange() {
  
  detectSubtotalChangeIntId = setInterval(function() {
    if((cartGetCurrSubtotal() != cartCurrSubtotal && cartCurrSubtotal) 
      || (getTotalProductsInCart() != totalProductsInCart)
      ) {
      clearInterval(detectSubtotalChangeIntId);
    	window.location = "/cart?stchange=" + Math.random();
    } else if(cartGetCurrSubtotal() != cartCurrSubtotal && cartCurrSubtotal < .01) {
      cartCurrSubtotal = cartGetCurrSubtotal();
    }
  }, 200);
} // detectSubtotalChange

function updateDiscountCodeAmount(discountCode, totalPrice, discountAmt) {
  console.log('updateDiscountCodeAmount');
var url = "https://apps2.faultless.com/shopify/trapp/vineoh18/editdiscountcodeamount.php?discountCode=" + discountCode + "&totalPrice=" + totalPrice + "&discountAmt=" + discountAmt + "";
  console.log('updateDiscountCodeAmount = ' + url);
  jQuery.get(url, function(response) {
  	console.log(response);
  });
  jQuery("#shopify-section-footer").after('<iframe src="' + url + '" height="5" width="5"></iframe>');
} // updateDiscountCodeAmount

function getCurrentCustomerEmail() {
  if(jQuery("#currentCustomerEmail") && jQuery("#currentCustomerEmail").text()) {
  	return jQuery("#currentCustomerEmail").text().trim();
  }
  return false;
}

function isOnMobileView() {
	return jQuery(".nav-primary-mobile-icon").is(":visible") || jQuery("#Details-menu-drawer-container").is(":visible");
}

function sortCollectionProductsByHandle(selector) {
  
  	jQuery(".collection-products article[product-skucode$='71'] button.add-to-cart.button.disabled, "
           + ".collection-products article[product-skucode$='12'] button.add-to-cart.button.disabled, "
           + ".collection-products article[product-skucode$='45'] button.add-to-cart.button.disabled, "
           + ".collection-products article[product-skucode$='67'] button.add-to-cart.button.disabled "
          ).text('Sold Out');
  
  jQuery(".collection-products article[product-skucode$='71'] div.image, "
         + ".collection-products article[product-skucode$='12'] div.image, "
         + ".collection-products article[product-skucode$='45'] div.image, "
         + ".collection-products article[product-skucode$='67'] div.image "
          ).append('<div class="retiring-soon-bug">retiring soon</div>');
  
    
  	if(window.location.search.indexOf("sort_by") < 0 || window.location.search.indexOf("sort_by=title-ascending") > -1) {
    	if(jQuery(selector + " article.item.collection-product").length) {
        console.log("sorting");
          var prods = jQuery(selector + " article.item.collection-product").detach();
        prods.sort(function(a, b) {
          var aid = jQuery(a).attr("product-skucode") + a.id;
          var bid = jQuery(b).attr("product-skucode") + b.id;
          if(aid == bid) {
              return 0;
          }
          if(aid > bid) {
              return 1;
          }
          return -1;
        }); // sort
        jQuery(selector + " > div:first").append(prods);
        
          	// place seasonal melts last
          if(jQuery("h1.title").text() == "Wax Melts" || jQuery("h1.title").text().match(/Gifts /i)) {
          	jQuery(selector + " > div:first").append(jQuery("article.item.collection-product.seasonal-product-item"));
          } // if melts
          
          // place wax melter first
          if(jQuery("h1.title").text() == "Wax Melts" || jQuery("h1.title").text() == "Flameless Fragrance") {
          	jQuery(selector + " > div:first").prepend(jQuery("article.item.collection-product#trapp-melt-warmer"));
            jQuery("article.item.collection-product#trapp-melt-warmer .title-wrap .title a").append('<br><br>');
          } // if melts
          
           // place 3 wick candles first
          if(jQuery("h1.title").text() == "Seasonal Collection") {
          	jQuery(selector + " > div:first").prepend(jQuery("article.item.collection-product[id$='16oz-3-wick-poured-candle']"));
          } // if seasonal collection
          
           	// if poured candles collection, place seasonal candles after signature
          if(jQuery("h1.title").text() == "Poured Candles") {
          	jQuery("#60171-signature-home-collection-no-indigo-acai").after(jQuery("article.item.collection-product.seasonal-product-item"));
          } 
          
      } // #shopify-section-collection-template .collection-products
    } // no sort_by or title ascending
  	else if(window.location.search.indexOf("sort_by=title-descending") > -1) {
    	if(jQuery(selector + " article.item.collection-product").length) {
        console.log("sorting desc");
          var prods = jQuery(selector + " article.item.collection-product").detach();
        prods.sort(function(a, b) {
          var aid = a.id;
          var bid = b.id;
          if(aid == bid) {
              return 0;
          }
          if(aid > bid) {
              return 1;
          }
          return -1;
        }); // sort
          
        jQuery(selector + " > div:first").append(prods.get().reverse());
        
      } // #shopify-section-collection-template .collection-products
    } // no sort_by or title ascending
  	
   	jQuery(selector).css("visibility", "visible");
   	if(jQuery("#loading-collection-products").length) {
   		jQuery("#loading-collection-products").get(0).remove();
	}
	
} // sortCollectionProductsByHandle

function getRowLinePrice(row) {
	var linePrice = jQuery(row).find(".price.price--end").text().trim();
  if(linePrice) {
  	var linePriceNum = parseFloat(linePrice.replace("$", "", linePrice));
  	console.log("getRowLinePrice = " + linePrice + "; " + linePriceNum);
    return linePriceNum;
  }
  	
} // getRowLinePrice

var refreshingCartPageIntId = 0;
var refreshingCartPageWait = false;
function refreshingCartPage(txt, url, refreshingCartPageWaitEnabled) {
  if(typeof refreshingCartPageWaitEnabled !== 'undefined') {
  	refreshingCartPageWait = true;
  }
  if(!txt) {
    txt = '<div id="refreshing-cart-wrapper"><img src="https://cdn.shopify.com/s/files/1/2925/4816/files/loadingwsm.gif?87"><br>Your cart is being updated...</div>';
  }
  if(!url) {
  	url = "/cart";
  }
  refreshingCartPageIntId = setInterval(function() {
    if(!refreshingCartPageWait) {
      clearInterval(refreshingCartPageIntId);
      window.location = url;
    }
  }, 1500);
  jQuery.colorbox({ open : true, html : txt});
} //refreshingCartPage 

function isSkucodeSeasonal(skucode) {
	return skucode.match(/^[0-9]{3}(56|57|58|91|92|93|94|96|95)$/i);
} // isSkucodeSeasonal

function isSkucodeLastChance(skucode) {
  if(skucode.match(/^6[0-9]{2}([0-9]{2})?$/i) && skuToMup[skucode.substring(0, 3)]) {
  	return true;  
  }
  return false;
} // isSkucodeLastChance

function isSkucodeFlameless(skucode) {
  return skucode.match(/^(717|713|726|745|744|626|644|645|643|613|683)([0-9]+)?$/i);
}

function isSkucodeAccessories(skucode) {
  console.log("isSkucodeAccessories = " + skucode);
  // old wax melts
  if( skucode.match(/^713[0-9]{2}/) ) {
  	return true;
  }
  // old diffusers
  if( skucode.match(/^7(45|44)[0-9]{2}/) ) {
  	return true;
  }

  // retiring fragrances 202409
  if( skucode.match(/^[0-9]{3}(07|21|39|72|28|64|63)/) ) {
  	return true;
  }
  
  return skucode.match(/^(730|630)([0-9]+)?$/i);
}

var totalAccessoriesProducts = 0;
var totalAccessoriesAmount = 0.00;

function isSkucode3Wick(skucode) {
	return (skucode.match(/^(619)([0-9]+)?$/i) || skucode.match(/^(689)([0-9]+)?$/i));
}

function logGoogleAnalyticsEvent(cat, act, lab, val) {
  if(typeof val != "undefined") {
  	ga('send', 'event', cat, act, lab, val);
  } else {
  	ga('send', 'event', cat, act, lab);
  }
}

var subtotal = 0;
var subtotalWithDiscounts = 0;
var totalProductsInCart = 0;

var totalLastChanceAmount = 0.00;
var totalLastChanceMupDiscount = 0.00;
var lastChance20DiscountAmount = 0.00;

var enableLastChanceMarkDown = false;
if(window.location.search.indexOf("enableLastChanceMarkDown=1") > -1 || true) {
  // enabled 20220211
	enableLastChanceMarkDown = true;
}

var totalSeasonalAmount = 0.00;
var totalSeasonalMupDiscount = 0.00;
var totalSeasonalAmountWithMupDiscount = 0.00;
var seasonals40OffDiscount = 0.00;

var totalSevenSeriesAmount = 0.00;
var totalSevenSeriesAmountWithMupDiscount = 0.00;
var sevenSeriesPercentOffPromoEnabled = false;
var sevenSeriesPercentOffPromoPercent = 0.20;
var sevenSeriesPercentOffPromoDiscountAmount = 0.20;
if(window.location.search.indexOf("sevenSeriesPercentOffPromoEnabled=1") > -1) {
  // enabled 20220320 // disabled 20230325
  sevenSeriesPercentOffPromoEnabled = true;
}


var totalMeltWarmers = 0;
var totalMeltWarmersMax = 2;
var totalFreeWarmerMeltsMax = 3;
var totalFreeWarmerMelts = 0;
var enableWarmerMeltsPromo = false;
var totalWarmerMeltsPromoDiscount = 0.00;

var meltWarmerPercentOffPromoEnabled = false;
meltWarmerPercentOffPromoEnabled = false; // disabled 20211214 // enabled 20211210 // enabled 20210813 // disabled 20210815 11:59pm
if(window.location.search.indexOf("meltWarmerPercentOffPromoEnabled=1") > -1) {
	meltWarmerPercentOffPromoEnabled = true;
}

var meltWarmerFreeMeltPromoEnabled = false;
var meltWarmerFreeMeltPromoDiscount = 0.00;
var totalMelts = 0;
var totalMeltsToDiscount = 0;
// meltWarmerFreeMeltPromoEnabled = true; // 20211001 // disabled 20211011
if(window.location.search.indexOf("testwarmerfreemeltpromo=1") > -1) {
	meltWarmerFreeMeltPromoEnabled = true;
}

// added below 20230626 for free oils per app diffuser purchased
var freeItemsPromoEnabled = false;
var freeItemsPromoDiscount = 0.00;
var totalFreeItemsPromoRequired = 0;
var totalFreeItemsPromoToDiscount = 0;
var totalFreeItemsPromoDiscount = 0.00;
if(window.location.search.indexOf("freeItemsPromoEnabled=1") > -1) { // disabled 20230706 // enabled 20230630 for 4th of july
	freeItemsPromoEnabled = true;
}

var totalLargeCandles = 0;
var totalMists = 0;

var total3WickCandles = 0;
var total3WickCandles3Batches = 0;
var total3WickCandles2Batches = 0;
var total3WickCandlesDiscount = 0;

localStorage.removeItem('totalDiscountAmt');

var enableOriginalDiscountApp = false;
enableOriginalDiscountApp = true;

if(window.location.search.indexOf("enableOriginalDiscountApp=1") > -1) {
	enableOriginalDiscountApp = true;
}

var cartToken = "";

var specialThanksCouponDiscount = 0.0;

var specialThanksCouponExtraDiscount = 0.0;

var hideTheCheckoutButton = false;

var enableMday2021Promo = false;
/*
if(true || location && location.search && location.search.indexOf("testmday2021=") > -1) {
	enableMday2021Promo = true;
}
*/

var enableFree72And73Votive = false;
var free72And73VotiveDiscountAmt = 0.00;
var hasFree72And73Votive = false;
var free72And73VotiveRequiredAmt = 25.00;
var freeVotivesAvailable = false;

var totalFlamelessAmount = 0.00;
var totalFlamelessMupDiscount = 0.00;
var totalFlamelessAmountWithMupDiscount = 0.00;
var flameless25OffDiscountAmount = 0.00;
var enableFlameless25Off = false;
// enableFlameless25Off = true; // turned on 20210613 // turned off 20210621

var enableMom2019Promo = false;
//enableMom2019Promo = true;

var enableSummer2019Promo = false;
var summer2019PromoExtraDiscount = 0.00;
enableSummer2019Promo = false;

var enablePercentOffPromoDiscount = false;
var percentOffPromoDiscount = 0.20;
var percentOffPromoDiscountAmount = 0.00;
var percentOffPromoDiscountText = " - Valentine's Day Sale";
enablePercentOffPromoDiscount = false; // enabled 20240130 vday // disabled 20241102 enabled halloween 20241025 // disabled 20240904 // disabled 20240709 // enabled 20240704 // disabled 20240402 // enabled 20240324 // disabled 20240319 // enabled 20240315 without appliances // disabled 20240216 // enabled 20240204 // disabled 20230907 // enabled 20230831 // disabled 20230815 summer // enabled 20230809 summer // disabled 20221214 // enabled 20221207 // disabled 20221228 // enabled 20221121 bf // enabled 20220901 // disabled 20220706 // enabled 20220701 // disabled 20211208 // enabled 20211203 // disabled 20211129 // enabled 20211124 for bf2021 //disabled 20211019 // enabled 20211015 // 20210216 - disabled v-day promo

// TODO: just for the cruise gabe
if((new Date()).getDate() >= 30 || (new Date()).getDate() <= 6) {
  //enablePercentOffPromoDiscount = true;
  //console.log("!!!MANUAL ON valentine's day  Promo 2025");
}

if(location && location.search && location.search.indexOf("testEnablePercentOffPromoDiscount=") > -1) {
	enablePercentOffPromoDiscount = true;
}

var totalGiftCardAmount = 0.00;

var tenPercentOffDiscountAmount = 0.00;

var enableFreeMistPromo = false;
var freeMistPromoDiscountAmount = 0.00;
var freeMistPromoMax = 4;
var freeMistPromoTotal = 0;
var freeMistPromoMissing = 0;

var enablePercentOffFragrancePromo = false;
enablePercentOffFragrancePromo = false; // enabled 20250703 // 20250607 // enabled 20250522 // enabled 20250424 // disabled 20250325 // enabled 20240422 //enabled 20240408 // disabled 20240311 // enabled 20240304 // disabled 20231018 // enabled 20231013 // disabled 20230928 // on 20230923 // off 20230828 // on 20230818 // off 20230619 // on 20230614 father's day // turned on 20210901
var percentOffFragrancePromoPercent = 0.20; // 0.40
var percentOffFragrancePromoDiscount = 0.00;
var totalPercentOffFragrancePromoAmount = 0.00;

// TODO: just for the cruise gabe
if((new Date()).getDate() >= 8) {
  //enablePercentOffFragrancePromo = false;
  //console.log("!!!MANUAL OFF Fragrance Promo");
} else {
  //console.log("!!!STILL TRUE enablePercentOffFragrancePromo");
}

var percentOffFragrancePromoIsFragrance = function(titleOrSkucode) {

  // enabled 20250703 20% off sitewide
  if(isSkucodeAccessories(titleOrSkucode)) {
    return false;
  }
  return true;
  // end 20250522
  
  // 20250423 mother's day
  if( titleOrSkucode.match(/^(703|726|717|714)(04|08|13|25|60|79)/) ) {
  	return true;
  }
  return false;
  
  // 20250320 extra 20% off Fresh Fragrances
  
  if( titleOrSkucode.match(/^[0-9]{3}(10|20|28|73|76|78|81)/) ) {
  	return true;
  }
  return false;
  
  
  // retiring fragrances 202409
  if( titleOrSkucode.match(/^[0-9]{3}(07|21|39|72|28|64|63)/) ) {
  	return true;
  }
  return false;
  // seasonal fragrances
  if( titleOrSkucode.match(/^[0-9]{3}(56|57|58|94)/) ) {
  	return true;
  }
  return false;
  // 20241003 - Retiring Fragrances 30% off
  if( titleOrSkucode.match(/^[0-9]{3}(07|21|39|68|74|77|80)$/) ) {
  	return true;
  }
  return false;
  
  // 20240422 - Earthy Fragrances 20% off
  if( titleOrSkucode.match(/^[0-9]{3}(07|21|39|68|74|77|80)$/) ) {
  	return true;
  }
  return false;
  
  // 20240408 - Floral Fragrances 20% off
  if( titleOrSkucode.match(/^[0-9]{3}(08|13|25|60|63|75)$/) ) {
  	return true;
  }
  return false;
  
  // 20240304 - spring fragrances promo 20% off
  if( titleOrSkucode.match(/^[0-9]{3}(10|28|63|76|77|78|81)$/) ) {
  	return true;
  }
  return false;
  
  // 20231013 - seasonal?
  if( titleOrSkucode.match(/^[0-9]{3}(56|57|58|94|97)$/) ) {
  	return true;
  }
  return false;

  // 20230922
  if( titleOrSkucode.match(/^(730)(53|54|55)$/)
      ) {
  	return false;
  } // no ultrasonic diffusers
  
  if( titleOrSkucode.match(/^(728|729|730)[0-9]{2}$/)
      ) {
  	return true;
  } else {
  } // soaps or lotions or accessories
  return false;
  
  // 20230818 25% off Bourbon Mahogany, Appliances, and Accessories
  if( titleOrSkucode.match(/^[0-9]{3}97$/) || 
       titleOrSkucode.match(/^(730)[0-9]{2}$/)
      ) {
  	return true;
  } else {
  } // house box or not?
  return false;
  
  // 20230613 // house box discount
  if( titleOrSkucode.match(/^(701)[0-9]{2}$/) ) {
  	return true;
  } else {
    return false;
  } // house box or not?
  
   // 20230320 changed to (10|20|28|73|76|78)
  // 202300510 changed to (08|13|25|60|63|75) for mother's day promo 2023
  if( titleOrSkucode.match(/^[0-9]{3}(08|13|25|60|63|75)$/) ) {
  	return true;
  } else if( titleOrSkucode.indexOf("cinnamon ciderxxx") > -1 ) {
    return true;
  }
  return false;
} // percentOffFragrancePromoIsFragrance

// disabled 20230515 // enabled 20230510 // disabled 20230326 enabled 20230320 enabled AND disabled 20230111
if(location && location.search && (location.search.indexOf("testretiringpromo=") > -1 || location.search.indexOf("enablePercentOffFragrancePromo") > -1)) { 
	enablePercentOffFragrancePromo = true;
  console.log("enablePercentOffFragrancePromo");
}

/***** *****/

var enablePercentOffProductPromo = false; 
enablePercentOffProductPromo = false; // disabled 20250320 since these skucodes are now under accessories check // enabled 20240805
var percentOffProductPromoPercent = 0.00; // 0.40
var percentOffProductPromoDiscount = 0.00;
var percentOffProductPromoText = '2.6 oz. Wax Melts';
var totalPercentOffProductPromoAmount = 0.00;

var percentOffProductPromoIsProduct = function(titleOrSkucode) {
  console.log("percentOffProductPromoIsProduct ? = " + titleOrSkucode);
  // gourmet
  if( titleOrSkucode.match(/^5023xxx[0-9]+/) ) {
  	return true;
  }
  // seasonal
  /*
  if( titleOrSkucode.match(/^[0-9]{3}(56|57|58|94)/) ) {
  	return true;
  }
  */
  // old wax melts
  if( titleOrSkucode.match(/^713[0-9]{2}/) ) {
  	return true;
  }
  // old diffusers
  if( titleOrSkucode.match(/^7(45|44)[0-9]{2}/) ) {
  	return true;
  }
  return false;
  // retiring fragrances 202409
  if( titleOrSkucode.match(/^[0-9]{3}(07|21|39|72)$/) ) {
  	return true;
  }
  return false;
} // percentOffProductPromoIsProduct

/***** *****/


var enablePackagePromo = false; 
var packagePromoProducts = {};
enablePackagePromo = false; // disabled 20250406 enabled 20250401
var packagePromoPercent = 0.20; // 0.40
var packagePromoDiscount = 0.00;
var packagePromoText = '20% Off Ultrasonic Diffuser and Select Diffuser Oils When You Buy Both';
var totalPackagePromoAmount = 0.00;

if(location && location.search && location.search.indexOf("testEnablePackagePromo=") > -1) {
	enablePackagePromo = true;
}

var packagePromoIsProduct = function(titleOrSkucode) {
  console.log("packagePromoIsProduct ? = " + titleOrSkucode);
  if( titleOrSkucode.match(/^73053$/) ) {
  	return '73053';
  }
  if( titleOrSkucode.match(/^(717)(76|75|14)/) ) {
  	return '717';
  }
  return false;
} // packagePromoIsProduct

function calcPackagePromo() {
  	packagePromoDiscount = 0.00;
  	var thisTotal = 0.00;
 	var thisDiscount = 0.00;
  	
  jQuery(".cart .row.line-item").each(function(i, elem) {
            
      var sku = jQuery(elem).attr("data-sku");
      var skucode = jQuery(elem).attr("data-skucode");
      var rowLinePrice = 0.00;
      
      if(!packagePromoIsProduct(skucode)) {
      	return;
      }
      console.log("current packagePromoProducts = " + packagePromoProducts);
    console.log("current skucode package = " + packagePromoIsProduct(skucode));
      if(!packagePromoProducts[packagePromoIsProduct(skucode)]) {
        packagePromoProducts[packagePromoIsProduct(skucode)] = 1
      } else {
        packagePromoProducts[packagePromoIsProduct(skucode)]++;
      }

      console.log("calcPackagePromo = " + skucode);
      console.log("packagePromo product found = " + packagePromoIsProduct(skucode) + " " + packagePromoProducts[packagePromoIsProduct(skucode)] + " ; " + Object.keys(packagePromoProducts).length);
      
      rowLinePrice = getRowLinePrice(elem);
      thisTotal += rowLinePrice;

      var productTitleElem = jQuery(elem).find(".product-title");
      var productHref = jQuery(elem).find(".product-title a:first").attr("href");
      
    }); // each .row.line-item

  console.log("packagePromoProducts = " + packagePromoProducts);
  if(Object.keys(packagePromoProducts).length >= 2) {
    var totalToDiscount = thisTotal - thisDiscount;
    console.log('calcPackagePromo totalToDiscount = ' + thisTotal + ' - ' + thisDiscount + ' = ' + totalToDiscount);
    var thisExtraDiscount = totalToDiscount * packagePromoPercent;
    console.log('calcPackagePromo thisExtraDiscount = ' + thisExtraDiscount);
    packagePromoDiscount = thisExtraDiscount;
    return thisExtraDiscount;
  }
  
  return 0.00;
} // calcPackagePromo

/***** *****/


if(location && location.href.indexOf("apps/help-center") > -1) { 
	window.location = "/pages/faq";
}


var ffcVibrantPromoEnabled = false;
var ffcVibrantPromoCode = 'FFCVIBRANT';
var ffcVibrantPromoDiscountPerCandle = 24.75;
var ffcVibrantPromoDiscountAmount = 0.00;
// ffcVibrantPromoEnabled = true; // disabled 20211103 // enabled 20211029 but all 3wicks // dusabled 20211022

var enableMeltWarmerFfcDiscountPromo = false; // disabled 20211109 // enabled 20211103

var meltWarmerSeasonalMeltsPromoEnabled = false; // disabled 20211117
var meltWarmerSeasonalMeltsPromoDiscountAmount = 0.00;

var b4g1CandlesMeltsPromoEnabled = false;
var b4g1CandlesMeltsPromoCandlesDiscountAmount = 0.00;
var b4g1CandlesMeltsPromoMeltsDiscountAmount = 0.00;

if(location && location.search && location.search.indexOf("customrefpromocodedelete=") > -1) {
	window.localStorage.setItem('customRefPromoCode', '');	
  window.localStorage.removeItem('customRefPromoCode');
  console.log('reset customRefPromoCode');
}

if(/* true || */ (location && location.search && location.search.indexOf("b4g1CandlesMeltsPromoEnabled=") > -1)) {
    // turned on 20221128 cyber monday 2022
	b4g1CandlesMeltsPromoEnabled = true;
}

var customRefPromoCode = '';
if(location && location.search && location.search.indexOf("customrefpromocode=") > -1) {
	var customrefpromocodeMatches = location.search.match(/customrefpromocode\=([a-z0-9\-]+)/i);
  console.log('customrefpromocodeMatches = ' + customrefpromocodeMatches);
  if(customrefpromocodeMatches && customrefpromocodeMatches.length > 1) {
  	customRefPromoCode = customrefpromocodeMatches[1];
    window.localStorage.setItem('customRefPromoCode', customRefPromoCode);
  }
  //alert(customRefPromoCode);
}

if(window.localStorage.getItem('customRefPromoCode')) {
	customRefPromoCode = window.localStorage.getItem('customRefPromoCode');
  console.log('customRefPromoCode found in session = ' + customRefPromoCode);
}

if(enableSummer2019Promo) {
  if(window.location && window.location.search && window.location.search.indexOf("fbclid=") > -1) {
    customRefPromoCode = 'SUMMER19';
    console.log('AUTOMATIC customRefPromoCode = ' + customRefPromoCode);
  } else if(window.location && window.location.search && window.location.search.indexOf("mc_cid=") > -1) {
    customRefPromoCode = 'SUMMER';
    console.log('AUTOMATIC customRefPromoCode = ' + customRefPromoCode);
  }
  window.localStorage.setItem('customRefPromoCode', customRefPromoCode);
}

if(enableSummer2019Promo && !customRefPromoCode) {
  customRefPromoCode = 'SUMMERS';
  console.log('DEFAULT customRefPromoCode = ' + customRefPromoCode);
  window.localStorage.setItem('customRefPromoCode', customRefPromoCode);
}

//customRefPromoCode = '';


var hasSpecialThanksCoupon = function() {
  jQuery(".cart .product-title a").each(function(i, elem) {
  	var txt = jQuery(elem).text();
    console.log(txt);
    var matches = txt.match(/Special Thanks Coupon - ([0-9]{1,2})% Off/i);
    if(matches) {
    	console.log('spctnx = ' + matches);
      jQuery(elem).click(function(ev) {
      	ev.preventDefault();
      }); // don't go to prod page
      jQuery(elem).closest(".line-item.row").find(".image a").click(function(ev) {
      	ev.preventDefault();
      }); // don't go to prod page
      	specialThanksCouponDiscount = parseInt(matches[1]) / 100;
      	console.log(specialThanksCouponDiscount);
      	return false;
    }
  });
  if(specialThanksCouponDiscount)  {
  	return specialThanksCouponDiscount;
  }
  return specialThanksCouponDiscount;
} // hasSpecialThanksCoupon

var hasSkuCodeInCart = function(skucode) {
  var hasit = jQuery(".line-item.row[data-skucode='" + skucode + "']").length;
  console.log(skucode + " found in cart? " + hasit);
  return hasit;
} // hasSpecialThanksCoupon

var getSkucodeQty = function(skucode) {
  if(jQuery(".line-item.row[data-skucode='" + skucode + "']").length) {
  	var qty = parseInt(jQuery(".line-item.row[data-skucode='" + skucode + "'] input.quantity__input").val());
    console.log(skucode + ' qty = ' + qty);
    return qty;
  }
  return 0;
} // getSkucodeQty

var getSkucodeTotalPrice = function(skucode) {
  if(jQuery(".line-item.row[data-skucode='" + skucode + "']").length) {
    var tprice = parseFloat( jQuery(".line-item.row[data-skucode='" + skucode + "']:first .price.price--end").text().replace("$", "") );
    console.log('getSkucodeTotalPrice of ' + tprice + ' = ' + tprice);
    return tprice;
  }
  return 0;
} // getSkucodeQty

var displayFragrancePageBanner = function() {
  var hr = location.href;
  var matches = hr.match(/\/collections\/all\/([a-zA-Z\-0-9]+)/i);
  if(matches && matches.length > 1) {
  	jQuery.get("/pages/fragrance-pages-images", function(response) {
			
 	 });
  } // in a frag page?

} // displayFragrancePageBanner

var skuToMup = {
  "626" : "3/$27 or $10 ea." // spray
  , "644" : "2/$60 or $32 ea." // refills
  , "643" : "2/$80 or $42 ea." // diffusers
  , "645" : "2/$80 or $42 ea." // diffusers
  , "609" : "2/$35 or $20 ea." // 3.75
  , "611" : "3/$15 or $6 ea." // vot
  , "607" : "2/$62 or $35 ea."
  , "613" : "3/$25 or $9 ea." // melt
  , "618" : "2/$30 or $16 ea." // vibrant 2.5
  , "619" : "2/$99 or $52 ea." // vibrant 16 oz
  , "601" : "2/$57 or $30 ea."
  , "693" : "2/$15 or $8 ea." // temp seasonal melt sku // added 20210208
  
  , "717" : "2/$30 or $15 ea."
  , "701" : "2/$72 or $36 ea."
  , "703" : "2/$64 or $32 ea."
  , "711" : "3/$19.50 or $6.50 ea."
  , "709" : "2/$40 or $20 ea."
  , "718" : "3/$42 or $15 ea."
  , "719" : "2/$96 or $48 ea."
  , "713" : "3/$28.50 or $9.50 ea."
  , "726" : "2/$36 or $18 ea."
  , "745" : "2/$80 or $40 ea."
  , "744" : "2/$60 or $30 ea."
};

/*
16oz: $52 or 2/$99

2.5oz: $16 or 2/$30
*/

var skuToProductType = {
  "626" : "Home Fragrance Sprays" // flameless
  , "644" : "Reed Diffuser Refills" // flameless
  , "643" : "Reed Diffusers" // flameless
  , "645" : "Reed Diffusers" // flameless
  , "609" : "3.75 oz. Poured Candles"
  , "611" : "Votive Candles"
  , "607" : "8.75 oz. Poured Candles"
  , "613" : "Wax Melts" // flameless
  , "618" : "2.5 oz. Vibrant Collection" // vibrant 2.5
  , "619" : "16 oz. Vibrant Collection" // vibrant 16 oz
  , "601" : "7 oz. Poured Candles"
  , "693" : "Seasonal Wax Melts"
  
  , "717" : "Ultrasonic Diffuser Oils"
  , "701" : "7 oz. House Candles"
  , "703" : "7 oz. Signature Candles"
  , "711" : "2 oz. Votives"
  , "709" : "3.75 oz. Candles"
  , "718" : "2.1 oz. Seasonal Votives"
  , "719" : "16 oz. 3-Wick Candles"
  , "713" : "Fragrance Melts"
  , "726" : "Fragrance Mists"
  , "745" : "Reed Diffusers"
  , "744" : "Reed Diffuser Refills"
};

var skuToDiscount = {
  '626' : new Array(3, 1.00, 0) // spray, qty required, discount per product, current quantity
  , '644' : new Array(2, 2.00, 0) // refills
  , '643' : new Array(2, 2.00, 0) // diffusers
  , '609' : new Array(2, 2.50, 0) // 3.75
  , '611' : new Array(3, 1.00, 0) // vot
  , '607' : new Array(2, 4.00, 0)
  , '613' : new Array(3, 0.66, 0) // melt
  , '618' : new Array(2, 1, 0) // vibrant 2.5
  , '619' : new Array(2, 2.50, 0) // vibrant 16 oz
  , '601' : new Array(2, 1.50, 0)
  , '693' : new Array(2, 0.50, 0) // temp seasonal melt
  
  , '717' : new Array(2, 3, 0)
  , '701' : new Array(2, 2, 0)
  , '703' : new Array(2, 2, 0)
  , '711' : new Array(3, 0.50, 0)
  , '709' : new Array(2, 3, 0)
  , '718' : new Array(3, 1, 0) // 2.1 oz Seasonal Votives -1 each
  , '719' : new Array(2, 2, 0)
  , '713' : new Array(3, 1.5, 0)
  , '726' : new Array(2, 2, 0)
  , '745' : new Array(2, 3, 0)
  , '744' : new Array(2, 2, 0)
};

skuToDiscount = {
  
  '717' : new Array(2, 0, 0)
  , '701' : new Array(2, 0, 0)
  , '703' : new Array(2, 0, 0)
  , '711' : new Array(3, 0, 0)
  , '709' : new Array(2, 0, 0)
  , '718' : new Array(3, 0, 0) // 2.1 oz Seasonal Votives -1 each
  , '719' : new Array(2, 0, 0)
  , '713' : new Array(3, 0, 0)
  , '726' : new Array(2, 0, 0)
  , '745' : new Array(2, 0, 0)
  , '744' : new Array(2, 0, 0)
};

// NEW ONE BELOW. ALWAYS TRUE
if(enableLastChanceMarkDown) {

	skuToMup = {
    "717" : "2/$30 or $15 ea."
    , "701" : "2/$72 or $36 ea."
    , "703" : "2/$64 or $32 ea."
    , "711" : "3/$19.50 or $6.50 ea."
    , "709" : "2/$40 or $20 ea."
      , "718" : "3/$45 or $15 ea."
    , "719" : "2/$96 or $48 ea."
    , "713" : "3/$28.50 or $9.50 ea."
    , "726" : "2/$36 or $18 ea."
    , "745" : "2/$80 or $40 ea."
    , "744" : "2/$60 or $30 ea."
  };

  skuToMup = {};
  
	skuToProductType = {

     "717" : "Ultrasonic Diffuser Oils"
    , "701" : "7 oz. House Candles"
    , "703" : "7 oz. Signature Candles"
    , "711" : "2 oz. Votives"
    , "709" : "3.75 oz. Candles"
     , "718" : "2.1 oz. Seasonal Votives"
    , "719" : "16 oz. 3-Wick Candles"
    , "713" : "Fragrance Melts"
    , "726" : "Fragrance Mists"
    , "745" : "Reed Diffusers"
    , "744" : "Reed Diffuser Refills"
  };

  skuToDiscount = { // OLD ONE. NEW BELOW

       '717' : new Array(2, 3, 0)
      , '701' : new Array(2, 2, 0)
      , '703' : new Array(2, 2, 0)
      , '711' : new Array(3, 0.50, 0)
      , '709' : new Array(2, 3, 0)
    , '718' : new Array(3, 1, 0) // 2.1 oz Seasonal Votives -1 each
      , '719' : new Array(2, 2, 0)
      , '713' : new Array(3, 1.5, 0)
      , '726' : new Array(2, 2, 0)
      , '745' : new Array(2, 3, 0)
      , '744' : new Array(2, 2, 0)
    };


  skuToDiscount = {

       '717' : new Array(2, 0, 0)
      , '701' : new Array(2, 0, 0)
      , '703' : new Array(2, 0, 0)
      , '711' : new Array(3, 0, 0)
      , '709' : new Array(2, 0, 0)
    , '718' : new Array(3, 0, 0) // 2.1 oz Seasonal Votives -1 each
      , '719' : new Array(2, 0, 0)
      , '713' : new Array(3, 0, 0)
      , '726' : new Array(2, 0, 0)
      , '745' : new Array(2, 0, 0)
      , '744' : new Array(2, 0, 0)
    };
} // enableLastChanceMarkDown


var getSkuMupPrice = function(sku) {
  var m = skuToMup[sku].match(/([0-9])\/\$([0-9]{2}) or \$([0-9\.]+)/i);
  console.log('getSkuMupPrice =' + sku + '; ' + m);
  var mupPrice = parseFloat(m[2]) / parseFloat(m[1]);
  console.log('mup price = ' + mupPrice);
  return mupPrice;
  
} // getSkuMupPrice

var initBrandTaglineOffersCounter = 0;

function initBrandTaglineOffers() {
  
	 var html = 

       /*
       '<div class="announcement-bar__message small" style="display:none;"><p onclick="window.location=\'https://trappfragrances.com/collections/seasonal-collection\'"><strong>Limited Time | 20% off Entire Seasonal Collection </p>'
             + '<a href="https://trappfragrances.com/collections/seasonal-collection" class="announcement-bar__link link pl-2">SHOP SALE</a></div>' +
        */
        
        /*
         '<div class="announcement-bar__message small" style="display:none;"><p onclick="window.location=\'https://trappfragrances.com/products/73055-trapp-ultrasonic-app-driven-diffuser\'">Buy a Smart-App Driven Ultrasonic Diffuser, get an Ultrasonic Diffuser Oil FREE—any fragrance!</p>'
             + '<!-- <a href="https://trappfragrances.com/products/trapp-melt-warmer" class="announcement-bar__link link pl-2">SHOP NOW</a> --></div>'
*/
       ''
       /*
        + '<div class="announcement-bar__message small" style="display:none;"><p>20% off Entire Purchase</p>'
             + '</div>'
             */
             /*
       + '<div class="announcement-bar__message small" style="display:none;"><p>Final day to order and ship in time for Christmas is Monday 12/11</p>'
             + '</div>'
             */
       
        + '<div class="announcement-bar__message small" style="display:none;"><p><strong>$4.99 Flat Rate Shipping</strong> when you order 2 or more items. | </p><a href="https://trappfragrances.com/pages/faq#content-3a" class="announcement-bar__link link pl-2">LEARN MORE</a>'
             + '</div>'
/*
        + '<div class="announcement-bar__message small" style="display:none;"><p>FREE SHIPPING ON ORDERS OF $99+</p><a href="https://trappfragrances.com/pages/faq#content-3a" class="announcement-bar__link link pl-2">LEARN MORE</a>&nbsp;or <a href="https://trappfragrances.com/pages/store-locator" class="announcement-bar__link link pl-2">FIND A STORE</a>'
             + '</div>'
      
  + '<div class="announcement-bar__message small" style="display:none;"><p>Limited time! 50% off Cinnamon Cider</p><a href="https://trappfragrances.com/collections/seasonal-collection" class="announcement-bar__link link pl-2">SHOP NOW</a>'
             + '</div>' */
       
/*
        '<div class="announcement-bar__message small" style="display:none;"><p onclick="window.location=\'/products/trapp-melt-warmer\'">Buy 4, Get 1 Free: 7oz Signature Candles & Fragrance Melts</p>'
             + '<a href="https://trappfragrances.com/collections/7-oz-signature-poured-candles" class="announcement-bar__link link pl-2"></a></div>'
*/
             
       ''
       ;
  // promo banner text
  //jQuery("#shopify-section-template--17876314161267__image_hero .banner__text p, #shopify-section-template--17876314161267__image_hero .h1").css("text-shadow", "0 0 2px black");
  
  jQuery("#shopify-section-announcement-bar .announcement-bar__message:first").after(html);
  jQuery("#shopify-section-announcement-bar").addClass("initialized");
  rotateBrandTaglineOffers();
  setInterval(function() {
    rotateBrandTaglineOffers();
  }, 4000);
} // initBrandTaglineOffers

function rotateBrandTaglineOffers() {
	console.log('hide');
  initBrandTaglineOffersCounter++;
  if(initBrandTaglineOffersCounter < 2) {
  	jQuery("#shopify-section-announcement-bar .announcement-bar__message:eq(0)").fadeOut(0, function() {
      jQuery("#shopify-section-announcement-bar .announcement-bar").append(jQuery("#shopify-section-announcement-bar .announcement-bar__message:eq(0)"));
      jQuery("#shopify-section-announcement-bar .announcement-bar__message:eq(0)").fadeIn(600);
    });
  } else {
  	jQuery("#shopify-section-announcement-bar .announcement-bar__message:eq(0)").fadeOut(600, function() {
      jQuery("#shopify-section-announcement-bar .announcement-bar").append(jQuery("#shopify-section-announcement-bar .announcement-bar__message:eq(0)"));
      jQuery("#shopify-section-announcement-bar .announcement-bar__message:eq(0)").fadeIn(600);
    });
  }
    
}

function displayPromoSalePrice() {
  $(".product-card-wrapper[card-wrapper-skucode]").each(function(i, elem) {
                  
          var thisSkucode = $(elem).attr("card-wrapper-skucode");
          if(percentOffFragrancePromoIsFragrance(thisSkucode)) {
            $(".product-card-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .card__inner .card__badge").html('<span class="badge badge--bottom-left color-accent-1">Sale</span>');
            $(".product-card-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__regular").css("display", "none");
            $(".product-card-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__sale").css("display", "block");
            $(".product-card-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__sale .price-item--regular").html(
               $(".product-card-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__regular .price-item--regular").html()
            );
            var thisPriceFloat = parseFloat( $(".product-card-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__regular .price-item--regular").html().replace(/([^0-9\.]+)/ig, '') );
            $(".product-card-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__sale .price-item--sale.price-item--last").html(
               "$" + (thisPriceFloat * (1 - percentOffFragrancePromoPercent)).toFixed(2) + " USD"
            );
          } // percentOffFragrancePromoIsFragrance?
         
        }); // loop
  
} // displayPromoSalePrice

function customJsJqueryDocumentReady() {

jQuery(document).ready(function(ev) {
  
  $("#shopify-section-header").attr("aria-hidden", false);
  
  initHoverDiamondEffect();
  
 initBrandTaglineOffers();
  
  initCandleDiamondFilters();

  $(".fragrance-checkbox-label").on("mouseover", function(ev) {
    console.log('mouseover diamond filter');
    $(this).closest("button").find(".fragrance-diamond:first").addClass("hover-active");
  });

  $(".fragrance-checkbox-label").on("mouseout", function(ev) {
    console.log('mouseout diamond filter');
    $(this).closest("button").find(".fragrance-diamond:first").removeClass("hover-active");
  });

  $(".facet-filters__field").on("click", function(ev) {
    console.log(this);
 //   $(this).find(".select").trigger("click");
  });
  
  if(document.getElementById("customer_register_link")) {
  	jQuery("#customer_register_link").addClass("button");
 }

  if(window.location && window.location.href.indexOf("collections/vendor") > -1) {
    window.location = '/';
  }

  if(window.location && window.location.href.indexOf("pages/faq") > -1 && location.hash && location.hash.indexOf("content-3a") > -1) {
    jQuery("#btn3").click();
    setTimeout(function() {
      jQuery("#content-3a").addClass("active");
    }, 1000);
    
  }
  
  if(document.getElementById("carouselWrapper")) {
  	initCarouselWrapperArrows();
  }
  
  if(jQuery("#shopify-section-1527017580889 .section-title")) {
    jQuery("#shopify-section-1527017580889 .section-title").click(function(ev) {
      var win = window.open("https://www.instagram.com/trappfragrances/", "_blank");
      win.focus();
    });
 	}
  
  if(jQuery("#section-block-image-1620798956c646eb67-0").length) {
  	jQuery("#top-promo-banner-1").hide();
  }
  
  if(window.location.href.indexOf("pages/about-us") > -1) {
  	// https://cdn.shopify.com/s/files/1/2925/4816/files/Trapp_Full-of-Life-Diamond_White.png?v=1642021039
    jQuery("#shopify-section-template--14209848311890__main_hero .banner__media").append(
    	'<div class="full-of-life-overlay"><img src="https://cdn.shopify.com/s/files/1/2925/4816/files/Trapp_Full-of-Life-Diamond_White.png?v=1642021039"></div>'
    );
  }
  
  if(typeof initFanclubPopup !== "undefined") {
    if(true || window.location.search && window.location.search.indexOf("initFanclubPopup=1") > -1) {
      // go live 20200811
      // deactivate 20240211
      // initFanclubPopup();
    }
  }
  
  if(jQuery("#mc-embedded-subscribe").length) {
    jQuery("#mc-embedded-subscribe").val("GO");
  }
  
  if(jQuery("#shopify-section-template--14209848541266__featured_products a.button")) {
    jQuery("#shopify-section-template--14209848541266__featured_products a.button").text("BROWSE SELECTION");
    jQuery("#shopify-section-template--14209848541266__featured_products a.button").attr("href", "/collection/all-fragrances");
  }
  
  
  if(jQuery("#price-template--14212754800722__main").length) {
    var prodPagePrice = (jQuery("#price-template--14212754800722__main .price-item--regular").text().match(/\$[0-9]{1,3}/));
    var prodPageUrl = window.location.href;
    if(prodPageUrl.match(/products\/(7[0-9]{2}).+/)) {
      var prodPageSku = prodPageUrl.match(/products\/(7[0-9]{2}).+/);
      prodPageSku = prodPageSku[1];
      console.log("prodPageSku = " + prodPageSku);
      jQuery("#price-template--14212754800722__main").after('<div id="mup-pricing-wrapper">' + skuToMup[prodPageSku] + '</div>');
    } // 2022 prod
    else {
      for(var k in skuToMup) {
        if(jQuery(".price__badge-sale").text().indexOf("Sale") >= -1) {
          console.log("LAST CHANCE product. no mup.");
        	continue;
        }
      	var currSkuToMup = skuToMup[k];
        if(currSkuToMup.indexOf(" or " + prodPagePrice + " ea") > -1) {
        	jQuery("#price-template--14212754800722__main").after('<div id="mup-pricing-wrapper">' + currSkuToMup + '</div>');
        }
      } // loop
      
      if(jQuery("#price-template--14212754800722__main .price-item--regular").text().match(/\$0\.00/)) {
        console.log("0 dollars prolly promo product");
        window.location.href = "/?ref=ppr";
      }
    }
    
    if(jQuery("#mup-pricing-wrapper").get(0) && jQuery("#mup-pricing-wrapper").text().match(/undefined/)) {
    	jQuery("#mup-pricing-wrapper").hide();
      console.log('HIDING MUP');
    }
    
    if(/* location.search && location.search.indexOf("initProductImagesSlider") > -1 && */ jQuery("body").width() > 1100) {
    	initProductImagesSlider();
    }
    
    setTimeout(function() {
    	initHoverDiamondEffect();
    }, 2000);

    // product__info-wrapper //.product__accordion.accordion
    if(jQuery(".product__info-wrapper:first .product__accordion.accordion:first .accordion__content.rte:first").length > 0 && 
       jQuery(".product__info-wrapper:first .product__accordion.accordion:first .accordion__content.rte:first").text().trim().length < 10) {
      jQuery(".product__info-wrapper:first .product__accordion.accordion:first").hide();
    } // hide product details accordion if empty

    
    // for 20250401 promo only
    //console.log(window.location.search);
    if(window.location.search.indexOf("testPackagePromoEnabled=") > -1 || enablePackagePromo) {
      console.log("!!!PACKAGE PROMO ENABLED");
      $("product-form form button[type='submit']").click(function(ev) {
        setTimeout(function() {
          console.log("Added to cart = " + window.location);
          $.getJSON("/cart.js", function(response) {
            console.log(response);
            if(window.location.href.indexOf("73053") > -1) {

              if(response.items) {
                var oilsFound = false;
                for(var i = 0; i < response.items.length; i++) {
                  if(response.items[i].sku.match(/(717)(76|75|14)/)) {
                    oilsFound = true;
                  }
                  
                } // loop

                $(".cart-notification__links:first").before('<div id="package-promo-alert" style="clear:both;"></div>');
                
                if(!oilsFound) {
                  $("#package-promo-alert").html('<h3 style="margin-top:-10px;"><strong>Limited time only!<br>' 
                  + ' Get 20% Off this Diffuser</strong> and select Ultrasonic Diffuser Oils when you have both in your cart: <span style="font-size:0.8em">'
                   + '<a href="https://trappfragrances.com/products/71776-no-76-watermint-eucalyptus-0-5-oz-ultrasonic-diffuser-oil">No. 76 Watermint Eucalyptus</a>'
                   + ', <a href="https://trappfragrances.com/products/71775-no-75-hibiscus-prosecco-0-5-oz-ultrasonic-diffuser-oil">No. 75 Hibiscus Prosecco</a>'
                    + ' or <a href="https://trappfragrances.com/products/71714-no-14-mediterranean-fig-0-5-oz-ultrasonic-diffuser-oil">No. 14 Mediterranean Fig</a></span>'
                  + '</h3>');
                } else {
                }
              } // has items
              
            } else if(window.location.href.match(/\/(717)(76|75|14)\-/)) {

              if(response.items) {
                var diffuserFound = false;
                for(var i = 0; i < response.items.length; i++) {
                  if(response.items[i].sku == "73053") {
                    diffuserFound = true;
                  }
                  
                } // loop

                if(!diffuserFound) {
                  var thisProdUrl = 'https://trappfragrances.com/products/73053-trapp-90ml-ultrasonic-diffuser?packagePromoFrom=717';
                  $(".cart-notification__links:first").before('<div id="package-promo-alert" style="clear:both;"></div>');
                  $("#package-promo-alert").html('<h3 style="margin-top:-10px;"><strong>Limited time only!<br>' 
                  + ' Get 20% Off this Diffuser Oil</strong> and the <a href="' + thisProdUrl + 'https://trappfragrances.com/products/73053-trapp-90ml-ultrasonic-diffuser">90 ml Signature Ultrasonic Diffuser</a> when you <a href="' + thisProdUrl + '">add it to your cart</a> now!'
                  + '</h3>');
                }
              } // has items
              
            } // diffuser or oil for the promo?
          });
        }, 500);
      });
    } // packagePromoEnabled
    
    // sale badge on product page for mother's day 2025
    if(enablePercentOffFragrancePromo) {
      var thisSkucode = $(".product__info-wrapper:first").attr("card-wrapper-skucode");
      if(percentOffFragrancePromoIsFragrance(thisSkucode)) {
        $(".product__info-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .card__inner .card__badge").html('<span class="badge badge--bottom-left color-accent-1">Sale</span>');
        $(".product__info-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__regular").css("display", "none");
        $(".product__info-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__sale").css("display", "block");
        $(".product__info-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__sale .price-item--regular").html(
           $(".product__info-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__regular .price-item--regular").html()
        );
        var thisPriceFloat = parseFloat( $(".product__info-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__regular .price-item--regular").html().replace(/([^0-9\.]+)/ig, '') );
        $(".product__info-wrapper[card-wrapper-skucode='" + thisSkucode + "'] .price__sale .price-item--sale.price-item--last").html(
           "$" + (thisPriceFloat * (1 - percentOffFragrancePromoPercent)).toFixed(2) + " USD"
        );
      } // percentOffFragrancePromoIsFragrance?

      setTimeout(function() {
        // TODO: REPEATED ABOVE TWICE. PLEASE REFACTOR WHEN YOU HAVE THE TIME, GABE SELF
        displayPromoSalePrice();
        
      }, 1000);
      
    } // enablePercentOffFragrancePromo
    
  } // product details page
  
  if(jQuery(".product__info-wrapper .price__badge-sold-out").length && jQuery(".product__info-wrapper .price__badge-sold-out").text().match(/old out/)
    && (window.location.href.match(/(lotion|soap)/) || window.location.href.match(/products\/7.+/) || window.location.href.match(/products\/citronella.+/) || window.location.href.match(/products_preview/))) {
 	jQuery(".product__info-wrapper .price__badge-sold-out").text("Sold Out");
    
    if(jQuery(".product-form__submit.button").html().match(/old out/)) {
    	jQuery(".product-form__submit.button").text("Sold Out");
    } // ONLY IF Sold Out
  }
  

  
  var productGridFirstProdHref = '';
  var comingSoonIntId = '';
  
  var applyComingSoon = function() {
    console.log("applyComingSoon");
    productGridFirstProdHref = jQuery("#product-grid .card-wrapper:first a:first").attr("href") + jQuery("#product-grid .card-wrapper:eq(1) a:first").attr("href");
    jQuery(".card-wrapper").each(function(d,t){
        var s=jQuery(t).find("a:first").attr("href");
      if(!s) {
      	return;
      }
      console.log("s = " + s);
        if(s.match(/products\/(7.+|citronella.+|.+lotion|.+soap)/) && jQuery(t).find(".badge--bottom-left").text()=="Sold out" && !s.match(/products\/(70357.+)/)) { // temporary exclude orange clove 202301
         jQuery(t).find(".badge--bottom-left").text("Sold Out")
        } // if
      }); // loop
  } // applyComingSoon

  var productGridFirstProdHrefRet = '';
  var retiringSoonIntId = '';
  
  var applyRetiringSoon = function() {
    console.log("applyRetiringSoon");
    productGridFirstProdHrefRet = jQuery("#product-grid .card-wrapper:first a:first").attr("href") + jQuery("#product-grid .card-wrapper:eq(1) a:first").attr("href");
    jQuery('.product-card-wrapper[card-wrapper-title*="Cinnamon Cider"]').each(function(i, elem) {
    //  jQuery(elem).find(".card__badge").append('<span class="badge badge--bottom-left">SALE!</span>');
    });
  } // applyRetiringSoon
  
  if(jQuery("#product-grid .card--product, .card-wrapper").length) {
	
    applyComingSoon();

   applyRetiringSoon();
    
    if(jQuery("#product-grid .card--product").length) {

      
      comingSoonIntId = setInterval(function() {
        //console.log("checking first product href = " + jQuery("#product-grid .card-wrapper:first a:first").attr("href"));
        if(productGridFirstProdHref != jQuery("#product-grid .card-wrapper:first a:first").attr("href") + jQuery("#product-grid .card-wrapper:eq(1) a:first").attr("href")) {
        	applyComingSoon();
        }
      }, 1000);

    
      retiringSoonInt = setInterval(function() {
        if(productGridFirstProdHrefRet != jQuery("#product-grid .card-wrapper:first a:first").attr("href") + jQuery("#product-grid .card-wrapper:eq(1) a:first").attr("href")) {
        	applyRetiringSoon();
         // clearInterval(retiringSoonIntId);
        }
      }, 1000);
      
    } // product collection page
    
    	/*
     	let productGridObserver = new MutationObserver(mutationRecords => {
        console.log("MUTATION RECORDS = " + mutationRecords); // alert(the changes)
      }); // productGridObserver
    	productGridObserver.observe(document.getElementById("product-grid"), {
        childList: true, // observe direct children
        subtree: true, // lower descendants too
        characterDataOldValue: true, // pass old data to callback
      }); // productGridObserver.observe
      */
	} // #product-grid .card--product
  
  if(window.location.search && window.location.search.indexOf("clearTotalDiscountAmt=") > -1) {
  	localStorage.removeItem('totalDiscountAmt');
    console.log('tda = ' + localStorage.getItem('totalDiscountAmt'));
  }
  
  //console.log('location href = ' + location.href);
  if(location && window.location.href.match(/\/account$/i)) {
    if(document.referrer && document.referrer.match(/\/account\/login$/i)) {
      console.log('doc referrer = ' + document.referrer);
      logGoogleAnalyticsEvent('Customer Sign-in', 'submit', '');
    }
  } // in login page?

  if(location && window.location.href.match(/\/account\/register$/i)) {
    if(document.referrer && document.referrer.match(/\/account\/register$/i)) {
      console.log('doc referrer = ' + document.referrer);
      if(document.getElementById("create_customer") && $("#create_customer").html().match(/have sent an email/i)) {
        logGoogleAnalyticsEvent('Customer Registration', 'submit', '');
      }
    }
  } // just registered
  
  if(location && window.location.href.match(/\/challenge$/i)) {
    if(document.referrer && document.referrer.match(/\/account\/register$/i)) {
      console.log('doc referrer = ' + document.referrer);
      logGoogleAnalyticsEvent('Customer Registration', 'submit', '');
    }
  } // just registered
  
  jQuery("#app-nav .nav-primary-mobile-icon.nav-primary-mobile-icon-account").click(function(ev) {
  	ev.preventDefault();
    jQuery("#app-nav .multi-login-links").toggle();
  });
  
  jQuery(".nav-level-1 a[href='/search'], .nav-primary-mobile-icon-search").click(function(ev) {
		ev.preventDefault();
    	jQuery(".search.section a[data-toggle-top-bar-search]").click();
	});
  jQuery(".nav-level-1 a[href='/search']").html('<i class="fa fa-search"></i>');
  //jQuery("#top-bar .search.section").css("display", "none");

  var buildHomeMainMenu = function(ulSelector, level) {
    var spacing = '';
    for(var i = 0; i < level; i++) {
    	spacing += "&nbsp;&nbsp;";
    }
  	jQuery(ulSelector).find("> li").each(function(i, elem) {
      var link = jQuery(elem).find("> a:first").get(0);
    	jQuery("#home-main-menu-select").append('<option class="option-level-' + level + '" value="' + jQuery(link).attr("href") + '">' + spacing + jQuery(link).text() + '</option>');
      if(jQuery(elem).find("ul").length) {
        buildHomeMainMenu(jQuery(elem).find("ul:first"), level + 1);
      }
    });
  } // buildHomeMainMenu
  
  if(jQuery("#Banner-template--17876314161267__image_hover").length) {
    jQuery("#Banner-template--17876314161267__image_hover .banner__media-image-half").css("cursor", "pointer");
    jQuery("#Banner-template--17876314161267__image_hover .banner_hover:eq(0)").click(function(ev) {
      window.location = '/search?q=82&options%5Bprefix%5D=last&type=product';
    });
    jQuery("#Banner-template--17876314161267__image_hover .banner_hover:eq(1)").click(function(ev) {
      window.location = '/collections/gourmet-collection';
    });
  } // Banner-template--17876314161267__image_hover
  
  if(jQuery("#home-main-menu").length) {
    jQuery("#home-main-menu-select").append('<option>Explore our products</option>');
    buildHomeMainMenu("#home-main-menu > ul", 0);
    jQuery("#home-main-menu-select").change(function(ev) {
      window.location = jQuery(this).find("option:selected").val();
    });
    
    //jQuery("#section-block-image-1522706385618-0 img:first").attr("src", "https://cdn.shopify.com/s/files/1/2925/4816/files/B4G1_FALL19_BANNER1-web.jpg?1046").show();
  } // if "#home-main-menu"
  
  if(!jQuery(".nav-primary-mobile-icon").is(":visible")) {
  	// add Shop By and Explore
    jQuery("#app-header .column-max:first").append('<span id="shop-by-header-lbl" class="menu-header-lbl">Shop by</span><span id="explore-header-lbl" class="menu-header-lbl">Explore</span><a href="/">&nbsp;</a>');
  } // not on mobile

  if(jQuery("#Banner-template--17876314161267__image_hero_R9L9kr").length && isOnMobileView()) {
    var mobileBannerUrl2023 = "https://cdn.shopify.com/s/files/1/2925/4816/files/Trapp_B2C_Email_Capsule-Collection-Launch_Mobile.jpg?v=1718525553";
    // https://cdn.shopify.com/s/files/1/2925/4816/files/Trapp_Homepage-Hero_New-Fragrance_81-Waterlily_MOBILE.jpg?v=1678726700
  //   mobileBannerUrl2023 = "https://cdn.shopify.com/s/files/1/2925/4816/files/2024-04_Trapp_Web_B2C_Earth-Day_Mobile.jpg?v=1713762846";

    // promo banner start mobile
mobileBannerUrl2023 = "https://cdn.shopify.com/s/files/1/2925/4816/files/2024-07-30_Trapp_B2C_20-off-melts_mobile_1.jpg?v=1722850812";
   //jQuery("#Banner-template--17876314161267__image_hero").find(".banner__box .white-color-text").removeClass("white-color-text");
    // promo banner end mobile
    
    jQuery("#Banner-template--17876314161267__image_hero").find("img:first").hide().after('<img src="' + mobileBannerUrl2023 + '">');
    //jQuery(".banner__content:first > .banner__box").css("padding-bottom", "250px"); // 20250508 don't force height on first anymore
    
    jQuery(".banner__content .banner__box").find("hr.short").hide(); // 20250508 hide all hr
    
    jQuery("#Banner-template--17876314161267__image_hero").find("hr.short").hide();

    // PROMO BANNER 2025
     if(jQuery("#Banner-template--17876314161267__image_hero_Fwkrzr").find("img:first").length) {
       mobileBannerUrl2023 = "https://cdn.shopify.com/s/files/1/2925/4816/files/Trapp_B2C_Email_4th-of-July_Mobile_1.jpg?v=1751533801";
      jQuery("#Banner-template--17876314161267__image_hero_Fwkrzr").find("img:first").hide().after('<img src="' + mobileBannerUrl2023 + '">');
      jQuery("#Banner-template--17876314161267__image_hero_Fwkrzr").find("hr.short").hide();
      jQuery("#Banner-template--17876314161267__image_hero_Fwkrzr .banner__text").css("font-weight", "bold").css("text-shadow", "0 0 3px black");
    } // has FIRST promo banner 2025
    
    if(jQuery("#Banner-template--17876314161267__image_hero_R9L9kr").find("img:first").length) {
       mobileBannerUrl2023 = "https://cdn.shopify.com/s/files/1/2925/4816/files/2025.01-NewReedDiffuserKit-Mobile1.jpg?v=1735714593";
      jQuery("#Banner-template--17876314161267__image_hero_R9L9kr").find("img:first").hide().after('<img src="' + mobileBannerUrl2023 + '">');
      jQuery("#Banner-template--17876314161267__image_hero_R9L9kr").find("hr.short").hide();
      jQuery("#Banner-template--17876314161267__image_hero_R9L9kr .banner__text").css("font-weight", "bold").css("text-shadow", "0 0 3px black");
    } // comes after promo banner if promo banner is visible
   
    
    console.log("MOBILE BANNER GO");
  } // home page banner and on mobile? 202212

  var currHomePageHero = 0;
  var homePageHeroIntervalId = 0;

  var homeHeroDots = '';

  var loadHomepageHero = function() {

    jQuery("#home-hero-container-dots .dot").removeClass("active");
    
    if(currHomePageHero >= jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]').length) {
      currHomePageHero = 0;
      jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:gt(' + currHomePageHero + ')').css("display", "none").animate({opacity: 0}, 1000);
    } else {
      jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:gt(' + currHomePageHero + ')').css("display", "none").css("opacity", 0);
      jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:eq(' + currHomePageHero + ')').css("display", "block").animate({opacity: 1}, 1000);  
    }

    jQuery("#home-hero-container-dots .dot:eq(" + currHomePageHero + ")").addClass("active");
    
  } // loadHomepageHero
  
 jQuery("#Banner-template--17876314161267__image_hero").find(".banner__box .white-color-text *").css("text-shadow", "#000 0 0 3px").css("font-weight", "bold");

  // home page _image_hero
  if(jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]').length 
    && jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]').length > 1
//    && window.location && window.location.search.indexOf("testCarousel=1") > 0
    ) {

    setTimeout(function() {
      if(enablePercentOffFragrancePromo) {
        $("section.featured-products .collection .card-wrapper").each(function(i, elem) {
          $(elem).addClass("product-card-wrapper");
          var thisHref = $(elem).find("a:first").attr("href");
          console.log("thisHref = " + thisHref);
          var thisArr = thisHref.match(/products\/([0-9]{5})/i);
          console.log("thisArr = " + thisArr[1]);
          $(elem).attr("card-wrapper-skucode", thisArr[1]);
        });
        displayPromoSalePrice();
      } // if enablePercentOffFragrancePromo
      
    }, 1000);
    
    
    console.log("HOME PAGE HERO FOUND and MULTIPLE" + jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:eq(' + '0' + ')').css("height"));
    jQuery('#MainContent').css("position", "relative");
    //jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:eq(' + '0' + ')').css("z-index", 9999);
    jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:eq(' + '0' + ')').css("z-index", 1);
    jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:gt(' + '0' + ')').css("position", "absolute").css("width", "100%").css("z-index", 2).css("opacity", 0).css("top", 0).css("display", "none");
    jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:gt(' + '0' + ') div.banner.banner--medium')
      .css("min-height", jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:eq(' + '0' + ')').css("height"));
    jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:gt(' + '0' + ') div.banner.banner--medium')
      .css("max-height", jQuery('section[id^="shopify-section-template--17876314161267__image_hero"]:eq(' + '0' + ')').css("height"));
    
    if(!homeHeroDots) {
      var homeHeroDotsSize = jQuery('section[id^="shopify-section-template--"][id*="__image_hero"]').length;
      console.log("HOME HERO DOTS SIZE = " + homeHeroDotsSize);
      for(var i = 0; i < homeHeroDotsSize; i++) {
        homeHeroDots += '<div class="dot"></div>';
      }
        jQuery(".home-hero-container-dots:first").html(homeHeroDots);
    } // homeHeroDots already populated?
    
    
    jQuery("#home-hero-container-dots .dot:eq(" + currHomePageHero + ")").addClass("active");


    
    
    jQuery("#home-hero-container-dots .dot").click(function(ev) {
      clearInterval(homePageHeroIntervalId);
      currHomePageHero = jQuery("#home-hero-container-dots .dot").index(this);
      console.log("currHomePageHero = " + currHomePageHero);
      loadHomepageHero();
    }); // click dot

    var instafeedIntId = setInterval(function() {
      if(jQuery(".instafeed-new-layout-item > a[onclick]").length) {
        clearInterval(instafeedIntId);
        jQuery(".instafeed-new-layout-item > a[onclick]").attr("title", "Opens in a new window - Trapp Instagram image");
      }
    }, 100);

    var instafeedIntId2 = setInterval(function() {
      if(jQuery("a[data-instafeed-src]").length) {
        clearInterval(instafeedIntId2);
        jQuery("a[data-instafeed-src]").attr("title", "Opens in a new window - Trapp Instagram image");
      }
    }, 100);
    
    homePageHeroIntervalId = setInterval(function() {
      //jQuery().css("opacity", 1);

      currHomePageHero++;
      loadHomepageHero();
      
    }, 6000); // setInterval
    
  } // home page _image_hero and MULTI

  if(isOnMobileView() && window.location.href.indexOf("retailer-resources") > -1) {
    jQuery(".banner__media.media:first").hide().after('<img style="width:100%;" src="' + 'https://cdn.shopify.com/s/files/1/2925/4816/files/Trapp_Retailer-Landing-Page_Hero_MOBILE_1.jpg?v=1696039972' + '">');
    $(".banner__content.banner__content--center").hide();
  }
  
  if(jQuery("#section-block-image-1522706385618-0").length && jQuery(".nav-primary-mobile-icon").is(":visible")) {
    var mobileBannerUrl = "https://cdn.shopify.com/s/files/1/2925/4816/files/free_votives_banner2-mobile.jpg?v=1582264094";
    //mobileBannerUrl = "https://cdn.shopify.com/s/files/1/2925/4816/files/TRAPP_NEW-FRAG-2020-SITE_Banner_reviews_mobile-_1_-web.jpg?v=1583194282";
    /*
    mobileBannerUrl = "https://cdn.shopify.com/s/files/1/2925/4816/files/Hibiscus-Prosecco-Mobile-Banner-3.30-opt.jpg?v=1585718298";
    mobileBannerUrl = "https://cdn.shopify.com/s/files/1/2925/4816/files/Tabac-and-Leather-Mobile-Banner-3.30.20.jpg?v=1586754838";
    mobileBannerUrl = "https://cdn.shopify.com/s/files/1/2925/4816/files/Free-Fragrance-Mother_s-Day-Promo-Mobile-Banner-4.20.jpg?v=1587360509";
    */
    mobileBannerUrl = "https://cdn.shopify.com/s/files/1/2925/4816/files/May-Mobile-Banner-web.jpg?v=1588570008";
    mobileBannerUrl = "https://cdn.shopify.com/s/files/1/2925/4816/files/Tabac-and-Leather-Mobile-Banner1500px.jpg?v=1593412385";
   // mobileBannerUrl = "https://cdn.shopify.com/s/files/1/2925/4816/files/4th-of-July-Trapp-Mobile-Banner-1500px.jpg?v=1593667720";
   // jQuery("#section-block-image-1522706385618-0").find("img:first").attr("src", mobileBannerUrl);
    
    jQuery("#section-block-image-1588569635278-0").find("img:first").attr("src", "https://cdn.shopify.com/s/files/1/2925/4816/files/May-Mobile-Banner-Find-a-Store-web.jpg?v=1588570164");
    
    
  } // home page banner and on mobile?
  
  if(	location && location.href.indexOf("collections/flameless-fragrance") > -1 && jQuery(".nav-primary-mobile-icon").is(":visible")
     	&& jQuery(".collection-image img").length
    	) {
    var mobileBannerUrl = "https://cdn.shopify.com/s/files/1/2925/4816/files/25_-off-Flameless-Mobile-Banner-1500px.jpg?v=1593063325";
    //jQuery(".collection-image:first").find("img:first").attr("src", mobileBannerUrl);
    
  } // flameless fragrance page during 25% off promo
  
  if(jQuery("#shopify-section-1598983015295 #trapp-melt-warmer img").length) {
    jQuery("#shopify-section-1598983015295 .collection-products .small-item-grid-1").prepend(jQuery("#shopify-section-1598983015295 #trapp-melt-warmer"));
    jQuery("#shopify-section-1598983015295 #trapp-melt-warmer img").attr("src", "https://cdn.shopify.com/s/files/1/2925/4816/products/Melter-In-and-Out-of-Box-Front-Unlit.jpg?v=1598981824")
  } // home page trapp melt warmer image switch
  
  if(	location 
     	&& location.href.indexOf("collections/wax-melts") > -1
     	&& jQuery(".collection-image img").length
    	) {
    jQuery("#61394-fireside-pumpkin-oz-home-fragrance-melts img").attr("src", "https://cdn.shopify.com/s/files/1/2925/4816/files/seasonal-2020-fireside-pumpkin-thumb_16743c60-19de-4c3c-a080-95049ada8b51.jpg?v=1597217949");
    jQuery("#61358-holiday-oz-home-fragrance-melts img").attr("src", "https://cdn.shopify.com/s/files/1/2925/4816/files/seasonal-2020-holiday-thumb_d3cb82b7-9639-458f-8c29-5e0e2f9c6ea3.jpg?v=1597217949");
    jQuery("#61356-white-fir-oz-home-fragrance-melts img").attr("src", "https://cdn.shopify.com/s/files/1/2925/4816/files/seasonal-2020-white-fir-thumb_69899f0e-1920-4ad1-bfa1-6e39fce74154.jpg?v=1597217949");
    jQuery("#61357-orange-clove-oz-home-fragrance-melts img").attr("src", "https://cdn.shopify.com/s/files/1/2925/4816/files/seasonal-2020-orange-clove-thumb_0772fa91-53e7-423f-8742-719acf861b79.jpg?v=1597217949");
    jQuery("#61391-lemon-sugar-cookie-oz-home-fragrance-melts img").attr("src", "https://cdn.shopify.com/s/files/1/2925/4816/files/seasonal-2020-lemon-sugar-cookie-thumb_da65c37e-8b7e-417c-b873-845b413a83a2.jpg?v=1597217949");
    jQuery("#61392-hearth-oz-home-fragrance-melts img").attr("src", "https://cdn.shopify.com/s/files/1/2925/4816/files/seasonal-2020-hearth-thumb_3881a0f4-77b1-4d3e-9c3c-cb771afbe5b4.jpg?v=1597217949");
    jQuery("#61393-golden-cypress-oz-home-fragrance-melts img").attr("src", "https://cdn.shopify.com/s/files/1/2925/4816/files/seasonal-2020-golden-cypress-thumb_83fa0dbe-9ba3-445e-bd43-4eec9f05bd71.jpg?v=1597217949");
  } // wax melts collection page
  
  if(jQuery("#app-body nav.breadcrumbs").length && jQuery("#app-body nav.breadcrumbs a").length > 1) {
      jQuery("#app-body nav.breadcrumbs a:last").addClass("last-breadcrumb");
    }

  
	var inShoppingCart = false;
  	inShoppingCart = jQuery("#main-cart-items").length && jQuery("#cart").length;
  	console.log(inShoppingCart);
    inShoppingCart = false; // forever false for NL, no need to call this custom code anymore
  
  if(inShoppingCart) {
    
    /*
    // disabled 20210202
    if(true || hasSkuCodeInCart('FALL19PROMO') || hasSkuCodeInCart('FALLTRAPPPROMO') || hasSkuCodeInCart('SEASONAL19PROMO')) {
    	b4g1SeasonalIsEnabled = true; // enable 20200904
    }
    */

    jQuery(".totals__subtotal-value").css("visibility", "hidden");
    
    var clickQtyTimeoutId = 0;
    
    function onQtyClick() {
      
      clickQtyTimeoutId = setTimeout(function() {
      	window.location = "/cart?ts=1";
      }, 400);
      return;
      if(clickQtyTimeoutId) {
          clearTimeout(clickQtyTimeoutId);
        	clickQtyTimeoutId = 0;
          return;
        }
   	 clickQtyTimeoutId = setTimeout(function() {
      	window.location = "/cart?ts=1";
       //alert('ok');
          clickQtyTimeoutId = 0;
      }, 400);
   	} // onQtyClick
    
    /*
    
    jQuery(".cart .row.line-item .quantity__button").click(function(ev) {
      onQtyClick();
    });
    
    jQuery(".cart .row.line-item input").on("change keyup", function(ev) {
      setTimeout(function() {
      	window.location = "/cart";
      }, 400)
    });
    
    jQuery(".cart .row.line-item a.button").click(function(ev) {
      setTimeout(function() {
      	window.location = "/cart";
      }, 400)
    });
    
    
    Shopify.onCartUpdate = function (cart) {
      window.location = "/cart?oncartupdate";
  };
  */
    /*
    var mutationObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    alert(mutation);
  });
});
    
    mutationObserver.observe(document.getElementById("totals-subtotal-value"), {
  
  characterData: true,
  attributeOldValue: true,
  characterDataOldValue: true
});
*/
    
    if(seasonals50OffIsEnabled) {
        b4g1SeasonalIsEnabled = false;
    }
    
    if(hasSkuCodeInCart('INTERNALDEMOMELTWARMER2020') || hasSkuCodeInCart('63052')) {
   // 	enableWarmerMeltsPromo = true;
      console.log('enableWarmerMeltsPromo');
    }
    
 
    if(//	(window.location.search && window.location.search.indexOf("testfree74and75votive=1") >= 0)
       // || hasSkuCodeInCart("INTERNALTESTINGPRODUCT")
      // true
      (window.location.search && window.location.search.indexOf("testfree76and77votive=1") >= 0)
      || true // activated 20210316
        ) {
       enableFree72And73Votive = true;
    }

    
    /*
    // disabled 20200504
    if((window.location.search && window.location.search.indexOf("testfreemistpromo=1") >= 0)
       || hasSkuCodeInCart("INTERNALTESTINGPRODUCT")
      	|| true // turned on 20200420
      ) {
    	enableFreeMistPromo = true;
    }
    */
    
    /*
    // deactivated 20200629
    if(hasSkuCodeInCart("INTERNALTESTINGPRODUCT") || true) {
      enableFlameless25Off = true;
    }
    */
    
    console.log("enableOriginalDiscountApp = " + enableOriginalDiscountApp);
    if(enableOriginalDiscountApp || (window.location.search && window.location.search.indexOf("testcarttoken=") > -1)) {
      //console.log(jQuery.get);
      jQuery.get("/cart.json", function(response) {
        console.log("CART.JS = " + response + "; " + response.token);
          //var cartJson = JSON.parse(response);
       
          cartToken = response.token;
        // remove specials chars from cartToken 202406
        cartToken = (cartToken.replace("?", "")).replace("=", "");
          console.log("crttok = " + cartToken);
      });
   }
    
  	//jQuery("form.cart").before('<img src="https://cdn.shopify.com/s/files/1/2925/4816/files/loadingwsm.gif?1918972491611896069" alt="Loading...">');
    //jQuery("form.cart").css("visibility", "hidden");
    
    //jQuery(".cart__checkout-button.button, #dynamic-checkout-cart").css("visibility", "hidden");
    
    var discountInterval = setInterval(function() { 
      
      if(hasSkuCodeInCart('PromoCode21519Seasonal')) {
          seasonals40OffIsEnabled = true;
      }
      
      if(jQuery(".so-cart-discount-notes").length || enableOriginalDiscountApp) {
     	var totalDiscountAmt = 0.00;
        clearInterval(discountInterval);
        
        var skuToDiscountSeasonal = {};
        
        for(var k in skuToDiscount) {
          skuToDiscountSeasonal[k] = new Array(skuToDiscount[k][0], skuToDiscount[k][1], 0);
        } // loop through skuToDiscount
        
        var skuQuantities = {};
        var hasMupDiscount = false;
        
        var skuTotalDiscounts = {};
        
        var skuTotalDiscountsSeasonal = {};
        
        skuToDiscountSeasonal['619'] = new Array(1, 0, 0); // 16oz 3 wick init
        
        if(enableOriginalDiscountApp) {
          
          jQuery(".so-cart-item-up-notes,.so-cart-discount-notes").hide();
          
          jQuery(".cart .row.line-item").each(function(i, elem) {
            
            var isSeasonalProduct = false;
            var isFlamelessProduct = false;
            
            var isLastChanceProduct = false;
            
            var sku = jQuery(elem).attr("data-sku");
            var skucode = jQuery(elem).attr("data-skucode");
            var dataPrice = parseFloat(jQuery(elem).attr("data-price")) / 100;
            var rowLinePrice = 0.00;
            
            rowLinePrice = getRowLinePrice(elem);
            
            if(skucode.match(/^TRAPPGC.+/)) {
              totalGiftCardAmount += rowLinePrice;
              console.log("Found GIFT CARD product.");
              return;
            }
            
            // START seasonal collection sku mapping to MUP
           // Old Seasonal Candle?  Overwrite 607 with 601
            if(skucode.match(/60756|60757|60758|60791|60792|60793|60794/i)) {
            	sku = "601";
            }
            if(skucode.match(/681([0-9]{2})/i)) {
            	sku = "601";
            }
            
            // TEMPORARY: Is Seasonal Melt? // added 20210208
            /*
            if(skucode.match(/61356|61357|61358|61391|61392|61393|61394/i)) {
            	sku = "693";
            }
            */
            if(skucode.match(/683([0-9]{2})/i)) {
            	sku = "613";
            }
            if(skucode.match(/689([0-9]{2})/i)) {
            	sku = "619";
            }
            // END mapping of seasonal collection to sku
            
            // new diffuser skucode?
            if(skucode.match(/645([0-9]{2,})/i)) {
              console.log("Detected new diffuser code.")
            	sku = "643";
            }
            
            // is Seasonal product?
            if(isSkucodeSeasonal(skucode)) {
            	isSeasonalProduct = true;
              	console.log("Found seasonal product = " + skucode);
              	totalSeasonalAmount  += rowLinePrice;
            }
            
            // is Last Chance product?
            /*
            if(isSkucodeLastChance(skucode)) {
            	isLastChanceProduct = true;
              	console.log("Found Last Chance product = " + skucode);
              	totalLastChanceAmount  += rowLinePrice;
            }
            */
            
            console.log("IS??? FLAMELESS " + skucode);
            
            // is Flameless product?
            if(isSkucodeFlameless(skucode)) {
              	
              	totalFlamelessAmount += rowLinePrice;
              	isFlamelessProduct = true;
            }

            var qty = parseInt(jQuery(elem).find("input.quantity__input").val());

            // is Accessories product?
            if(isSkucodeAccessories(skucode)) {
              	totalAccessoriesProducts += qty;
                totalAccessoriesAmount += rowLinePrice;
                console.log("current totalAccessoriesAmount = " + totalAccessoriesAmount);
                // is actually a discontinued product?
                if(!skucode.match(/^(730|630)([0-9]+)?$/i)) {
                  console.log("BUT this accessory is actually a discontinued product = " + skucode);
                  $(elem).find(".product-option:first").append(' <span class="badge price__badge-sale color-accent-1">Sale</span>');
                }
            }

            

            if(enablePercentOffFragrancePromo && percentOffFragrancePromoIsFragrance(skucode) && !isSkucodeAccessories(skucode)) {
              // do this first if fragrance disco is higher
              totalPercentOffFragrancePromoAmount += rowLinePrice;
              console.log("current totalPercentOffFragrancePromoAmount = " + totalPercentOffFragrancePromoAmount);
            } else {
              if(enablePercentOffProductPromo && percentOffProductPromoIsProduct(skucode) && !isSkucodeAccessories(skucode)) {
                totalPercentOffProductPromoAmount += rowLinePrice;
                console.log("current totalPercentOffProductPromoAmount = " + totalPercentOffProductPromoAmount);
              }
            } // fragrance or product disco since non stackable
            
            var productTitleElem = jQuery(elem).find(".cart-item__name:first");
          	var productHref = jQuery(elem).find(".product-title a:first").attr("href");
            
            var isMupProduct = false;
            
            // Old diffuser kits, $25.20.  Seasonal 3-wicks, $29.40.  Seasonal Melts, $4.80.
            // sale product so non mup?
            if(dataPrice == 25.20 || dataPrice == 29.40 || dataPrice == 4.80 || (dataPrice == 6.00 && skucode == "62665") || skucode == "64367x"
              /* || hasSkuCodeInCart('TRAPPFAMILYPROMOxxx') */
              ) {
              isMupProduct = false;
              jQuery(this).find("span.odapp-cart-discount-notes").hide();
              console.log('SKIPPING MUP FOR SALE - ' + skucode + " with price " + dataPrice);
            }
            else if(skuToMup[sku]) {
            	jQuery(productTitleElem).append('<span class="odapp-cart-discount-notes">' + skuToMup[sku] + '</span>');
                isMupProduct = true;
              
              	totalSevenSeriesAmount += rowLinePrice;
            } // sale non mup or mup?

            isMupProduct = false; // 20240412 FORCED FOR NOW. TODO: UPDATE
            
           // totalProductsInCart += qty;
            totalProductsInCart++; // just count the boxes / rows
            console.log("totalProductsInCart = " + totalProductsInCart);
            
            // is 3Wick candle?
            if(isSkucode3Wick(skucode)) {
              	total3WickCandles += qty;
              if(!skuToDiscountSeasonal[sku]) {
              	skuToDiscountSeasonal[sku] = new Array(1, 0, 0);
              }
              	console.log("current qty 3wick = " + total3WickCandles);
            }
            
            if(seasonals50OffIsEnabled && isSeasonalProduct) {
            	isMupProduct = false; // no mup stuff for 50% off seasonals
              skuToDiscountSeasonal[sku][2] += qty; // so we can count later
              jQuery(this).find("span.odapp-cart-discount-notes").hide();
              console.log('SKIPPING MUP FOR SEASONAL - ' + skucode);
            }
            
            if(!isMupProduct || !skuToDiscount[sku]) {
            	return;
            }
            
            skuToDiscount[sku][2] += qty;
            console.log("current qty " + sku + " = " + skuToDiscount[sku][2]);
            
            if(isSeasonalProduct) {
            	skuToDiscountSeasonal[sku][2] += qty;
              if(isFlamelessProduct) {
                totalSeasonalMelts += qty;
              } // a seasonal melt?
            } // a seasonal product?
            
            if(sku == "601" || sku == "607" || sku == "703") {
              totalLargeCandles += qty;
            } else if(sku == "626") {
            	totalMists += qty;
            }
            
          }); // each .row.line-item
          
          totalMeltWarmers = getSkucodeQty("INTERNALDEMOMELTWARMER2020") + getSkucodeQty('63052');
          console.log("totalMeltWarmers = " + totalMeltWarmers + "; totalSeasonalMelts = " + totalSeasonalMelts);
          
          for(var k in skuToDiscount) {
          	var allQty = skuToDiscount[k][2];
            var minRequired = skuToDiscount[k][0];
            var discountPerProduct = skuToDiscount[k][1];
            if(allQty >= minRequired) {
              	var totalDiscountPerSku = allQty * discountPerProduct;
            	totalDiscountAmt += totalDiscountPerSku;
              	skuTotalDiscounts[k] = totalDiscountPerSku;
              
              if(isSkucodeFlameless(k)) {
                totalFlamelessMupDiscount += skuTotalDiscounts[k];
                console.log("Flameless mup discount for " + k + ": " + skuTotalDiscounts[k]);
              }
              
              if(isSkucodeLastChance(k)) {
              	totalLastChanceMupDiscount  += skuTotalDiscounts[k];
                console.log("Last Chance mup discount for " + k + ": " + skuTotalDiscounts[k]);
            }
              
              if(skuToDiscountSeasonal[k][2] > 0) {
              	totalSeasonalMupDiscount += skuToDiscountSeasonal[k][2] * discountPerProduct;
              } // has seasonal of this sku?
            } // qty more than minrequired
          } // loop through skuToDiscount
          
          console.log("totalSeasonalAmount = " + totalSeasonalAmount + "; totalSeasonalMupDiscount = " + totalSeasonalMupDiscount);
        	totalSeasonalAmountWithMupDiscount = totalSeasonalAmount - totalSeasonalMupDiscount;
          
          console.log("totalSevenSeriesAmount = " + totalSevenSeriesAmount);
          console.log("totalSevenSeriesMupDiscount = " + totalDiscountAmt);
          totalSevenSeriesAmountWithMupDiscount = totalSevenSeriesAmount - totalDiscountAmt;
          console.log("totalSevenSeriesAmountWithMupDiscount = " + totalSevenSeriesAmountWithMupDiscount);
          
          console.log('totalLargeCandles = ' + totalLargeCandles + "; totalMists = " + totalMists);
          // end enableOriginalDiscountApp code
        } else {
        
          jQuery(".so-cart-discount-notes").each(function(i, elem) {
              var h = jQuery(elem).html();
              var m = h.match(/for \$([0-9\.]+) ea/);

            if(m = h.match(/([0-9])\/\$([0-9\.]+)/)) {
              var mupQty = parseFloat(m[1]);
              var mupPrice = parseFloat(m[2]);
              var mupPricePer = (mupPrice / mupQty).toFixed(2);
              console.log('mupPricePer ' + '=' + mupPricePer);
              m = ['', mupPricePer];
            }

            var productHref = jQuery(elem).closest(".row.line-item").find(".product-title a:first").attr("href");

            // get product type aka first 3 digits
            var urlMatches = productHref.match(/\/products\/([0-9]{3})/i);
            if(urlMatches) {
              console.log(urlMatches + "; " + urlMatches.length);
            }
            
            var sku = jQuery(elem).closest(".row.line-item").attr("data-sku");
            var skucode = jQuery(elem).closest(".row.line-item").attr("data-skucode");
            
           // Seasonal Candle?  Overwrite 607 with 601
            if(skucode.match(/60756|60757|60758|60791|60792|60793|60794/i)) {
            	sku = "601";
            }
            
            // new diffuser skucode?
            if(skucode.match(/645([0-9]{2,})/i)) {
              console.log("Detected new diffuser code.")
            	sku = "643";
            }

            var qty = parseInt(jQuery(elem).closest(".line-item.row").find("input.quantity").val());
            if(urlMatches && urlMatches.length > 1 && skuToMup[sku]) {
              if(!skuQuantities[sku]) {
                  skuQuantities[sku] = 0;	
              }
              skuQuantities[sku] += qty;
              console.log(sku + " curr total " + skuQuantities[sku]);

              var minQtyRequired = parseInt(skuToMup[sku].substr(0, 1));
              if(skuQuantities[sku] >= minQtyRequired) {
                  hasMupDiscount = true;
              }

            } // product has an mup discount

            // no discount code found but display it anyway
            if(!m || m.length < 2) {
				
              /*
              for(var k in skuToMup) {
                  if(productHref.indexOf("products/" + k) > -1) {
                      jQuery(elem).append('<span>' + skuToMup[k] + '</span>').addClass("custom-label");

                    break;
                  } 
              } // loop skuToMup
              */
              
              if(skuToMup[sku]) {
            	jQuery(elem).append('<span>' + skuToMup[sku] + '</span>').addClass("custom-label");
              }

              return; // -- no need for this anymore 20181023
            } // return no matter what -- no need for this anymore 20181023

            // this product has no discount stuff to it
            if(!m) {
              return;
            }

            //jQuery(elem).closest(".row.line-item").find(".line-price-calc").hide(); // hide all in cart


            var totalOrigAmt = parseFloat(jQuery(elem).closest(".line-item.row").find(".price.line-price").text().replace("$", ""));
            var origAmt = parseFloat(jQuery(elem).closest(".line-item.row").find(".price.item-price").text().replace("$", ""));
              var itemAmt = parseFloat(m[1]);
            var itemAmtFixed = itemAmt.toFixed(2);
            var discountAmt = origAmt - itemAmt;

            var totalItemAmtFixed = (qty * itemAmt).toFixed(2);
            var totalDiscount = totalOrigAmt - totalItemAmtFixed;
              console.log(i + " = " + discountAmt + " ; " +  itemAmtFixed + " ; " + totalItemAmtFixed + " ; " + totalDiscount);
            totalDiscountAmt += totalDiscount;


            if(urlMatches && urlMatches.length > 1 && skuToProductType[sku]) {
              if(!skuTotalDiscounts[sku]) {
                  skuTotalDiscounts[sku] = 0;
              }
              skuTotalDiscounts[sku] += totalDiscount;
              console.log(skuToProductType[sku] + "; curr total = " + skuTotalDiscounts[sku]);
            } // get product name from 3 digits and add to its MUP total discount

          }); // loop through each discount note
          
        } // enableOriginalDiscountApp?
        
        detectSubtotalChange();
        
        if(enableMom2019Promo) {
          if(totalLargeCandles < 3 && hasSkuCodeInCart('MOM2019')) {
            // console.log('mom2019 del btn = ' + jQuery("#cart-item-22337607925842").find("a[href^='/cart/change']").get(0));
            
            refreshingCartPage(null, jQuery("#cart-item-22337607925842").find("a[href^='/cart/change']").attr("href"));
          } // does not qualify?  Remove item from cart
          else if(totalLargeCandles >= 3 && hasSkuCodeInCart('MOM2019')) {
            jQuery("header.page-header").after('<div id="cart-promo-header-alert">Congratulations! You have qualified for a FREE Motherâ€™s Day Black Carryall Tote!</div>');
          }
        } // enableMom2019Promo?
        
        if(enableFreeMistPromo && totalLargeCandles) {
        	processFreeMistPromo();
        } // enableFreeMistPromo?
        
        var extraDiscount = 0.00;
        
        if(enableWarmerMeltsPromo) {
        	extraDiscount = processWarmerMeltsPromo();
          	totalDiscountAmt += extraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        }
        
        if(enableMday2021Promo && hasSkuCodeInCart('63052') && skuToDiscount['613'][2] >= 3) {
        	console.log("valid for MDAY2021PROMO");
          	enablePercentOffPromoDiscount = true;
			percentOffPromoDiscount = 0.20;
          percentOffPromoDiscountText = " Mother's Day Flash Sale";
       	} // enableMday2021Promo

        /*
        if($(".cart-item__name[href*='no-80']").length > 0 || $(".cart-item__name[href*='no-81']").length > 0) {
        	console.log("valid for No. 80 and No. 81 Products");
          	enablePercentOffPromoDiscount = true;
			percentOffPromoDiscount = 0.20;
          percentOffPromoDiscountText = " with purchase of No. 80 or No. 81 products";
       	} //  No 80 and No 81 Products // get a discount when you purchase a new fragrance newfragrance product
        */
        
        if(meltWarmerPercentOffPromoEnabled && totalMeltWarmers > 0) {
        	console.log("valid for meltWarmerPercentOffPromoEnabled");
          	enablePercentOffPromoDiscount = true;
			percentOffPromoDiscount = 0.30;
          	percentOffPromoDiscountText = " With Melt Warmer Purchase";
       	}
        
        if(sevenSeriesPercentOffPromoEnabled) {
          
          sevenSeriesPercentOffPromoDiscountAmount = sevenSeriesPercentOffPromoPercent * totalSevenSeriesAmountWithMupDiscount;
          console.log("sevenSeriesPercentOffPromoEnabled = " + sevenSeriesPercentOffPromoDiscountAmount);
        	extraDiscount = sevenSeriesPercentOffPromoDiscountAmount;
          	totalDiscountAmt += extraDiscount;
        }
        
        if(meltWarmerFreeMeltPromoEnabled && totalMeltWarmers > 0) {
        	console.log("valid for meltWarmerFreeMeltPromoEnabled");
          meltWarmerFreeMeltPromoDiscount = processMeltWarmerFreeMeltPromo();
          
          	
          extraDiscount = meltWarmerFreeMeltPromoDiscount;
          	totalDiscountAmt += extraDiscount;
       	} // is meltWarmerFreeMeltPromoEnabled
        
        console.log("totalSeasonalMelts = " + totalSeasonalMelts);
        if(meltWarmerSeasonalMeltsPromoEnabled && totalMeltWarmers && totalSeasonalMelts) {
          if(!totalMelts) {
          	totalMelts = skuToDiscount['713'][2];
          }
          if(totalMelts < 3) {
          	meltWarmerSeasonalMeltsPromoDiscountAmount = 4.50;
          } else {
            if(totalSeasonalMelts >= 8) {
            	meltWarmerSeasonalMeltsPromoDiscountAmount = 4.16 * 8;
            } else {
            	meltWarmerSeasonalMeltsPromoDiscountAmount = 4.16 * totalSeasonalMelts;
            }
          }
          
          console.log("meltWarmerSeasonalMeltsPromoEnabled = " + meltWarmerSeasonalMeltsPromoDiscountAmount);
          
           extraDiscount = meltWarmerSeasonalMeltsPromoDiscountAmount;
          	totalDiscountAmt += extraDiscount;
        	totalMelts = 0; // reset for now
        } // meltWarmerSeasonalMeltsPromoEnabled

        totalMelts = skuToDiscount['713'][2];
        console.log("totalMelts = " + totalMelts);
        
        if(seasonals40OffIsEnabled) {
        	
          console.log("seasonals40OffIsEnabled");
        
        } else if(seasonals50OffIsEnabled) {
          
          console.log("seasonals50OffIsEnabled");
          
        } else if(b4g1SeasonalIsEnabled) {
          
          jQuery(".cart .row.line-item").each(function(i, elem) {
              var productHref = jQuery(elem).find(".product-title a:first").attr("href");
              var qty = parseInt(jQuery(elem).find("input.quantity__input").val());
                  // get product sku aka first 5 digits
                var skuMatch = productHref.match(/\/products\/([0-9]{5})-/i);
              if(skuMatch) {
                  console.log("skuMatch = " + skuMatch + "; " + skuMatch.length);
              }
            
            var dataSkucode = jQuery(elem).attr("data-skucode");

                if((dataSkucode.match(/(607|681)(56|57|58|91|92|93|94|95|96)/)) || (skuMatch && skuMatch.length > 1 && skuMatch[1].match(/(607|681)(56|57|58|91|92|93|94|95|96)/))) {
                  totalSeasonalCandles += qty;
                }
                if(skuMatch && skuMatch.length > 1 && skuMatch[1].match(/(61356|61357|61358|61391|61392|61393|61394)/)) {
                 // totalSeasonalMelts += qty; // commented here because it is already done above
                }
            }); // loop through items to find seasonal items
          
          console.log("totalSeasonalCandles = " + totalSeasonalCandles);
          
          // code to work with warmer melts promo
          if(totalFreeWarmerMelts) {
            totalSeasonalMelts -= totalFreeWarmerMelts;
          	console.log('totalSeasonalMelts - totalFreeWarmerMelts = ' + totalSeasonalMelts);
          }
          
          if((totalSeasonalCandles >= 4 || totalSeasonalMelts >= 4) && (true || hasSkuCodeInCart('FALL19PROMO') || hasSkuCodeInCart('FALLTRAPPPROMO') || hasSkuCodeInCart('SEASONAL19PROMO'))) {

            if(totalSeasonalCandles % 5 == 4) {
              promptB4g1Seasonals += '<p class="cart-promo-prompt-box">You are eligible to receive a Free Seasonal Candle!  <a href="/collections/seasonal-collection">Add 1 more Seasonal Candle</a> to your cart to get it for free!</p>';
              jQuery("head").append('<style type="text/css">.cart__checkout-button.button { display:none; }</style>');
            }
            if(totalSeasonalMelts % 5 == 4) {
              promptB4g1Seasonals += '<p class="cart-promo-prompt-box">You are eligible to receive a Free Seasonal Wax Melt!  <a href="/collections/seasonal-collection-wax-melts">Add 1 more Seasonal Wax Melt</a> to your cart to get it for free!</p>';
            }

            if(promptB4g1Seasonals && true /* window.location.search.indexOf("testpromoprompt=1") > -1 */) {
              jQuery(".page-header h1:first").after(promptB4g1Seasonals);
            }
            
          } // promo code has been added and cart items qualify
          else if((totalSeasonalCandles >= 4 || totalSeasonalMelts >= 4) && (true || customRefPromoCode && customRefPromoCode.match(/(fall19|falltrapp|seasonal19)/i))) {
          	//processB4g1SeasonalFragrancesPromoCode(customRefPromoCode);
          } // no promo code yet but cart items qualify
          else if((totalSeasonalCandles < 4 || totalSeasonalMelts < 4) && (true || hasSkuCodeInCart('FALL19PROMO') || hasSkuCodeInCart('FALLTRAPPPROMO') || hasSkuCodeInCart('SEASONAL19PROMO'))) {
          	/*
            if(hasSkuCodeInCart('FALL19PROMO')) {
            	refreshingCartPage(null, jQuery("#cart-item-30118480052306").find("a[href^='/cart/change']").attr("href"))
            } else if(hasSkuCodeInCart('FALLTRAPPPROMO')) {
            	refreshingCartPage(null, jQuery("#cart-item-30118485393490").find("a[href^='/cart/change']").attr("href"))
            } else if(hasSkuCodeInCart('SEASONAL19PROMO')) {
            	refreshingCartPage(null, jQuery("#cart-item-30167453990994").find("a[href^='/cart/change']").attr("href"))
            }
            */
          } // no promo code yet but cart items qualify
        } // b4g1SeasonalIsEnabled
        else if(b4g1CandlesMeltsPromoEnabled) {
          
          if( (totalMelts >= 4 || totalLargeCandles >= 4) ) {

            if(totalLargeCandles % 5 == 4) {
              promptB4g1Seasonals += '<p class="cart-promo-prompt-box">You are eligible to receive a Free Seasonal Candle!  <a href="/collections/seasonal-collection">Add 1 more Seasonal Candle</a> to your cart to get it for free!</p>';
              jQuery("head").append('<style type="text/css">.cart__checkout-button.button { display:none; }</style>');
            }
            if(totalMelts % 5 == 4) {
              promptB4g1Seasonals += '<p class="cart-promo-prompt-box">You are eligible to receive a Free Seasonal Wax Melt!  <a href="/collections/seasonal-collection-wax-melts">Add 1 more Seasonal Wax Melt</a> to your cart to get it for free!</p>';
            }

            if(promptB4g1Seasonals && true /* window.location.search.indexOf("testpromoprompt=1") > -1 */) {
              jQuery(".page-header h1:first").after(promptB4g1Seasonals);
            }
            
          }
        
        } // b4g1CandlesMeltsPromoEnabled
        
        subtotal = cartGetCurrSubtotal();
          subtotalWithDiscounts = subtotal - totalDiscountAmt;
        
        console.log("hasVineoh18PromoItem = " + hasVineoh18PromoItem);
        
        if(hasVineoh18PromoItem) {
        	extraDiscount = subtotalWithDiscounts * .25;
          	totalDiscountAmt += extraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        } // vineoh18
        else if(seasonals50OffIsEnabled) {
          console.log("skuToDiscountSeasonal = " + skuToDiscountSeasonal['601'][2] + ' ; ' + skuToDiscountSeasonal['613'][2] + ' ; ' + skuToDiscountSeasonal['619'][2]);
          console.log("total seasonal price = " + ((skuToDiscountSeasonal['601'][2] * 30.00) + (skuToDiscountSeasonal['613'][2] * 8.00) + (skuToDiscountSeasonal['619'][2] * 49.00)));
          seasonals40OffDiscount = ((skuToDiscountSeasonal['601'][2] * 30.00) + (skuToDiscountSeasonal['613'][2] * 8.00) + (skuToDiscountSeasonal['619'][2] * 49.00)) * .50;
          
          //	seasonals40OffDiscount = totalSeasonalAmountWithMupDiscount * 0.50;
        	extraDiscount = seasonals40OffDiscount;
          	totalDiscountAmt += extraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        } else if(seasonals40OffIsEnabled) {
          	seasonals40OffDiscount = totalSeasonalAmountWithMupDiscount * 0.40;
        	extraDiscount = seasonals40OffDiscount;
          	totalDiscountAmt += extraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        } else if(seasonalsPercentOffIsEnabled) {
          console.log("seasonalsPercentOffIsEnabled");
          	seasonalsPercentOffDiscount = totalSeasonalAmountWithMupDiscount * seasonalsPercentOffPercent;
          console.log("seasonalsPercentOffDiscount = " + seasonalsPercentOffDiscount);
        	extraDiscount = seasonalsPercentOffDiscount;
          	totalDiscountAmt += seasonalsPercentOffDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        } else if(b4g1SeasonalIsEnabled && (totalSeasonalCandles >= 5 || totalSeasonalMelts >= 5) && (true || hasSkuCodeInCart('FALL19PROMO') || hasSkuCodeInCart('FALLTRAPPPROMO') || hasSkuCodeInCart('SEASONAL19PROMO'))) {
        	totalSeasonalCandlesDiscount = Math.floor(totalSeasonalCandles / 5) * 28.50;
          	totalSeasonalMeltsDiscount = Math.floor(totalSeasonalMelts / 5) * 8.33;
          //totalSeasonalMeltsDiscount = 0; // deactivated melts for now 20190917
          	extraDiscount = totalSeasonalCandlesDiscount + totalSeasonalMeltsDiscount;
          	totalDiscountAmt += extraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        } // b4g1SeasonalIsEnabled
        else if( b4g1CandlesMeltsPromoEnabled && (totalLargeCandles >= 5 || totalMelts >= 5) ) {
        	b4g1CandlesMeltsPromoCandlesDiscountAmount = Math.floor(totalLargeCandles / 5) * 32.00;
          	b4g1CandlesMeltsPromoMeltsDiscountAmount = Math.floor(totalMelts / 5) * 9.50;
            extraDiscount = b4g1CandlesMeltsPromoCandlesDiscountAmount + b4g1CandlesMeltsPromoMeltsDiscountAmount;
          	totalDiscountAmt += extraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        } // b4g1CandlesMeltsPromoEnabled
        
        
        
        if(hasSkuCodeInCart('3WICKMERRYPROMO')) {
        	window.location = jQuery(".line-item.row[data-skucode='" + '3WICKMERRYPROMO' + "'] a:last").attr("href");
              refreshingCartPage();
        } 
        /*
        if(hasSkuCodeInCart('3WICKJOLLYPROMO')) {
        	window.location = jQuery(".line-item.row[data-skucode='" + '3WICKJOLLYPROMO' + "'] a:last").attr("href");
              refreshingCartPage();
        } else if(hasSkuCodeInCart('3WICKMERRYPROMO') && total3WickCandles < 2) {
        	window.location = jQuery(".line-item.row[data-skucode='" + '3WICKMERRYPROMO' + "'] a:last").attr("href");
              refreshingCartPage();
        } else if(hasSkuCodeInCart('3WICKMERRYPROMO') && total3WickCandles >= 2) {
          total3WickCandlesDiscount = calc3WickMerryPromo();
          extraDiscount = total3WickCandlesDiscount;
          
          	totalDiscountAmt += extraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        } else if(!hasSkuCodeInCart('3WICKMERRYPROMO') && total3WickCandles >= 2) {
          process3WickMerryPromo('3wickmerry');
        }
        */
        /*
        if(hasSkuCodeInCart('3WICKJOLLYPROMO') && total3WickCandles < 3) {
        	window.location = jQuery(".line-item.row[data-skucode='" + '3WICKJOLLYPROMO' + "'] a:last").attr("href");
              refreshingCartPage();
        }
        
        if(hasSkuCodeInCart('3WICKJOLLYPROMO') && total3WickCandles >= 3) {
          total3WickCandlesDiscount = calc3WickJollyPromo();
          extraDiscount = total3WickCandlesDiscount;
          
          	totalDiscountAmt += extraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        }
        else if(hasSkuCodeInCart('3WICKMERRYPROMO') && total3WickCandles >= 2) {
          total3WickCandlesDiscount = calc3WickMerryPromo();
          extraDiscount = total3WickCandlesDiscount;
          
          	totalDiscountAmt += extraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        }
        */

        
        
        if(enablePercentOffFragrancePromo /* && subtotalWithDiscounts >= 50 */) {
          console.log("enablePercentOffFragrancePromo active with subtotalWithDiscounts = " + subtotalWithDiscounts);
        	extraDiscount = calcPercentOffFragrancePromo();
          console.log("extraDiscount = " + extraDiscount);
          	totalDiscountAmt += extraDiscount;
          console.log("totalDiscountAmt = " + totalDiscountAmt);
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
         // subtotalWithDiscounts = subtotal; // reactivated for bf 2024 // deactivated this on 20241119 to correct total with discounts on cart page // override previous line for this special non-stackable promo 20241003
          console.log("subtotalWithDiscounts = " + subtotalWithDiscounts);
        } // enablePercentOffFragrancePromo

        if(enablePercentOffProductPromo) {
          console.log("enablePercentOffProductPromo active with subtotalWithDiscounts = " + subtotalWithDiscounts);
          console.log("calcPercentOffProductPromo = " + calcPercentOffProductPromo());
        	extraDiscount += calcPercentOffProductPromo();
          	totalDiscountAmt += calcPercentOffProductPromo();
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
           subtotalWithDiscounts = subtotal; // reactivated for bf 2024  // deactivated this on 20241119 to correct total with discounts on cart page // override previous line for this special non-stackable promo 20240828
          console.log("totalDiscountAmt = " + totalDiscountAmt);
        } // enablePercentOffProductPromo

        if(enablePackagePromo) {
          console.log("enablePercentOffFragrancePromo active with subtotalWithDiscounts = " + subtotalWithDiscounts);
          extraDiscount += calcPackagePromo();
          totalDiscountAmt += calcPackagePromo();
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
           subtotalWithDiscounts = subtotal;
          console.log("totalDiscountAmt = " + totalDiscountAmt);
        } // enablePackagePromo

        if(totalAccessoriesProducts > 0) {
          // enableFlameless25Off = true; // turned off 20220817
        }
        
        if(enableFlameless25Off) {
          console.log("enableFlameless25Off = TRUE");
          console.log("Flameless mup discount total: " + totalFlamelessMupDiscount + "; from total: " + totalFlamelessAmount);
          totalFlamelessAmountWithMupDiscount = parseFloat(totalFlamelessAmount) - parseFloat(totalFlamelessMupDiscount);
          
          var totalFlamelessAppliancesAmount = getSkucodeTotalPrice('63052') + getSkucodeTotalPrice('73052') 
            + getSkucodeTotalPrice('73053') + getSkucodeTotalPrice('73054') + getSkucodeTotalPrice('73055') + getSkucodeTotalPrice('73056');
          console.log("totalFlamelessAppliancesAmount = " + totalFlamelessAppliancesAmount);
          flameless25OffDiscountAmount = (totalFlamelessAmountWithMupDiscount + totalFlamelessAppliancesAmount) * 0.25;
          extraDiscount = flameless25OffDiscountAmount;
          totalDiscountAmt += extraDiscount;
          subtotalWithDiscounts = subtotal - totalDiscountAmt;
        } // enableFlameless25Off
        
        
        if(hasSkuCodeInCart('PROMOFFC25OFF') || hasSkuCodeInCart('PROMOFFCFREESHIP')) {
          if(!hasSkuCodeInCart('60776') && !hasSkuCodeInCart('60176') && !hasSkuCodeInCart('60777') && !hasSkuCodeInCart('60177')) {
            if(hasSkuCodeInCart('PROMOFFC25OFF')) {
              refreshingCartPage(null, jQuery("#cart-item-39302268682322").find("a[href^='/cart/change']").attr("href"));
            } else if(hasSkuCodeInCart('PROMOFFCFREESHIP')) {
              // ffcfreeship
              refreshingCartPage(null, jQuery("#cart-item-39302269042770").find("a[href^='/cart/change']").attr("href"));
            }
          } // if not qualified, remove promo product
          else {
          	// qualified
            
            if(hasSkuCodeInCart('PROMOFFC25OFF')) {
              enablePercentOffPromoDiscount = true;
              percentOffPromoDiscount = 0.25;
            } else if(hasSkuCodeInCart('PROMOFFCFREESHIP')) {
            }
          } // qualification check
        } // PROMOFFC25OFF stuff
        
        if(enableFree72And73Votive && freeVotivesAvailable) {
          
          console.log("hasFree72And73Votive = " + hasFree72And73Votive);

          if(true) {
          
          if( false // 20200211 - votives not added anymore
             	// hasFree72And73Votive
            ) {
            
            	console.log('SHOULD NOT RUN 20200211');
            	
            /*
              if(skuToDiscount['611'][2] >= skuToDiscount['611'][0]) {
                free72And73VotiveDiscountAmt = 4.50 * 2;
              } else {
                free72And73VotiveDiscountAmt = 4.50 * 2;
              }
              */
            
            	free72And73VotiveDiscountAmt = 4.50 * 2;

                extraDiscount = free72And73VotiveDiscountAmt;
                totalDiscountAmt += extraDiscount;
                subtotalWithDiscounts = subtotal - totalDiscountAmt;
              console.log("free72And73VotiveDiscountAmt = " + free72And73VotiveDiscountAmt + " ; subtotalWithDiscounts = " + subtotalWithDiscounts);

              if(subtotalWithDiscounts >= free72And73VotiveRequiredAmt) {
                // good!
                
                if(!hasSkuCodeInCart('PROMO74AND75VOT')) {

                  jQuery.post('/cart/add.js', {
                        quantity: 1,
                        id: 31871417942098
                  }, function(response) {
                      console.log(response);
                  });
                  refreshingCartPage();
                  
                } // no promo product yet?
                
              } else {
                // does not qualify, set reset
                
                if(hasSkuCodeInCart('PROMO74AND75VOT')) {
                  window.location = jQuery(".line-item.row[data-skucode='" + 'PROMO74AND75VOT' + "'] a:last").attr("href");
                  refreshingCartPage();
                }
                
                console.log("reset free72And73VotiveDiscountAmt");
                free72And73VotiveDiscountAmt = 0.00;
                totalDiscountAmt -= extraDiscount;
				extraDiscount = 0.00;
                subtotalWithDiscounts = subtotal - totalDiscountAmt;
              }
          } // hasFree72And73Votive
          else if( false // 20200211 - votives not added anymore
                  	/* jQuery(".line-item.row[data-skucode='61174']").length || jQuery(".line-item.row[data-skucode='61175']").length */
                 ) {
            console.log("has either 72 or 73 - BUT SHOULD NOT RUN 20200211");
            
          	if(skuToDiscount['611'][2] >= skuToDiscount['611'][0]) {
                free72And73VotiveDiscountAmt = 4.50;
              } else {
                free72And73VotiveDiscountAmt = 5.00;
              }

                extraDiscount = free72And73VotiveDiscountAmt;
                totalDiscountAmt += extraDiscount;
                subtotalWithDiscounts = subtotal - totalDiscountAmt;

              if(subtotalWithDiscounts >= free72And73VotiveRequiredAmt) {
                // good!
                if(jQuery(".line-item.row[data-skucode='61174']").length) {
                	jQuery.post('/cart/add.js', {
                      quantity: 1,
                      id: 31843091054674
                    }, function(response) {
                    	if(!hasSkuCodeInCart('PROMO74AND75VOT')) {
                          refreshingCartPage(null, '/cart/add?id=31871417942098&qty=1');
                        } else {
                          refreshingCartPage();
                        }
                    });
                } else {
                	jQuery.post('/cart/add.js', {
                      quantity: 1,
                      id: 31842125545554
                    }, function(response) {
                    	if(!hasSkuCodeInCart('PROMO74AND75VOT')) {
                          refreshingCartPage(null, '/cart/add?id=31871417942098&qty=1');
                        } else {
                          refreshingCartPage();
                        }
                    });
                }
              } else {
                // does not qualify, set reset
                free72And73VotiveDiscountAmt = 0.00;
				totalDiscountAmt -= extraDiscount;
                extraDiscount = 0.00;
                subtotalWithDiscounts = subtotal - totalDiscountAmt;
              }
          } // has either one of them
          else if(subtotalWithDiscounts >= free72And73VotiveRequiredAmt) {
            console.log("add 72 and 73, but don't do this anymore by 20200211");
            
            if(!hasSkuCodeInCart('PROMO76AND77VOT')) {
              refreshingCartPage(null, '/cart/add?id=39275446337618&qty=1');
            } else {
              //refreshingCartPage(null, null, true); // 20200211 - deactivated
            }
            
            /*
            // 20200211 - votives not added anymore
          	jQuery.post('/cart/add.js', {
                      quantity: 1,
                      id: 31842125545554
            }, function(response) {
            	jQuery.post('/cart/add.js', {
                      quantity: 1,
                      id: 31843091054674
                }, function(response) {
                	refreshingCartPageWait = false;
                });
            });
            */
            
            
          } // does not have promo items yet
          else {
            // does not meet requirements
            console.log("Does not meet free votives requirements.");
            if(hasSkuCodeInCart('PROMO76AND77VOT')) {
              // remove promo product
              window.location = jQuery(".line-item.row[data-skucode='" + 'PROMO76AND77VOT' + "'] a:last").attr("href");
              refreshingCartPage();
            }
          } // qualifies for promo?
          
          } // true or false
          
        } // enableFree72And73Votive
        
        if(enableSummer2019Promo && customRefPromoCode.match(/^SUMMER(S|19)?$/i)) {
          initSummer2019Promo();
        } // enableSummer2019Promo
        
        if(enableSummer2019Promo && customRefPromoCode.match(/^summer(S|19)?$/i) && skuToDiscount['601'][2] >= 4) {
          summer2019PromoExtraDiscount = getSkuMupPrice('601');
          extraDiscount += summer2019PromoExtraDiscount;
          	totalDiscountAmt += summer2019PromoExtraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
          
          if(!hasSkuCodeInCart('SUMMER') && !hasSkuCodeInCart('SUMMERS') && !hasSkuCodeInCart('SUMMER19')) {
            var summer2019VariantId = '';
            if(customRefPromoCode.toUpperCase() == ('SUMMER')) {
            	summer2019VariantId = '22556103770194';
            } else if(customRefPromoCode.toUpperCase() == ('SUMMERS')) {
            	summer2019VariantId = '22556106653778';
            } else if(customRefPromoCode.toUpperCase() == ('SUMMER19')) {
            	summer2019VariantId = '22556108259410';
            }
            console.log('summer2019VariantId = ' + summer2019VariantId);
          	jQuery.post('/cart/add.js', {
                      quantity: 1,
                      id: summer2019VariantId
            }, function(response) {
            	refreshingCartPage();
            });
          } // no summer product yet?
          else {
            // all is good to go!
          	jQuery("header.page-header").after('<div id="cart-promo-header-alert">Congratulations! You have qualified for a FREE 7 oz. Candle!</div>');
          }
        } // enableSummer2019Promo
        else if(hasSkuCodeInCart('SUMMER') || hasSkuCodeInCart('SUMMERS') || hasSkuCodeInCart('SUMMER19')) {
          var deleteSkuCodeHref = "";
          if(hasSkuCodeInCart('SUMMER')) {
            deleteSkuCodeHref = jQuery(".line-item.row[data-skucode='" + 'SUMMER' + "'] a:last").attr("href");
          } else if(hasSkuCodeInCart('SUMMERS')) {
            deleteSkuCodeHref = jQuery(".line-item.row[data-skucode='" + 'SUMMERS' + "'] a:last").attr("href");
          } else if(hasSkuCodeInCart('SUMMER19')) {
            deleteSkuCodeHref = jQuery(".line-item.row[data-skucode='" + 'SUMMER19' + "'] a:last").attr("href");
          }
          refreshingCartPage();
          window.location = deleteSkuCodeHref;
        }
        
        if(b4g1FallFragrancesIsEnabled) {
        	var totalFallFragrancesCandles = countFallFragrancesCandles();
          if(totalFallFragrancesCandles == 4 && (hasSkuCodeInCart('FALL19PROMO') || hasSkuCodeInCart('FALLTRAPPPROMO'))) {
            jQuery("header.page-header").after('<div id="cart-promo-header-alert" style="background:#f4f4f4;border:#ccc 5px solid;color:#999;">Congratulations! You qualified for a FREE Fall Fragrance 7 oz. Candle!<br>Choose the FREE Fall Fragrance 7 oz. Candle that you would like to add to your cart<br>'
                                               + '<a href="/cart/add/?id=12725077737554&qty=1" class="button">Fireside Pumpkin</a>'
                                               + '&nbsp;&nbsp;<a href="/cart/add/?id=12725025407058&qty=1" class="button">Hearth</a>'
                                               + '&nbsp;&nbsp;<a href="/cart/add/?id=12724986937426&qty=1" class="button">Orange Clove</a>'
                                               + '</div>');
            jQuery("head").append('<style type="text/css">.cart__checkout-button.button { display:none; }</style>');
          } else if(totalFallFragrancesCandles >= 5 && (hasSkuCodeInCart('FALL19PROMO') || hasSkuCodeInCart('FALLTRAPPPROMO'))) {
            b4g1FallFragrancesDiscountAmt = 26.5;
            extraDiscount += b4g1FallFragrancesDiscountAmt;
          	totalDiscountAmt += b4g1FallFragrancesDiscountAmt;
            
            jQuery("header.page-header").after('<div id="cart-promo-header-alert" style="background:#e7751d;color:#fff;">Congratulations! You have a FREE Fall Fragrance 7 oz. Candle in your cart!'
                                               + '</div>');
          } else if(totalFallFragrancesCandles < 4) {
            if(hasSkuCodeInCart('FALL19PROMO')) {
            	refreshingCartPage(null, jQuery("#cart-item-30118480052306").find("a[href^='/cart/change']").attr("href"))
            } else if(hasSkuCodeInCart('FALLTRAPPPROMO')) {
            	refreshingCartPage(null, jQuery("#cart-item-30118485393490").find("a[href^='/cart/change']").attr("href"))
            }
          }
        } // b4g1FallFragrancesIsEnabled
        
        
        if(hasSkuCodeInCart('MONDAY19PROMO')) {
          if((subtotal - totalDiscountAmt) >= 50) {
        	 // take an extra 10% off
          	tenPercentOffDiscountAmount = subtotalWithDiscounts * .10;
          	console.log('tenPercentOffDiscountAmount = ' + tenPercentOffDiscountAmount);
          	extraDiscount += tenPercentOffDiscountAmount;
          	totalDiscountAmt += tenPercentOffDiscountAmount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
          } else {
          	refreshingCartPage(null, jQuery("#cart-item-31276099469394").find("a[href^='/cart/change']").attr("href"));
          }
        } // has MONDAY19PROMO
        
        
        if(enableFreeMistPromo) {
        	extraDiscount += freeMistPromoDiscountAmount;
          	totalDiscountAmt += freeMistPromoDiscountAmount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        } // enableFreeMistPromo

        if(freeItemsPromoEnabled) {
          if(getSkucodeQty('73055')) {
            console.log("freeItemsPromoEnabled");
            extraDiscount += processFreeItemsPromoDiscount();
            totalDiscountAmt += freeItemsPromoDiscount;
            subtotalWithDiscounts = subtotal - totalDiscountAmt;
          }
        } // freeItemsPromoEnabled
        
        if(/*hasSkuCodeInCart('FFCVIBRANTPROMO') && */ ffcVibrantPromoEnabled) {
          if(total3WickCandles < 2 && jQuery("#cart-item-39640812683346").length) {
          	refreshingCartPage(null, jQuery("#cart-item-39640812683346").find("a[href^='/cart/change']").attr("href"));
          } else {
          	ffcVibrantPromoDiscountAmount = Math.floor(total3WickCandles / 2) * ffcVibrantPromoDiscountPerCandle;
            console.log("ffcVibrantPromoDiscountAmount = " + ffcVibrantPromoDiscountAmount);
            extraDiscount += ffcVibrantPromoDiscountAmount;
          	totalDiscountAmt += ffcVibrantPromoDiscountAmount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
          }
        } // FFCVIBRANTPROMO
        
        
        if(hasSkuCodeInCart('LUVMOMPROMO') || hasSkuCodeInCart('BESTMOMPROMO') || hasSkuCodeInCart('MOMS20PROMO') || hasSkuCodeInCart('MOMSDAYPROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.20;
          percentOffPromoDiscountText = " for Mother's Day";
          console.log('Has MOM\'S DAY day promo code for ' + percentOffPromoDiscount);
        } // has LUVMOMPROMO or other mom's day promo code

        if(hasSkuCodeInCart('BFWSALE25PROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.25;
          percentOffPromoDiscountText = " for Black Friday";
          console.log('Has BFWSALE25 day promo code for ' + percentOffPromoDiscount);
        } // has BFWSALE25PROMO
        else {
          // only activate during black friday 2023
         // jQuery("#vineoh-promo-txt").val("BFWSALE25");
         // jQuery("#vineoh-promo-btn").trigger('click');
        }

        if(hasSkuCodeInCart('HAPPYGIFTINGPROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.20;
          percentOffPromoDiscountText = " with HAPPYGIFTING";
          console.log('Has HAPPYGIFTING day promo code for ' + percentOffPromoDiscount);
        } // has HAPPYGIFTINGPROMO

        /*
        if((hasSkuCodeInCart('73059') || hasSkuCodeInCart('73060')) && true) { // activated on 20221031 // deactivated on 20221107 12am
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.20;
          percentOffPromoDiscountText = " with Rechargeable USB Lighter purchase";
          console.log('with Rechargeable USB Lighter purchase for ' + percentOffPromoDiscount);
        } // with Rechargeable USB Lighter purchase
        */
        
        if(hasSkuCodeInCart('DADSDAYPROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.20;
          percentOffPromoDiscountText = " for Father's Day";
          console.log('Has DAD\'S DAY day promo code for ' + percentOffPromoDiscount);
        } // has DADSDAYPROMO or other dad's day promo code
        
        
        // START THANKSFANCLUBPROMO
        /*
        enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.10;
          console.log('Has CYBERMONDAY2020 promo for ' + percentOffPromoDiscount);
        */
        if(hasSkuCodeInCart('BLACKFRIDAY2020PROMO')) {
          refreshingCartPage(null, jQuery("#cart-item-33140998307922").find("a[href^='/cart/change']").attr("href"));
        } // has GOODLUCK13PROMO skucode
        
       // processBlackFridayWeekendPromo();
        /*
        if(customRefPromoCode == 'THANKSFANCLUB' && totalSeasonalCandles >= 5) {
        	jQuery("#vineoh-promo-txt").val(customRefPromoCode);
        }
        if(hasSkuCodeInCart('THANKSFANCLUBPROMO')) {
          if(totalSeasonalCandles < 5) {
          	refreshingCartPage(null, jQuery("#cart-item-33136143269970").find("a[href^='/cart/change']").attr("href"))
          } // no b4g1 seasonal promo? remove
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.10;
          console.log('Has THANKSFANCLUB promo code for ' + percentOffPromoDiscount);
        } // has GOODLUCK13PROMO skucode
        */
        // END THANKSFANCLUB PROMO
        
        
        if(hasSkuCodeInCart('LASTCHANCE20PROMO')) {
          if(totalLastChanceAmount > 0.00) {
          	console.log('Has LASTCHANCE20PROMO');
          	lastChance20DiscountAmount = (totalLastChanceAmount - totalLastChanceMupDiscount) * .20;
          	extraDiscount += lastChance20DiscountAmount;
          	totalDiscountAmt += lastChance20DiscountAmount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
          } else {
          	jQuery(".cart-item[data-skucode='LASTCHANCE20PROMO'] cart-remove-button a").click();
            refreshingCartPage(null, jQuery(".cart-item[data-skucode='LASTCHANCE20PROMO'] cart-remove-button a").attr("href"))
          } // with last chance amount or not?
          
        } // has LASTCHANCE20PROMO skucode
        else if(totalLastChanceAmount > 0.00 && !hasSkuCodeInCart('LASTCHANCE20PROMO')) {
          processLastChance20Promo('LASTCHANCE20');
        }
        
        if(hasSkuCodeInCart('FANCLUB10PROMO') || hasSkuCodeInCart('FANCLUB15PROMO')) {
          enablePercentOffPromoDiscount = true;
          if(hasSkuCodeInCart('FANCLUB10PROMO')) {
          	percentOffPromoDiscount = 0.10;
          } else if(hasSkuCodeInCart('FANCLUB15PROMO')) {
          	percentOffPromoDiscount = 0.15;
          }
          console.log('Has memorial FFC promo code for ' + percentOffPromoDiscount);
        } // has FANCLUB10PROMO or FANCLUB15PROMO skucode
        
        if(hasSkuCodeInCart('CANDLELOVE15PROMO') || hasSkuCodeInCart('MYPROFILE15PROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.15;
          console.log('Has candlelove15 or myprofile15 promo code for ' + percentOffPromoDiscount);
        } // has CANDLELOVE15PROMO skucode

        if(hasSkuCodeInCart('MOBILE15PROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.15;
          console.log('Has MOBILE15PROMO promo code for ' + percentOffPromoDiscount);
          percentOffPromoDiscountText = " MOBILE15";
        } // has MOBILE15PROMO skucode

        if(hasSkuCodeInCart('SAVE10ATTPROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.10;
          console.log('Has SAVE10ATTPROMO promo code for ' + percentOffPromoDiscount);
          percentOffPromoDiscountText = " SAVE10";
        } // has SAVE10ATTPROMO skucode
        
        
        if(hasSkuCodeInCart('RE35SARAPROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.35;
          console.log('Has re35sara promo code for ' + percentOffPromoDiscount);
          percentOffPromoDiscountText = "";
        } // has RE35SARAPROMO skucode
        
        if(hasSkuCodeInCart('RE25CHRISTYCPROMO') || hasSkuCodeInCart('RE25ERINBPROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.25;
          console.log('Has RE25CHRISTYC or RE25ERINBPROMO promo code for ' + percentOffPromoDiscount);
          percentOffPromoDiscountText = "";
        } // has RE25CHRISTYCPROMO skucode

        if(hasSkuCodeInCart('HOME25PROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.25;
          console.log('Has HOME25PROMO promo code for ' + percentOffPromoDiscount);
          percentOffPromoDiscountText = "";
        } // has HOME25PROMO skucode

        if(hasSkuCodeInCart('REECENICHOLS10PROMO')) {
          enablePercentOffPromoDiscount = true;
          percentOffPromoDiscount = 0.10;
          console.log('Has REECENICHOLS10PROMO promo code for ' + percentOffPromoDiscount);
          percentOffPromoDiscountText = " (REECENICHOLS10)";
        } // has REECENICHOLS10 skucode
        
        
        if(enableMeltWarmerFfcDiscountPromo && totalMeltWarmers > 0) {
       	
          if(enableMeltWarmerFfcDiscountPromo || hasSkuCodeInCart('WARMFFCGET20PROMO') || hasSkuCodeInCart('WARMFFC25FORUPROMO')) {
            enablePercentOffPromoDiscount = true;
			
            /*
            if(hasSkuCodeInCart('WARMFFCGET20PROMO')) {
              percentOffPromoDiscount = 0.20;
            } else if(hasSkuCodeInCart('WARMFFC25FORUPROMO')) {
              percentOffPromoDiscount = 0.25;
            }
            
            
            console.log('Has WARMFFCGET20PROMO or WARMFFC25FORUPROMO promo code for ' + percentOffPromoDiscount);
            */
            percentOffPromoDiscountText = " with Melt Warmer Purchase";
            percentOffPromoDiscount = 0.20;
            console.log('Has enableMeltWarmerFfcDiscountPromo for ' + percentOffPromoDiscount);
            
          } // has WARMFFCGET20PROMO or WARMFFC25FORUPROMO skucode
        
        } // enableMeltWarmerFfcDiscountPromo
        
        
        if(hasSkuCodeInCart('TRAPPFAMILYPROMOXXX')) {
            enablePercentOffPromoDiscount = true;
            percentOffPromoDiscountText = " with Friends and Family";
            percentOffPromoDiscount = 0.25;
            console.log(extraDiscount);

            if(cartGetOrderUltimateSubtotal() > 300) {
              refreshingCartPage(null, jQuery(".cart-item[data-skucode='TRAPPFAMILYPROMO'] cart-remove-button a").attr("href"));
            }
          /*
          jQuery(".title-wrapper-with-link:first").after('<div class="cart-promo-prompt-box cart-promo-prompt-box">' 
                                                      + '<h3>Employees and friends and family only</h3>' + 
                                                '<p>Cannot be resold<br>Closely monitored<br>Maximum order value of $300</p>'
                                                + '<p><input type="checkbox" id="fnfagree"> I agree to the terms and conditions of this promo</p>'
                                                      + '</div>');*/
        } // has TRAPPFAMILYPROMO skucode
        
        console.log("totalGiftCardAmount = " + totalGiftCardAmount);
        console.log("sub = " + subtotal + "; subwd = " + subtotalWithDiscounts);
        
        if(enablePercentOffPromoDiscount) {
          
          console.log("enablePercentOffPromoDiscount = TRUE");
          console.log("sub = " + subtotal + "; subwd = " + subtotalWithDiscounts);
          
          if(/* true || */ (location && location.search && location.search.indexOf("bf2022=1") > -1)) {
            // turned on 20221121 // turned off 20221128
            // start black friday 2022
            if(subtotalWithDiscounts >= 300) {
            	percentOffPromoDiscount = 0.30;
              percentOffPromoDiscountText = " with $300 spend";
            } else if(subtotalWithDiscounts >= 200) {
            	percentOffPromoDiscount = 0.25;
              percentOffPromoDiscountText = " with $200 spend";
            } else if(subtotalWithDiscounts >= 100) {
              percentOffPromoDiscountText = " with $100 spend";
            	percentOffPromoDiscount = 0.20;
            } else {
          		percentOffPromoDiscount = 0.00;
         	}
            // end black friday 2022
            percentOffPromoDiscountAmount = (subtotalWithDiscounts - totalGiftCardAmount) * percentOffPromoDiscount;
          } // no TRAPPFAMILY promo code
          else {
          	// percentOffPromoDiscountAmount = (subtotal - totalGiftCardAmount) * percentOffPromoDiscount;
            percentOffPromoDiscountAmount = (subtotalWithDiscounts - totalGiftCardAmount - totalAccessoriesAmount - totalPercentOffProductPromoAmount - totalPercentOffFragrancePromoAmount) * percentOffPromoDiscount;
          }
          
        	console.log('percentOffPromoDiscount = ' + percentOffPromoDiscount);
          	console.log('percentOffPromoDiscountAmount = ' + percentOffPromoDiscountAmount);
          	extraDiscount += percentOffPromoDiscountAmount; // rollback percentOffFragrancePromoDiscount which is added to extraDiscount above
          	totalDiscountAmt += percentOffPromoDiscountAmount /* - percentOffFragrancePromoDiscount */; // same as above comment
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
        } // enablePercentOffPromoDiscount

        else {
          
        }
        
        if(hasSpecialThanksCoupon() && !hasSkuCodeInCart('TRAPPFAMILYPROMO')) {
        	specialThanksCouponExtraDiscount = subtotalWithDiscounts * specialThanksCouponDiscount;	
          	extraDiscount += specialThanksCouponExtraDiscount;
          	totalDiscountAmt += specialThanksCouponExtraDiscount;
          	subtotalWithDiscounts = subtotal - totalDiscountAmt;
          console.log(extraDiscount);
        } // hasSpecialThanksCoupon
        
        
        localStorage.setItem('totalDiscountAmt', totalDiscountAmt);
        console.log('tda = ' + totalDiscountAmt);
        
        if(totalDiscountAmt < .50 && hasMupDiscount) {
        	console.log("Invalid discount amt.");
        }
        
        jQuery("#calculating-discounts-wrapper").hide();
        jQuery(".cart__footer:first .totals:first").after('<div class="subtotal subtotal-discount-amount"><span>Promo Discount </span><span class="price">-$' + totalDiscountAmt.toFixed(2) + '</span></div>');
        
          jQuery(".subtotal-discount-amount:first").after('<div class="subtotal subtotal-with-discount"><span>Subtotal after Discounts </span><span class="price">$' + subtotalWithDiscounts.toFixed(2) + '</span></div>' +
                                                          '<style type="text/css">.subtotal *, .subtotal .price {display:block;text-align:right !important; font-weight:bold; font-size:2em;line-height:1.2em;}' + 
                                                          '#odapp-checkout-btn {min-width:100%; padding-left:10px;}'
                                                          +  '.subtotal-discount-amount {color:red;padding-top:10px;}'
                                                          +  '.subtotal-with-discount {color:green;}'
                                                          +'</style>');
        
        
        if(totalDiscountAmt < 0.01) {
        	jQuery(".subtotal-discount-amount, .subtotal-with-discount").hide();
        } else {
          // also display discount above cart items
          jQuery("#cart:first").before('<div id="pre-cart-discount-wrapper">You\'re getting a total discount of $' + totalDiscountAmt.toFixed(2) + ' on this order!<br><a href="#discount-line-item-wrapper">More details below on discounts applied</a>.</div>');
        }
        
        if(hasSkuCodeInCart('FRIDAY19PROMO') && subtotalWithDiscounts < 50) {
        	refreshingCartPage(null, jQuery("#cart-item-31290312949842").find("a[href^='/cart/change']").attr("href"))
        } // below 50?
        if(hasSkuCodeInCart('HOLIDAYPROMO') && subtotalWithDiscounts < 50) {
        	refreshingCartPage(null, jQuery("#cart-item-31276062408786").find("a[href^='/cart/change']").attr("href"))
        } // below 50?
        
        updateDiscountCodeAmount('ALD-' + cartToken.toUpperCase(), (subtotalWithDiscounts - totalGiftCardAmount).toFixed(2), totalDiscountAmt.toFixed(2));
        
        //console.log("cart --- " + cart);
        if(false /*!location.search || location.search.indexOf("testnewshippingcalc") < 0*/) {
        	jQuery("#shipping-calculator").hide(); // hide for now : TODO: FIX
        } else {
        	jQuery("#shipping-calculator .btn.get-rates").after('<input type="button" class="btn button" value="Calculate Shipping" id="get-rates-btn-new">');
          jQuery("#shipping-calculator .btn.get-rates").hide();
          jQuery("#get-rates-btn-new").click(function(ev) {
            var zip = jQuery("#address_zip").val();
            var province = jQuery("#address_province").val();
            var shipUrl = "/cart/shipping_rates.json?shipping_address%5Bzip%5D=" + zip + "&shipping_address%5Bcountry%5D=United%20States&shipping_address%5Bprovince%5D=" + province
            //console.log(shipUrl);
            console.log("getting shipping rates...");
            jQuery("#wrapper-response").html("Locating shipping rates...");
            var shippingMessage = "";
        	jQuery.get(shipUrl, function(response) {
              if(response && response.shipping_rates) {
                console.log("shipping rates total : " + response.shipping_rates.length);
                for(var i = 0; i < response.shipping_rates.length; i++) {
                  console.log(response.shipping_rates[i].name + " = " + response.shipping_rates[i].price);
                  
                  
                  if(/*hasSkuCodeInCart('61956') || hasSkuCodeInCart('61957') || hasSkuCodeInCart('61958') // 3wick
                    || */
                    hasSkuCodeInCart('THANKSFANCLUBPROMO')
                    ) {
                  	shippingMessage = "Free Shipping - $0.00";
                    break;
                  }
                  
                  
                  var thisPrice = parseFloat(response.shipping_rates[i].price);
                  if(false /* subtotalWithDiscounts < 99.00 && thisPrice < 1.00 && subtotalWithDiscounts >= 29.00 */) {
                  	shippingMessage = "Leap Day Promo Shipping - $" + thisPrice;
                  } else if(subtotalWithDiscounts < 99.00 && thisPrice < 1.00) {
                  	console.log("skipping " + thisPrice + " not qualified.");
                  } else if(subtotalWithDiscounts >= 99.00 && thisPrice < 1.00) {
                    shippingMessage = "Free Shipping - $" + thisPrice;
                  } else {
                  	shippingMessage = response.shipping_rates[i].name + " - $" + thisPrice;
                  }
                  if(shippingMessage) {
                  	break;
                  }
                } // loop through shipping rates
              } else {
              	shippingMessage = "Could not locate shipping rates for your area/order.";
              }
              jQuery("#wrapper-response").html('<div class="shipping-rates-result">' + shippingMessage + '</div>');
             }); // jquery.get
          }); // click event
        } // old or new shipping calc?
        
        if(subtotalWithDiscounts >= 99.00) {
        	//jQuery("#shipping-calculator").hide();
        } // hide/show shipping calc?
        else {
          	
        }
        
       	
        console.log(Object.keys(skuTotalDiscounts).length);
        for(var k in skuTotalDiscounts) {
        	console.log(k + " === " + skuTotalDiscounts[k]);
        }
        
        if(totalDiscountAmt > 0 && enableOriginalDiscountApp) {
          jQuery(".so-cart-discount-notes").remove();
          jQuery(".cart__checkout-button.button").css("display", "none");
        	jQuery(".cart__checkout-button.button").before('<input type="button" id="odapp-checkout-btn" class="button checkout" value="Checkout &raquo;">');
          	
          jQuery("#odapp-checkout-btn").click(function(ev) {
            ev.preventDefault();
            if(jQuery("#cart-note").length && jQuery("#cart-note").val().length > 2) {
              jQuery.post('/cart/update.js', { note : "Notes: " + jQuery("#cart-note").val()}, function () {
              	window.location.href = "/discount/ALD-" + cartToken + "?redirect=/checkout";
              });
            } // has cart-note?
            else {
            	window.location.href = "/discount/ALD-" + cartToken + "?redirect=/checkout";
            } // no cart-note?
          });
        }
        
        if(Object.keys(skuTotalDiscounts).length || extraDiscount) {
          jQuery(".row.checkout:last .columns .row:first .columns:first").prepend('<div id="discount-line-item-wrapper" class="row text-left-medium"><h2>Discounts Applied</h2></div>');
          // loop through skuTotalDiscounts and display itemized discounts table
          for(var k in skuTotalDiscounts) {
            var mupText = skuToMup[k].replace(/ or .+/i, "");
            mupText = mupText.replace(/\//i, " for ");
            jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-' + k + '">'
                                                         + skuToProductType[k] + ' "Buy ' + mupText + '" Discount Applied.  You saved <span class="discount-amount">$'
                                                         + skuTotalDiscounts[k].toFixed(2) + '</span>'
                                                         + '</div>');
          } // loop skuTotalDiscounts
          
          
          if(free72And73VotiveDiscountAmt || hasSkuCodeInCart('PROMO74AND75VOT')) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-free72and73votive">Free No. 74 and No. 75 Votive with a $25+ Purchase. <!-- You saved <span class="discount-amount">$'
                                                         + free72And73VotiveDiscountAmt.toFixed(2) + ' </span> -->'
                                                         + '</div>');
              jQuery("header.page-header").after('<div id="free72and73-header-alert">Congratulations!  Your order of $25+ gets you a FREE No. 74 and No. 75 Votive Candle!</div>');
            }
          
          if(extraDiscount) {
            
            
            if(totalWarmerMeltsPromoDiscount) {
              jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-warmermelts">3 Free Seasonal Fragrance Melts (max of 6) w/ Melt Warmer Purchase Discount Applied.  You saved <span class="discount-amount">$'
                                                         + totalWarmerMeltsPromoDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
            }
            
            if(sevenSeriesPercentOffPromoEnabled) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-seveseriespercentoff">20% Off All New Collection Items.  You saved <span class="discount-amount">$'
                                                         + sevenSeriesPercentOffPromoDiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
            }
            
            if(hasVineoh18PromoItem) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-vineoh18">VINEOH18 25% Off (you saved) <span class="discount-amount">$'
                                                         + extraDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
            } else if(seasonals40OffIsEnabled) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-seasonals40off">40% Off Seasonal Products <span class="discount-amount">$'
                                                         + seasonals40OffDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
            } else if(seasonalsPercentOffDiscount > 0.00 && seasonalsPercentOffIsEnabled) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-seasonals40off">25% Off Seasonal Products.  You saved <span class="discount-amount">$'
                                                         + seasonalsPercentOffDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
            } else if(seasonals50OffIsEnabled) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-seasonals40off">50% Off Seasonal Products.  You saved <span class="discount-amount">$'
                                                         + seasonals40OffDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
            } else if(summer2019PromoExtraDiscount) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-summer2019promo">Free 7 oz. Candle with Qualifying Purchase <span class="discount-amount">$'
                                                         + summer2019PromoExtraDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
            } else if(enableFlameless25Off) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-flameless25offpromo">25% Off Flameless Collection <span class="discount-amount">$'
                                                         + flameless25OffDiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
            } else if(b4g1SeasonalIsEnabled) {
              if(totalSeasonalCandlesDiscount) {
              	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-b4g1candles"><!-- FREE (' + Math.floor(totalSeasonalCandles / 5) + ') B4G1 Candles --> Buy Four, Get One Free Seasonal Candle Discount Applied.  You saved <span class="discount-amount">$'
                                                         + totalSeasonalCandlesDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
                b4g1SeasonalPromoBoxHtml += '<p>Congratulations!  You are getting ' + Math.floor(totalSeasonalCandles / 5) + ' FREE Seasonal Candle/s with your order!</p>';
              }
              
              if(totalSeasonalMeltsDiscount) {
              	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-b4g1candles"><!-- FREE (' + Math.floor(totalSeasonalMelts / 5) + ') B4G1 Melts --> Buy Four, Get One Free Seasonal Melt Discount Applied.  You saved <span class="discount-amount">$'
                                                         + totalSeasonalMeltsDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
                b4g1SeasonalPromoBoxHtml += '<p>Congratulations!  You are getting ' + Math.floor(totalSeasonalMelts / 5) + ' FREE Seasonal Melt/s with your order!</p>';
              }
              
              if(b4g1SeasonalPromoBoxHtml) {
              	jQuery(".page-header h1:first").after('<div class="cart-promo-prompt-box cart-promo-prompt-box-b4g1seasonal">' 
                                                      + '<h3>Buy 4 Get 1 Seasonal Collection</h3>' + b4g1SeasonalPromoBoxHtml
                                                      + '</div>');
              }
            	
              	
            } else if(b4g1CandlesMeltsPromoEnabled) {
              if(b4g1CandlesMeltsPromoCandlesDiscountAmount) {
              	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-b4g1candles"><!-- FREE (' + Math.floor(totalLargeCandles / 5) + ') B4G1 Candles --> Buy Four, Get One Free 7 oz. Signature/Seasonal Candle Discount Applied.  You saved <span class="discount-amount">$'
                                                         + b4g1CandlesMeltsPromoCandlesDiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
                b4g1SeasonalPromoBoxHtml += '<p>Congratulations!  You are getting ' + Math.floor(totalSeasonalCandles / 5) + ' FREE 7 oz. Candle/s with your order!</p>';
              }
              
              if(b4g1CandlesMeltsPromoMeltsDiscountAmount) {
              	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-b4g1candles"><!-- FREE (' + Math.floor(totalMelts / 5) + ') B4G1 Melts --> Buy Four, Get One Free Melt Discount Applied.  You saved <span class="discount-amount">$'
                                                         + b4g1CandlesMeltsPromoMeltsDiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
                b4g1SeasonalPromoBoxHtml += '<p>Congratulations!  You are getting ' + Math.floor(totalMelts / 5) + ' FREE Melt/s with your order!</p>';
              }
              
              if(b4g1SeasonalPromoBoxHtml) {
              	jQuery(".page-header h1:first").after('<div class="cart-promo-prompt-box cart-promo-prompt-box-b4g1seasonal">' 
                                                      + '<h3>Buy 4 Get 1 Cyber Monday Promo</h3>' + b4g1SeasonalPromoBoxHtml
                                                      + '</div>');
              }
            	
              	
            } else if(b4g1FallFragrancesIsEnabled) {
              if(b4g1FallFragrancesDiscountAmt) {
              	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-b4g1candles">FREE Fall Fragrance 7 oz. Candle (you saved) <span class="discount-amount">$'
                                                         + b4g1FallFragrancesDiscountAmt.toFixed(2) + '</span>'
                                                         + '</div>');
              }
            }
            
            
            if(hasSkuCodeInCart('MONDAY19PROMO')) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-tenpercentoff">MONDAY19 - 10% Off and Free Shipping on Orders $50+ <span class="discount-amount">$'
                                                         + tenPercentOffDiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
              
            }
            
            if(hasSkuCodeInCart('LASTCHANCE20PROMO')) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-lastchance20">20% Off Last Chance Collection.  You saved <span class="discount-amount">$'
                                                         + lastChance20DiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
              
            }

            if(freeItemsPromoEnabled && freeItemsPromoDiscount) {
              jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item">Free Ultrasonic Diffulser Oil w/ Every App-Driven Diffuser <span class="discount-amount">$'
                                                         + freeItemsPromoDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
            }
            
            if(enableFreeMistPromo) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-freemistpromo">Get a Free Home Fragance Mist with every 7 oz. and 8.75 oz. Candle (Max of ' + freeMistPromoMax + ').  You saved <span class="discount-amount">$'
                                                         + freeMistPromoDiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
              jQuery("header.page-header").after('<div id="free72and73-header-alert">Congratulations!  Your are getting ' + freeMistPromoTotal + ' FREE Home Fragrance Mist/s with this order!</div>');
            }
            
            
            if(meltWarmerFreeMeltPromoDiscount && totalMeltWarmers) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-freemistpromo">Get a Free Melt with Every Melt Warmer.  You saved <span class="discount-amount">$'
                                                         + meltWarmerFreeMeltPromoDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
              jQuery("header.page-header").after('<div id="free72and73-header-alert">Congratulations!  Your are getting ' + totalMeltsToDiscount + ' FREE Home Fragrance Melt/s with this order!</div>');
            }
            
            //meltWarmerSeasonalMeltsPromoDiscountAmount
            
            if(meltWarmerSeasonalMeltsPromoDiscountAmount > 0 && totalMeltWarmers) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-freemistpromo">50% Off Seasonal Melts with Melt Warmer Purch (limit 8).  You saved <span class="discount-amount">$'
                                                         + meltWarmerSeasonalMeltsPromoDiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
              }
            
            if(ffcVibrantPromoDiscountAmount) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-ffcvibrantpromo">BOGO 50% Off 3-Wick Candles. You saved <span class="discount-amount">$'
                                                         + ffcVibrantPromoDiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
            }
            
            if(enablePercentOffFragrancePromo) {
           //   console.log("PercentOffFragrancePromo qualifying amount?" + " = " + (subtotalWithDiscounts + percentOffFragrancePromoDiscount));
              console.log("percentOffFragrancePromoDiscount = " + (percentOffFragrancePromoDiscount));
            }
            if(/* ((subtotalWithDiscounts + percentOffFragrancePromoDiscount) >= 50) && */ enablePercentOffFragrancePromo && percentOffFragrancePromoDiscount > 0.00) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-tenpercentoff">20% Off Sale. You saved <span class="discount-amount">$'
                                                         + percentOffFragrancePromoDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
              
            }

            if(enablePercentOffProductPromo && percentOffProductPromoDiscount > 0.00) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-productpercentoff">40% off Select Products (' + percentOffProductPromoText + '). You saved <span class="discount-amount">$'
                                                         + percentOffProductPromoDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
              
            }

            if(enablePackagePromo && packagePromoDiscount > 0.00) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-productpercentoff">' + packagePromoText + '. You saved <span class="discount-amount">$'
                                                         + packagePromoDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
              
            }
            
            if(hasSkuCodeInCart('PUMPKINTIMEPROMO') && enablePercentOffFragrancePromo) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-tenpercentoff">PUMPKINTIME - 15% Off Fireside Pumpkin.  You saved <span class="discount-amount">$'
                                                         + percentOffFragrancePromoDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
              
            }
            
            if((hasSkuCodeInCart('CANDLELOVE15PROMO') || hasSkuCodeInCart('MYPROFILE15PROMO')) && enablePercentOffPromoDiscount) {
                jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-tenpercentoff">' + (percentOffPromoDiscount * 100) + '% Off Fan Club Member Promo.  You saved <span class="discount-amount">$'
                                                         + percentOffPromoDiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
            } else if(enablePercentOffPromoDiscount && percentOffPromoDiscountAmount >= 0.01) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-tenpercentoff">' + (percentOffPromoDiscount * 100) + '% Off Your Order ' + percentOffPromoDiscountText + '.  You saved <span class="discount-amount">$'
                                                         + percentOffPromoDiscountAmount.toFixed(2) + '</span>'
                                                         + '</div>');
            }
            
            if(total3WickCandlesDiscount) {
              if(hasSkuCodeInCart('3WICKJOLLYPROMO')) {
                jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-freemistpromo">3WICKJOLLY - Buy 2 & Get 3rd Free 3-Wick Candle + Free Shipping.  You saved <span class="discount-amount">$'
                                                           + total3WickCandlesDiscount.toFixed(2) + '</span>'
                                                           + '</div>');
                //jQuery("header.page-header").after('<div id="free72and73-header-alert">Congratulations!  Your are getting ' + freeMistPromoTotal + ' FREE Home Fragrance Mist/s with this order!</div>');

              } else if(hasSkuCodeInCart('3WICKMERRYPROMO')) {
              	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-freemistpromo">3WICKMERRY - Buy a 3-Wick and Get 2nd 3-Wick at 50% Off + Free Shipping.  You saved <span class="discount-amount">$'
                                                           + total3WickCandlesDiscount.toFixed(2) + '</span>'
                                                           + '</div>');
              }
            	
            }
            
            if(specialThanksCouponExtraDiscount) {
            	jQuery("#discount-line-item-wrapper").append('<div class="discount-line-item discount-line-item-specialthankscoupon">Special Thanks Coupon - 5% Off (you saved) <span class="discount-amount">$'
                                                         + specialThanksCouponExtraDiscount.toFixed(2) + '</span>'
                                                         + '</div>');
            }
            
            
          } // possibly vineoh
        }  // any discounts?
        
        if(!hideTheCheckoutButton) {
        	jQuery(".cart__checkout-button.button").css("visibility", "visible");
        } //display checkout button
        else {
          	jQuery(".cart__checkout-button.button").css("visibility", "hidden");
        } // hide checkout button
        
      } // has .so-cart-discount-notes
    }, 1500); // discountInterval
    
    /*
    if(true || window.location.search.indexOf("testvineoh18") > -1 || jQuery("#cart-item-12917942157394").length > 0) {
   		initVineoh18Promo(); 
    }
    */
    
    if(!jQuery("#cart-item-12917942157394").length && !jQuery("#vineoh-promo-wrapper").length && !hasSpecialThanksCoupon()) {
    	initPromoCodeBox();
    } // add promo code box for special thanks coupon
    
    if(hasSpecialThanksCoupon()) {
    	jQuery("#vineoh-promo-wrapper").hide();
    }
    
    if(enableFree72And73Votive) {
    	initFree72And73Votive();
    }
    
    if(window.location.search.indexOf("gabetest10percoff") > -1) {
      jQuery.get("/discount/GABETEST10PERCOFF",function(response) {
      	console.log("disc app");
      });
    }
    
  } // inShoppingCart
  
  var getFragranceProducts = function(url) {
    var fragName = "";
    
    jQuery(".product-detail .tags a").each(function(i, elem) {
      if(jQuery(elem).attr("href").match(url)) {
      	fragName = jQuery(elem).text();
        console.log("fragName = " + fragName);
      }
    });
    
    if(fragName) {
      var fragUrl = url;
      fragUrl = fragUrl.replace("/collections/all/", "/collections/");
    	jQuery(".product-detail .description").append(
        	'<a href="' + fragUrl + '" class="button" id="fragrance-collection-btn">View the entire ' + fragName + ' collection</a>'
        );
    }
    
    // candle care
      if(	jQuery("#app-body nav.breadcrumbs").text().indexOf("Poured Can") > -1
        	|| jQuery(".product-detail .description").html().match(/soy wax blend candle/)
        ) {
          jQuery(".product-detail .description").prepend(
              //'<a href="https://cdn.shopify.com/s/files/1/2925/4816/files/POS_Candle-Care_4x6-Blue-Web.jpg?4555172218968417232" class="button colorbox" id="product-candle-care-btn">Candle Care</a>'
            '<a href="https://about.trappfragrances.com/candlecare.aspx" target="_blank" class="button" id="product-candle-care-btn">Candle Care</a>'
          );
        /*
        jQuery("a.colorbox").colorbox({
          maxWidth : 600
        });
        */
      } // is a poured candle?
    
    /*
    jQuery.get(url, function(response) {
    	var m = response.match(/<div class="collection\-products">[\s\S]+?<\/div><\!\-\- \/ \.collection\-products \-\->/);
      	//console.log(m);
      if(m) {
        jQuery("#fragrance-products-wrapper").append('<h2>This fragrance is also available in the following products:</h2>');
      	jQuery("#fragrance-products-wrapper").append(m[0]);
        sortCollectionProductsByHandle("#fragrance-products-wrapper .collection-products");
        
        jQuery(".product-detail .description").append(
        	'<article class="product-more-info-panel" id="product-more-info-panel-fragrance-products"><h2></i> Also Available In</h2><div class="also-available-in-body"><ul></ul></div></article>'
        );
        
        jQuery("#fragrance-products-wrapper .title a").each(function(i, elem) {
          var iconToUse = "fa-circle-o";
          var href = jQuery(elem).attr("href");
          var hrefParts = href.split("/");
          if(window.location.href.indexOf(hrefParts[hrefParts.length - 1]) > -1) {
          	iconToUse = "fa-dot-circle-o";
          }
          jQuery("#product-more-info-panel-fragrance-products ul:first").append(
            '<li><i class="fa ' + iconToUse + '" id="related-product-id-' + i + '"></i></li>'
          );
          jQuery("#related-product-id-" + i).append(elem);
        });
        registerProductInfoPanel("#product-more-info-panel-fragrance-products");
      } // has products
      
      
      	
    }); // jQuery.get
    */
  } // getFragranceProducts
  
  var getFragranceProductsSeasonal = function(fragName) {
    
      var fragUrl = "/collections/" + fragName.toLowerCase().replace(/ /ig, '-');
          
          jQuery(".product-detail .description").append(
        	'<a href="' + fragUrl + '" class="button" id="fragrance-collection-btn">View the entire ' + fragName + ' collection</a>'
        );
    
  } // getFragranceProductsSeasonal
  
  var registerProductInfoPanel = function(elem) {
  	// <i class="fa fa-caret-right">
    jQuery(elem).find("h2").prepend('<i class="fa fa-caret-right">');
    jQuery(elem).find("h2:first").click(function(ev) {
    	jQuery(this).next().toggle();
      	jQuery(this).find("i").toggleClass("fa-caret-right fa-caret-down");
    }); // click
    jQuery(elem).find("h2:first").click(); // just open it already
  } // registerProductInfoPanel
    
  if(jQuery("#shopify-section-product-template").length) {
  	var prodDescription = jQuery(".product-detail .description").html();
    var m = prodDescription.match(/notes\s*\:\s*([a-zA-Z,; \-\.\&]+)/i);
    
    var newProdDescription = prodDescription.replace("At Trapp, it's all about the fragrance. That's why we guarantee every product will fill a room with fragrance within minutes. Trapp is set apart by its mission to use only the highest quality fragrances and unmatched fragrance quantity.", "");
    //  At Trapp, it's all about the fragrance. That's why we guarantee every product will fill a room with fragrance within minutes. Trapp is set apart by its mission to use only the highest quality fragrances and unmatched fragrance quantity - A bottle of perfume in every candle.
    newProdDescription = newProdDescription.replace("At Trapp, it's all about the fragrance. That's why we guarantee every product will fill a room with fragrance within minutes. Trapp is set apart by its mission to use only the highest quality fragrances and unmatched fragrance quantity - A bottle of perfume in every candle.", "");
    newProdDescription = newProdDescription.replace(/<br>([\s\r\n]*)<ul/ig, "<ul");
    jQuery(".product-detail .description").html("");
    
    if(m && m[1]) {
      	m[1] = m[1].replace(/&nbsp;/ig, " ");
      jQuery("#product-fragrance-notes").html(m[1].replace(/[,;]/ig, " <span style='font-size:1.3em'>|</span> "));
    } // product with fragrance notes
    
    jQuery(".product-detail .description").append(
        	'<article class="product-more-info-panel" id="product-more-info-panel-additional-info"><h2></i> Additional Information</h2><div class="additional-info-body"></div></article>'
        );
    jQuery(".product-detail .description .additional-info-body").append(newProdDescription);
    registerProductInfoPanel("#product-more-info-panel-additional-info");
    
    jQuery("#product-more-info-panel-additional-info .additional-info-body").find("li, ul > li, p, div, span").each(function(i, elem) {
      if(jQuery(elem).html().match(/fragrance notes/i)) {
        if(elem.tagName == "DIV") {
          if(elem.childElementCount < 2) {
          	jQuery(elem).hide();
          }
        } else {
        	jQuery(elem).hide();
        }
      	//
      } // has fragrance notes?
    }); // #product-more-info-panel-additional-info .additional-info-body").find("li, ul > li, p
    
    var tagUrl = null;
    
    console.log("tagUrl = " + tagUrl);
    
    if(jQuery(".product-detail .tags").length) {
    	tagUrl = jQuery(".product-detail .tags").html().match(/\/collections\/all\/no\-[0-9]+\-[a-zA-Z0-9\-]+/);
      if(tagUrl) {
        console.log("tagUrl = " + tagUrl);
        getFragranceProducts(tagUrl[0]);
      } // has tagUrl for that fragrance
      
    
    } // has tags?
    else {
      var thisProdTitle = "";
      thisProdTitle = jQuery("#shopify-section-product-template h1.title:first").text();
      console.log("thisProdTitle = " + thisProdTitle);
      var seasonalMatch = thisProdTitle.match(/(White Fir|Orange Clove|Holiday|Hearth|Fireside Pumpkin|Glowing Embers|Cinnamon Cider) .+/i)
      if(seasonalMatch && seasonalMatch[1]) {
      	getFragranceProductsSeasonal(seasonalMatch[1]);
      } // is seasonal?
    } // probably seasonal
    
    jQuery("#product-more-info-panel-additional-info p").each(function(i, elem) {
    	var txt = jQuery(elem).text();
      if(txt.length < 5) {
      	jQuery(elem).remove();
      }
    });
    
    
    
  } // #shopify-section-product-template
  
  if(jQuery("#insta-feed-btn").length) {
    jQuery("#insta-feed-btn").css("visibility", "visible");
    jQuery("#insta-feed-btn").click(function(ev) {
      	ev.preventDefault();
    	var lenvisible = jQuery("#insta-feed > a:visible").length;
      if(lenvisible == jQuery("#insta-feed > a").length) {
        var w = window.open("http://instagram.com/trappfragrances", "_blank");
        w.focus();
      }
      jQuery("#insta-feed > a").slice(lenvisible, lenvisible + 7 ).show();
    });
    
    if(isOnMobileView()) {
      console.log("IS ON MOBILE VIEW");
      setTimeout(function() {
      	jQuery("#insta-feed .instafeed-container, .instafeed-shopify .instafeed-container").width("50%");
        console.log("insta width " + jQuery("#insta-feed .instafeed-container:first").width());
        jQuery("#insta-feed .instafeed-container img, .instafeed-shopify .instafeed-container img").height(jQuery("#insta-feed .instafeed-container:first").width());
        jQuery("#insta-feed .instafeed-container").css("padding-top", "0");
        jQuery("#insta-feed .instafeed-container").height(jQuery("#insta-feed .instafeed-container img:first").width()).css("overflow", "hidden");
        jQuery("#insta-feed .instafeed-container").css("margin-bottom", "20px")
      }, 2000);
    	
    } // on mobile?
    
    
  } // #insta-feed-btn
  
  // jQuery(".colorbox-btn").colorbox(); // TODO: temporary disable until colorbox is added
  
  
  //jQuery("#notify-bar .message:first").append(jQuery("#notify-bar a[data-close]").get(0));

  if($("#events-iframe").get(0)) {
    setTimeout(function() {
      $("#events-iframe").css("visibility", "visible");
    }, 1000);
  }
}); // document.ready
  
} // customJsJqueryDocumentReady

var isVineoh18PromoEnabled = false;
var hasVineoh18PromoItem = false;

var b4g1SeasonalIsEnabled = false;
var b4g1SeasonalPromoBoxHtml = '';
b4g1SeasonalIsEnabled = false; // disabled 20211203 // enabled 20211119 // enabled 20190917 // enabled 20181115 // disabled 20190201
var totalSeasonalCandles = 0;
var totalSeasonalMelts = 0;
var promptB4g1Seasonals = '';
var totalSeasonalCandlesDiscount = 0.00;
var totalSeasonalMeltsDiscount = 0.00;

var seasonals40OffIsEnabled = false;
var seasonals50OffIsEnabled = false; // no mup

var seasonalsPercentOffIsEnabled = false;
var seasonalsPercentOffPercent = 0.25;
var seasonalsPercentOffDiscount = 0.00;

if(window.location.search.indexOf("testseasonal50off=") > -1) {
	seasonals50OffIsEnabled = true;
}

seasonals50OffIsEnabled = false; // disabled 20210202

if(window.location.search.indexOf("testseasonalpercentoff=") > -1) {
	seasonalsPercentOffIsEnabled = true; // enabled 20220929 // disabled 20221009
}


var b4g1FallFragrancesIsEnabled = false;
//b4g1FallFragrancesIsEnabled = true;
var b4g1FallFragrancesDiscountAmt = 0.00;

if(window.location.search.indexOf("testb4g1seasonal=") > -1) {
	b4g1SeasonalIsEnabled = true;
  console.log("b4g1SeasonalIsEnabled = " + b4g1SeasonalIsEnabled);
}

seasonals40OffIsEnabled = false; // enabled 20190201 // disabled 20190215


if(b4g1SeasonalIsEnabled && (!customRefPromoCode || !customRefPromoCode.match(/(fall19|falltrapp|seasonal19)/i))) {
  customRefPromoCode = 'FALL19';
  console.log('DEFAULT customRefPromoCode = ' + customRefPromoCode);
  window.localStorage.setItem('customRefPromoCode', customRefPromoCode);
}
if(customRefPromoCode && customRefPromoCode.match(/(fall19|falltrapp|seasonal19)/i)) {
	//b4g1SeasonalIsEnabled = true;
}


if(window.location.search.indexOf("testseasonals40off=") > -1) {
	seasonals40OffIsEnabled = true;
  console.log("seasonals40OffIsEnabled = " + seasonals40OffIsEnabled);
}

function processSpecialThanksCoupon() {
	var promoCode = jQuery("#vineoh-promo-txt").val().toUpperCase();
  var prodUrl = "/products/special-thanks-coupon-" + promoCode.substr(0, 14) + "-v2";
  //console.log(prodUrl);
  jQuery.get(prodUrl, function(response) {
    // "variants":[{"id":21183837110354,"price":0,"name":"Special Thanks Coupon - 5% Off + $5 Flat Rate Shipping - SPCTNX20181201001ZLE","
    var prodVariants = response.match(/"variants"\:\[\{"id"\:([\s\S]+?)(\:null\}\],"images")/i);
    //prodVariants = response.match(/"variants"/i);
    console.log(prodVariants);
    if(prodVariants) {
      var pvo = JSON.parse("{" + prodVariants[0].replace(',"images"', "") + "}");
      for(var k in pvo.variants) {
        if(pvo.variants[k].title == promoCode) {
        	window.location = "https://store.trappcandles.com/cart/add?id=" + pvo.variants[k].id + "&quantity=1";
        } //  correct?
      } // loop
    } // valid?
    else {
      alert("Invalid promo code.");
    } // invalid
  }); // get
} // processSpecialThanksCoupon

function processCustomPromoCode() {
	var promoCode = jQuery("#vineoh-promo-txt").val().toLowerCase();
  if(promoCode == "21519seasonal") {
  	 window.location = "https://store.trappcandles.com/cart/add?id=21402184974418&quantity=1";
  }
} // processCustomPromoCode

function processMom2019Promo() {
	console.log('processMom2019Promo');
  console.log('totalLargeCandles = ' + totalLargeCandles);
  if(totalLargeCandles >= 3) {
  	jQuery.post('/cart/add.js', {
                      quantity: 1,
                      id: 22337607925842
    }, function(response) {
    	refreshingCartPage();
    }).fail(function() {
    	console.log('mom2019 fail');
      alert("Thanks for shopping Trapp Fragrances!\nUnfortunately, we are all out of the Motherâ€™s Day black carryall totes.\nStay tuned for additional promotions.");
    });
                  
  }
} // processMom2019Promo

function initPromoCodeBox() {
	jQuery("#cart-shipping-wrapper").prepend('<div id="vineoh-promo-wrapper"><h3>ENTER PROMO CODE</h3><input type="text" id="vineoh-promo-txt" style="min-height:40px;"> <a class="button secondary" id="vineoh-promo-btn" href="#">Apply</a></div>');
      var submitPromoCode = function(ev) {
      	if(jQuery("#vineoh-promo-txt").val().toLowerCase().replace(" ", "") == "vineoh18xxx") {
        	console.log('calc based on s = ' + Math.floor(subtotalWithDiscounts));
          //var vbase = Math.floor(subtotalWithDiscounts);
          window.location = "https://store.trappcandles.com/cart/add?id=12917942157394&quantity=1";
        } // correct promo code?
        else if(jQuery("#vineoh-promo-txt").val().toLowerCase().indexOf("spctnx") === 0) {
        	console.log("SPC TNX");
          
          	processSpecialThanksCoupon();
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().indexOf("summer") === 0) {
        	window.location = "/cart?customrefpromocode=" + jQuery("#vineoh-promo-txt").val().toUpperCase();
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().indexOf("21519seasonal") === 0) {
        	console.log("21519seasonal");
          
          	processCustomPromoCode();
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase() == ("mom2019") && enableMom2019Promo) {
        	console.log("mom2019 promo");
          	processMom2019Promo();
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase() == ("flameless") && enableFlameless25Off) {
          alert("FLAMELESS promo code was already automatically applied to your cart.");
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/(fall19|falltrapp|seasonal19)/i) && b4g1SeasonalIsEnabled) {
          processB4g1SeasonalFragrancesPromoCode(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/fall(19|trapp)/i) && b4g1FallFragrancesIsEnabled) {
          processB4g1FallFragrances(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/(friday19xxx|mondayxxx19|holidayxxx)/i)) {
          processOrdersOf50Promo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/mem(15|20)xxx/i) 
                  || jQuery("#vineoh-promo-txt").val().toLowerCase().match(/thanksfanclub/i)
                  || jQuery("#vineoh-promo-txt").val().toLowerCase().match(/bfwsale25xxx/i)
                  || jQuery("#vineoh-promo-txt").val().toLowerCase().match(/happygiftingxxx/i)
                 ) {
          processPercentOffPromo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/pumpkintimexxx/i) && enablePercentOffFragrancePromo) {
          processPercentOffFragrancePromo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/(candlelove|myprofile)(15)/i)) {
          processCandlelove15Promo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/(mobile15|save10)/i)) {
          processMobile15Promo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/(ffcvibrant)/i) && ffcVibrantPromoEnabled) {
          processFfcVibrantPromo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/fanclub(10|15)xxx/i)) {
          processFanclubPercentOffPromo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/3wick(jollyxxx)/i)) {
          process3WickJollyPromo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/3wick(merryxxx)/i)) {
          process3WickMerryPromo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/ffc25offxxx|ffcfreeshipxxx/i)) {
          processFfc25OffPromo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/reecenichols10|home25|re35sara|re25christyc|re25erinb/i)) {
          processRe35SaraPromo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/trappfamilyxxx/i)) {
          processTrappFamilyPromo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/WARMER25FFCxxx|FFCWARMUP20xxx/i) && enableMeltWarmerFfcDiscountPromo) {
          processMeltWarmerFfcDiscountPromo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/LASTCHANCE20/i)) {
          processLastChance20Promo(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/xxx(luvmom|bestmom|moms20|momsday)xxx/i)) {
          processPercentOffPromoMomsDay(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else if(jQuery("#vineoh-promo-txt").val().toLowerCase().match(/dadsdayxxx/i)) {
          processPercentOffPromoDadsDay(jQuery("#vineoh-promo-txt").val().toLowerCase());
        } else {
        	alert("Invalid promo code.");
        }
      } // submitPromoCode
      jQuery("#vineoh-promo-btn").click(function(ev) {
        submitPromoCode(ev);
      }); // click
      
      jQuery("#vineoh-promo-txt").keydown(function(ev) {
        if(ev.keyCode == 13) {
          	ev.preventDefault();
        	submitPromoCode(ev);
        }
      }); // click
} // initPromoCodeBox

function initFree72And73Votive() {
  
  console.log("FREE VOTIVES AVAILABLE = " + jQuery("#freevotivesavailable").text());
  if(jQuery("#freevotivesavailable").text() == "true") {
    freeVotivesAvailable = true;
  }
  
  if(jQuery(".line-item.row[data-skucode='61174']").length && jQuery(".line-item.row[data-skucode='61175']").length) {
    hasFree72And73Votive = true;
  }
} // initFree72And73Votive

function initVineoh18Promo() {
  isVineoh18PromoEnabled = true;
 	console.log('initVineoh18Promo');
	if(!jQuery("#cart-item-12917942157394").length) {
      initPromoCodeBox();
    } // not 12917942157394 promo item yet?  add entry box
  else {
  	hasVineoh18PromoItem = true;
    
  } // promo item has been added
} // initVineoh18Promo

function initSummer2019Promo() {
  console.log('initSummer2019Promo');
  if(skuToDiscount['601'][2] == 3) {
    console.log('prompt to add free 7 oz. candle');
    jQuery(".page-header h1:first").after('<p class="cart-promo-prompt-box">You are eligible to receive a Free 7 oz. Candle!  <a href="/collections/7oz-poured-candles">Add 1 more 7 oz. Candle</a> to your cart to get it for free!</p>');
          
  } // 3 candles in cart?
} // initSummer2019Promo

if(window.location && window.location.hash == "#hc-how-long-will-my-trapp-candle-last-question") {
  jQuery(document).ready(function(ev) {
    jQuery(".section-div:eq(1) a:first").click();
    jQuery(window.location.hash).click();
    console.log(jQuery(window.location.hash).closest("div").find("a:first"));
  }); // document ready
}

var seasonalFallFragrancesSkucodes = ["60792", "60757", "60794"];

function countFallFragrancesCandles() {
	var totalqty = 0;
  for(var i = 0; i < seasonalFallFragrancesSkucodes.length; i++) {
    totalqty += getSkucodeQty(seasonalFallFragrancesSkucodes[i]);
  } // loop
  console.log('countFallFragrancesCandles totalqty = ' + totalqty);
  return totalqty;
} // countFallFragrancesCandles

function processB4g1FallFragrances(promoCode) {
  promoCode = promoCode.replace(/[^a-zA-Z0-9]/ig, '');
  console.log('processB4g1FallFragrances promo code = ' + promoCode);
	var totalqty = countFallFragrancesCandles();
  if(totalqty >= 4) {
    
    if(hasSkuCodeInCart('FALL19PROMO') || hasSkuCodeInCart('FALLTRAPPPROMO')) {
      alert("The promo is already in your cart.");
      return false;
    }
    
    if(promoCode.match(/fall19/i)) {
      window.location = "/cart/add?id=30118480052306&qty=1";
    } else if(promoCode.match(/falltrapp/i)) {
      	//30118485393490
      window.location = "/cart/add?id=30118485393490&qty=1";
    }
  } // qty qualifies
  else {
  	alert("You need at least 4 Fall Fragrance Candles in your Shopping Cart to qualify for this promo.");
  }
} // processB4g1FallFragrances

function processB4g1SeasonalFragrancesPromoCode(promoCode) {
  promoCode = promoCode.replace(/[^a-zA-Z0-9]/ig, '');
  console.log('processB4g1SeasonalFragrancesPromoCode promo code = ' + promoCode);
  
  if(hasSkuCodeInCart('FALL19PROMO') || hasSkuCodeInCart('FALLTRAPPPROMO') || hasSkuCodeInCart('SEASONAL19PROMO')) {
      alert("The promo is already in your cart.");
      return false;
    }
  
  if(totalSeasonalCandles >= 4 || totalSeasonalMelts >= 4) {
  	if(promoCode.match(/fall19/i)) {
      refreshingCartPage(null, "/cart/add?id=30118480052306&qty=1");
    } else if(promoCode.match(/falltrapp/i)) {
      	//30118485393490
      refreshingCartPage(null, "/cart/add?id=30118485393490&qty=1");
    } else if(promoCode.match(/seasonal19/i)) {
    	//30167453990994
      refreshingCartPage(null, "/cart/add?id=30167453990994&qty=1");
    }
  } // cart qualifies
  else {
    alert("You need to have at least 5 Seasonal Candles in your cart to qualify for this promo.");
  }
} // processB4g1SeasonalFragrancesPromoCode

function process3WickJollyPromo(promoCode) {
  var totalqty = total3WickCandles;
  if(totalqty >= 3) {
    
    if(hasSkuCodeInCart('3WICKJOLLYPROMO') || hasSkuCodeInCart('3WICKMERRYPROMO')) {
      alert("A similar promo is already in your cart.");
      return false;
    }
    window.location = "/cart/add?id=33190353535058&qty=1";
  } // qty qualifies
  else {
  	alert("You need at least 3 3-Wick Candles in your Shopping Cart to qualify for this promo.");
  }
} // process3WickJollyPromo

function process3WickMerryPromo(promoCode) {
  var totalqty = total3WickCandles;
  
  if(hasSkuCodeInCart('3WICKJOLLYPROMO') || hasSkuCodeInCart('3WICKMERRYPROMO')) {
      alert("A similar promo is already in your cart.");
      return false;
    }
  
  if(totalqty >= 2) {
    refreshingCartPage(null, "/cart/add?id=33190544113746&qty=1");
  } // qty qualifies
  else {
  	alert("You need at least 2 3-Wick Candles in your Shopping Cart to qualify for this promo.");
  }
} // process3WickMerryPromo

function calc3WickJollyPromo() {
  var batchCount = Math.floor(total3WickCandles / 3);
  var modCount = total3WickCandles % 3;
  console.log("3-wick batch count = " + batchCount);
  
  if(modCount == 2) {
  	jQuery(".page-header h1:first").after('<p class="cart-promo-prompt-box">You are eligible to receive 1 more FREE 3-Wick Candle!<br><a href="/collections/16-oz-3-wick-collection">Add ' 
                                          + 1 + ' more 3-wick candle</a> to your cart to get it for free!</p>');
  }
  if(batchCount > 0) {
    total3WickCandles3Batches = batchCount;
  	return batchCount * 49.00;
  }
  return 0.00;
} // calc3WickJollyPromo

function calc3WickMerryPromo() {
  var batchCount = Math.floor(total3WickCandles / 2);
  console.log("3-wick merry batch count = " + batchCount);
  
  if(batchCount > 0) {
    total3WickCandles2Batches = batchCount;
  	return batchCount * 24.50;
  }
  return 0.00;
} // calc3WickMerryPromo

function processOrdersOf50Promo(promoCode) {
  if(subtotalWithDiscounts < 50) {
    alert("Your order sub-total needs to be at least $50.00");
    return;
  } // check order sub-total
  
  if(hasSkuCodeInCart('FRIDAY19PROMO') || hasSkuCodeInCart('MONDAY19PROMO') || hasSkuCodeInCart('HOLIDAYPROMO')) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }
  
  if(promoCode.match(/friday19/i)) {
    refreshingCartPage(null, "/cart/add?id=31290312949842&qty=1");
  } else if(promoCode.match(/monday19/i)) {
    refreshingCartPage(null, "/cart/add?id=31276099469394&qty=1");
  } else if(promoCode.match(/holiday/i)) {
    refreshingCartPage(null, "/cart/add?id=31276062408786&qty=1");
  } 
} // processOrdersOf50Promo

function processPercentOffPromo(promoCode) {
  if(hasSkuCodeInCart('MEM15PROMO') || hasSkuCodeInCart('MEM20PROMO') || hasSkuCodeInCart('MOBILE15PROMO')) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }
  
  if(promoCode.match(/mem15/i)) {
    refreshingCartPage(null, "/cart/add?id=32398405501010&qty=1");
  } else if(promoCode.match(/mem20/i)) {
    refreshingCartPage(null, "/cart/add?id=32398404517970&qty=1");
  } else if(promoCode.match(/bfwsale25|happygifting/i)) {
    refreshingCartPage(null, "/cart/add?id=40630825254994&qty=1");
  } else if(promoCode.match(/goodluck13/i)) {
    refreshingCartPage(null, "/cart/add?id=33102573731922&qty=1");
  } else if(promoCode.match(/thanksfanclub/i)) {
    if(totalSeasonalCandles < 5) {
      alert("You must have at least 5 Seasonal Candles in your cart to use THANKSFANCLUB.");
    	return;
    }
    refreshingCartPage(null, "/cart/add?id=33136143269970&qty=1");
    
  } 
} // processPercentOffPromo

function processPercentOffPromoMomsDay(promoCode) {
  if(hasSkuCodeInCart('LUVMOMPROMO') || hasSkuCodeInCart('BESTMOMPROMO') || hasSkuCodeInCart('MOMS20PROMO') || hasSkuCodeInCart('MOMSDAYPROMO')) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }
  
  if(promoCode.match(/luvmom/i)) {
    refreshingCartPage(null, "/cart/add?id=39906657140818&qty=1");
  } else if(promoCode.match(/bestmom/i)) {
    refreshingCartPage(null, "/cart/add?id=39906711371858&qty=1");
  } else if(promoCode.match(/moms20/i)) {
    refreshingCartPage(null, "/cart/add?id=39906712551506&qty=1");
  } else if(promoCode.match(/momsday/i)) {
    refreshingCartPage(null, "/cart/add?id=39906712944722&qty=1");
  } else {
  
  }
} // processPercentOffPromoMomsDay

function processPercentOffPromoDadsDay(promoCode) {
	
  if(hasSkuCodeInCart('DADSDAYPROMO')) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }
  
  if(promoCode.match(/dadsday/i)) {
    refreshingCartPage(null, "/cart/add?id=39998109646930&qty=1");
  }
} // processPercentOffPromoDadsDay

function processPercentOffFragrancePromo(promoCode) {
  if(hasSkuCodeInCart('PUMPKINTIMEPROMO')) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }
  refreshingCartPage(null, "/cart/add?id=32785481400402&qty=1");
} // processPercentOffFragrancePromo

function calcPercentOffFragrancePromo() {
  	percentOffFragrancePromoDiscount = 0.00;
  	var thisTotal = 0.00;
 	var thisDiscount = 0.00;
  	var thisSkuToDiscount = JSON.parse(JSON.stringify(skuToDiscount));
  
	jQuery(".cart .row.line-item").each(function(i, elem) {
            
      var sku = jQuery(elem).attr("data-sku");
      var skucode = jQuery(elem).attr("data-skucode");
      var rowLinePrice = 0.00;
      
      if(!percentOffFragrancePromoIsFragrance(skucode) || isSkucodeAccessories(skucode)) {
      	return;
      }
      
      console.log('calcPercentOffFragrancePromo found = ' + skucode);

      rowLinePrice = getRowLinePrice(elem);
      
      thisTotal += rowLinePrice;

      $(elem).addClass("with-promo-sale-price").find(".cart-item__price-wrapper:last").after('<div class="promo-sale-price">$' + (rowLinePrice * (1 - percentOffFragrancePromoPercent)).toFixed(2) + '</div>').css("text-decoration", "line-through");

      var productTitleElem = jQuery(elem).find(".product-title");
      var productHref = jQuery(elem).find(".product-title a:first").attr("href");

      var isMupProduct = false;

      if(skuToMup[sku]) {
        isMupProduct = true;
      }

      var qty = parseInt(jQuery(elem).find("input.quantity__input").val());
      if(isMupProduct && thisSkuToDiscount[sku][2] >= thisSkuToDiscount[sku][0]) {
      	thisDiscount += (qty * thisSkuToDiscount[sku][1]);
      }
      
    }); // each .row.line-item
  
  var totalToDiscount = thisTotal - thisDiscount;
  console.log('calcPercentOffFragrancePromo totalToDiscount = ' + thisTotal + ' - ' + thisDiscount + ' = ' + totalToDiscount);
  var thisExtraDiscount = totalToDiscount * percentOffFragrancePromoPercent;
  console.log('calcPercentOffFragrancePromo thisExtraDiscount = ' + thisExtraDiscount);
  percentOffFragrancePromoDiscount = thisExtraDiscount;
  return thisExtraDiscount;
} // calcPercentOffFragrancePromo

function calcPercentOffProductPromo() {
  	percentOffProductPromoDiscount = 0.00;
  	var thisTotal = 0.00;
 	var thisDiscount = 0.00;
  	var thisSkuToDiscount = JSON.parse(JSON.stringify(skuToDiscount));
  
	jQuery(".cart .row.line-item").each(function(i, elem) {
            
      var sku = jQuery(elem).attr("data-sku");
      var skucode = jQuery(elem).attr("data-skucode");
      var rowLinePrice = 0.00;
      
      if(!percentOffProductPromoIsProduct(skucode)) {
      	return;
      }
      console.log("calcPercentOffProductPromo = " + skucode)
      if(enablePercentOffFragrancePromo && percentOffFragrancePromoIsFragrance(skucode)) {
        console.log("skipping " + skucode + " bec not stackable and when fragrance disco is higher");
        return; 
      }
      
      console.log('calcPercentOffProductPromo found = ' + skucode);

      rowLinePrice = getRowLinePrice(elem);
      
      thisTotal += rowLinePrice;

      var productTitleElem = jQuery(elem).find(".product-title");
      var productHref = jQuery(elem).find(".product-title a:first").attr("href");

      var isMupProduct = false;

      if(skuToMup[sku]) {
        isMupProduct = true;
      }

      var qty = parseInt(jQuery(elem).find("input.quantity__input").val());
      if(isMupProduct && thisSkuToDiscount[sku][2] >= thisSkuToDiscount[sku][0]) {
      	thisDiscount += (qty * thisSkuToDiscount[sku][1]);
      }
      
    }); // each .row.line-item
  
  var totalToDiscount = thisTotal - thisDiscount;
  console.log('calcPercentOffProductPromo totalToDiscount = ' + thisTotal + ' - ' + thisDiscount + ' = ' + totalToDiscount);
  var thisExtraDiscount = totalToDiscount * percentOffProductPromoPercent;
  console.log('calcPercentOffProductPromo thisExtraDiscount = ' + thisExtraDiscount);
  percentOffProductPromoDiscount = thisExtraDiscount;
  return thisExtraDiscount;
} // calcPercentOffProductPromo

function calcPercentOffFragrancePromoOld() {
  	percentOffFragrancePromoDiscount = 0.00;
  	var thisTotal = 0.00;
 	var thisDiscount = 0.00;
  	var thisSkuToDiscount = JSON.parse(JSON.stringify(skuToDiscount));
  
	jQuery(".cart .row.line-item").each(function(i, elem) {
            
      var sku = jQuery(elem).attr("data-sku");
      var skucode = jQuery(elem).attr("data-skucode");
      var rowLinePrice = 0.00;
      
      if(!percentOffFragrancePromoIsFragrance(skucode)) {
      	return;
      }
      
      console.log('calcPercentOffFragrancePromo found = ' + skucode);

      rowLinePrice = getRowLinePrice(elem);
      
      thisTotal += rowLinePrice;

      // Seasonal Candle?  Overwrite 607 with 601
      if(skucode.match(/60756|60757|60758|60791|60792|60793|60794/i)) {
        sku = "601";
      }

      var productTitleElem = jQuery(elem).find(".product-title");
      var productHref = jQuery(elem).find(".product-title a:first").attr("href");

      var isMupProduct = false;

      if(skuToMup[sku]) {
        isMupProduct = true;
      }

      var qty = parseInt(jQuery(elem).find("input.quantity").val());
      if(isMupProduct && thisSkuToDiscount[sku][2] >= thisSkuToDiscount[sku][0]) {
      	thisDiscount += (qty * thisSkuToDiscount[sku][1]);
      }
      
    }); // each .row.line-item
  
  var totalToDiscount = thisTotal - thisDiscount;
  console.log('calcPercentOffFragrancePromo totalToDiscount = ' + thisTotal + ' - ' + thisDiscount + ' = ' + totalToDiscount);
  var thisExtraDiscount = totalToDiscount * percentOffFragrancePromoPercent;
  console.log('calcPercentOffFragrancePromo thisExtraDiscount = ' + thisExtraDiscount);
  percentOffFragrancePromoDiscount = thisExtraDiscount;
  return thisExtraDiscount;
} // calcPercentOffFragrancePromoOld



function processFanclubPercentOffPromo(promoCode) {
  if(hasSkuCodeInCart('FANCLUB10PROMO') || hasSkuCodeInCart('FANCLUB15PROMO')) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }
  
  if(promoCode.match(/fanclub10/i)) {
    refreshingCartPage(null, "/cart/add?id=32682519265362&qty=1");
  } else if(promoCode.match(/fanclub15/i)) {
    refreshingCartPage(null, "/cart/add?id=32685306773586&qty=1");
  } 
} // processFanclubPercentOffPromo

function processFreeMistPromo() {
  var currCount = 1;
  for(var i = 0; (i < totalLargeCandles) && (i < freeMistPromoMax) && (i < totalMists); i++) {
    if(currCount == 1) {
      freeMistPromoDiscountAmount = 10.00;
    } else {
      freeMistPromoDiscountAmount = currCount * 8.00;
    }
    freeMistPromoTotal++;
    currCount++;
  }
  var aCounter = freeMistPromoTotal;
  while((aCounter < freeMistPromoMax) && (aCounter < totalLargeCandles)) {
  	aCounter++;
    freeMistPromoMissing++;
  }
  if(freeMistPromoMissing) {
  	jQuery(".page-header h1:first").after('<p class="cart-promo-prompt-box">You are eligible to receive ' + freeMistPromoMissing + ' more FREE Home Fragrance Mist/s!<br><a href="/collections/home-fragrance-sprays">Add ' 
                                          + freeMistPromoMissing + ' more mist/s</a> to your cart to get ' + (freeMistPromoMissing < 2 ? 'it' : 'them') + ' for free!</p>');
  }
  console.log("freeMistPromoDiscountAmount = " + freeMistPromoDiscountAmount + "; freeMistPromoTotal = " + freeMistPromoTotal + "; freeMistPromoMissing = " + freeMistPromoMissing);
  
} // processFreeMistPromo

function processCandlelove15Promo(promoCode) {
  var email = getCurrentCustomerEmail();
  if(!email) {
  	alert("Please log-in using your Fragrance Fan Club validated email.");
    return false;
  }
  
  if(promoCode.toLowerCase().indexOf("profile") > -1) {
  	refreshingCartPage('<div id="refreshing-cart-wrapper">Please wait while we validate your promo code.</div>', "/cart/add?id=32865538277458&qty=1", true);
  } else {
  	refreshingCartPage('<div id="refreshing-cart-wrapper">Please wait while we validate your promo code.</div>', "/cart/add?id=32757174435922&qty=1", true);
  } // profile or new?
  
  var checkEmailUrl = "https://trappcandles.com/fanclub_check_email.aspx?pc=" + promoCode.toUpperCase() + "&e=" + email;
  var checkPurchaseUrl = "https://apps.faultless.com/shopify/trapp/vineoh18/checkemail.php?email=" + email + "&search=" + promoCode.toUpperCase();
  jQuery.get(checkEmailUrl, function(response) {
    response = response.toLowerCase();
    if(response.indexOf("found") > -1 && response.indexOf(email.toLowerCase()) > -1) {
    	console.log('email valid.');
      	// now check whether they have used it before
      jQuery.get(checkPurchaseUrl, function(thisresponse) {
      	console.log(thisresponse);
        if(thisresponse.indexOf("customer") > -1) {
          jQuery.colorbox.close();
        	alert("It looks like you've already used " + promoCode + " in a previous order.\nIt is a one-time use only code.");
          return false;
        } else {
        	// valid so add CANDLELOVE15 promo product
          refreshingCartPageWait = false;
        }
      });
    } else {
    	// invalid here
      jQuery.colorbox.close();
      alert("Looks like your email has not yet been registered with the Trapp Fragrance Fan Club OR your promo code already expired.");
      return false;
    } // valid or invalid?
  });
} // processCandlelove15Promo

function processMobile15Promo(promoCode) {
  var email = getCurrentCustomerEmail();
  if(!email) {
  	alert("Please log-in to your trappfragrances.com account.");
    return false;
  }

  if($(".discount-line-item-tenpercentoff").length) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }

  if(promoCode.indexOf("15") > -1) {
    // mobile15
    refreshingCartPage('<div id="refreshing-cart-wrapper">Please wait while we validate your promo code.</div>', "/cart/add?id=40557503184978&qty=1", true);  
  } else {
    // save10
    refreshingCartPage('<div id="refreshing-cart-wrapper">Please wait while we validate your promo code.</div>', "/cart/add?id=40723464618066&qty=1", true);  
  }
  
  
  var checkPurchaseUrl = "https://apps.faultless.com/shopify/trapp/vineoh18/checkemail.php?email=" + email + "&search=" + promoCode.toUpperCase();
  console.log(checkPurchaseUrl);
  
  jQuery.get(checkPurchaseUrl, function(thisresponse) {
    console.log(thisresponse);
    if(thisresponse.indexOf("customer") > -1) {
      jQuery.colorbox.close();
        alert("It looks like you've already used " + promoCode + " in a previous order.\nIt is a one-time use only code.");
      return false;
    } else {
        // valid so add MOBILE15 promo product
      refreshingCartPageWait = false;
    }
  });
} // processMobile15Promo


function processFfcVibrantPromo(promoCode) {
  var email = getCurrentCustomerEmail();
  if(!email) {
  	alert("Please log-in using your Fragrance Fan Club validated email.");
    return false;
  }
  
  if(total3WickCandles < 2) {
  	alert("Please add at least 2 Vibrant 3-Wick Candles to your cart to use this promo code.");
    return false;
  }
  
  refreshingCartPage('<div id="refreshing-cart-wrapper">Please wait while we validate your promo code.</div>', "/cart/add?id=39640812683346&qty=1", true);
  
  var checkEmailUrl = "https://trappcandles.com/fanclub_check_email.aspx?pc=" + promoCode.toUpperCase() + "&e=" + email;
  var checkPurchaseUrl = "https://apps.faultless.com/shopify/trapp/vineoh18/checkemail.php?email=" + email + "&search=" + promoCode.toUpperCase();
  jQuery.get(checkEmailUrl, function(response) {
    response = response.toLowerCase();
    if(response.indexOf("found") > -1 && response.indexOf(email.toLowerCase()) > -1) {
    	console.log('email valid.');
      	// now check whether they have used it before
      jQuery.get(checkPurchaseUrl, function(thisresponse) {
      	console.log(thisresponse);
        if(thisresponse.indexOf("customer") > -1) {
          jQuery.colorbox.close();
        	alert("It looks like you've already used " + promoCode + " in a previous order.\nIt is a one-time use only code.");
          return false;
        } else {
        	// valid so add promo product
          refreshingCartPageWait = false;
        }
      });
    } else {
    	// invalid here
      jQuery.colorbox.close();
      alert("Looks like your email has not yet been registered with the Trapp Fragrance Fan Club OR your promo code already expired.");
      return false;
    } // valid or invalid?
  });
} // processFfcVibrantPromo

function processFfc25OffPromo(promoCode) {
  
  var email = getCurrentCustomerEmail();
  
  if(!email) {
    var altxt = ("<div style='padding:2em; margin-right:30px; text-align:center;max-width:500px;'>Must <a href='/account/login'>log into your account on TrappFragrances.com</a> using the same email you used to sign up for Fragrance Fan Club to receive discount.</div>");
    jQuery.colorbox({ open : true, html : altxt});
    return false;
  }
  
  if(hasSkuCodeInCart('PROMOFFC25OFF') || hasSkuCodeInCart('PROMOFFCFREESHIP')) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }
  if(!hasSkuCodeInCart('60776') && !hasSkuCodeInCart('60176') && !hasSkuCodeInCart('60777') && !hasSkuCodeInCart('60177')) {
  	alert("You must have a No. 76 or No. 77 (7 oz. or 8.75 oz.) poured candle in your cart to use this promo.");
    return;
  }
  
  var checkPurchaseUrl = "https://apps.faultless.com/shopify/trapp/vineoh18/checkemail.php?email=" + email + "&search=" + promoCode.toUpperCase();
  
  jQuery.get(checkPurchaseUrl, function(thisresponse) {
    console.log(thisresponse);
    //alert(checkPurchaseUrl);
    //alert(thisresponse);
    if(thisresponse.indexOf("customer") > -1) {
      jQuery.colorbox.close();
      alert("It looks like you've already used " + promoCode + " in a previous order.\nIt is a one-time use only code.");
      return false;
    } else {
      // valid so add promo product
      if(promoCode.match(/ffc25off/i)) {
        refreshingCartPage(null, "/cart/add?id=39302268682322&qty=1");
      } else {
        // ffcfreeship
        refreshingCartPage(null, "/cart/add?id=39302269042770&qty=1");
      }
    } // found or not?
  }); // previous purchase check
  
} // processFfc25OffPromo

function processLastChance20Promo(promoCode) {
  
  refreshingCartPage(null, "/cart/add?id=39796688158802&qty=1");
  
} // processLastChance20Promo


function processRe35SaraPromo(promoCode) {
  
  var email = getCurrentCustomerEmail();
  
  if(!email) {
    var altxt = ("<div style='padding:2em; margin-right:30px; text-align:center;max-width:500px;'>Must <a href='/account/login'>log into your account on TrappFragrances.com</a>.<br>Don't have an account yet?  <a href='/account/register'>Click here to register</a>.</div>");
    jQuery.colorbox({ open : true, html : altxt});
    return false;
  }
  
  if(hasSkuCodeInCart('REECENICHOLS10PROMO') || hasSkuCodeInCart('HOME25PROMO') || hasSkuCodeInCart('RE35SARAPROMO') || hasSkuCodeInCart('RE25CHRISTYCPROMO') || hasSkuCodeInCart('RE25ERINBPROMO') || percentOffPromoDiscountAmount) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }
  
  var checkPurchaseUrl = "https://apps.faultless.com/shopify/trapp/vineoh18/checkemail.php?email=" + email + "&search=" + promoCode.toUpperCase();
  
  jQuery.get(checkPurchaseUrl, function(thisresponse) {
    console.log(thisresponse);
    //alert(checkPurchaseUrl);
    //alert(thisresponse);
    if(thisresponse.indexOf("customer") > -1) {
      jQuery.colorbox.close();
      alert("It looks like you've already used " + promoCode + " in a previous order.\nIt is a one-time use only code.");
      return false;
    } else {
      // valid so add promo product
      var reVariantId = "";
      if(promoCode.toUpperCase() == ('RE35SARA')) {
      	reVariantId = "39361049198674";
      } else if(promoCode.toUpperCase() == ('RE25CHRISTYC')) {
      	reVariantId = "39372347310162";
      } else if(promoCode.toUpperCase() == ('RE25ERINB')) {
      	reVariantId = "39545600376914";
      } else if(promoCode.toUpperCase() == ('HOME25')) {
      	reVariantId = "40084793688146";
      } else if(promoCode.toUpperCase() == ('REECENICHOLS10')) {
      	reVariantId = "40221232726098";
      }
      refreshingCartPage(null, "/cart/add?id=" + reVariantId + "&qty=1");
    } // found or not?
  }); // previous purchase check
  
} // processRe35SaraPromo

function processWarmerMeltsPromo() {
  if(totalMeltWarmers < 1) {
  	return false;
  }
  var howmany = 0;
  var howmanyMissing = 0;
  if(totalMeltWarmers == 1) {
  	howmany = totalFreeWarmerMeltsMax;
  } else {
  	howmany = totalFreeWarmerMeltsMax * totalMeltWarmersMax;
  }
  if(totalSeasonalMelts < howmany) {
  	howmanyMissing = howmany - totalSeasonalMelts;
  }
  // totalFreeWarmerMeltsMax
  var promoboxhtml = '<h3>Get 3 Seasonal Fragance Melts When You Buy a NEW Trapp Melt Warmer</h3><p>Congratulations!  You are eligibe to receive '
  	+ howmany + ' FREE Seasonal Melts with your order!<br>'
  	+ 'You currently have ' + totalSeasonalMelts + ' Seasonal Melt/s in your cart.  <a href="/collections/seasonal-collection-wax-melts">Add ' + howmanyMissing + ' more to get a total of ' + howmany + ' Seasonal Melt/s</a> for free on this order!</p>';
  
  if(!howmanyMissing) {
    promoboxhtml = '<h3>Get 3 Seasonal Fragance Melts When You Buy a NEW Trapp Melt Warmer</h3><p>Congratulations!  You are getting '
  	+ howmany + ' FREE Seasonal Melts with your order!';
    totalWarmerMeltsPromoDiscount = howmany * 7.5;
    totalFreeWarmerMelts = howmany;
  } // successfully fulfilled
  else {
  	hideTheCheckoutButton = true;
  } // not yet fulfilled, so hide checkout button
  
  jQuery(".page-header h1:first").after('<div class="cart-promo-prompt-box cart-promo-prompt-box-warmermelts">' + promoboxhtml + '</div>');
  jQuery(".cart-promo-prompt-box-warmermelts:first").get(0).scrollIntoView();
  return totalWarmerMeltsPromoDiscount;
  
} // processWarmerMeltsPromo

function processBlackFridayWeekendPromo() {
  if(totalSeasonalCandles >= 5 && !hasSkuCodeInCart('BLACKFRIDAY2020PROMO')) {
    refreshingCartPage(null, "/cart/add?id=33140998307922&qty=1");
  }
  if(hasSkuCodeInCart('BLACKFRIDAY2020PROMO')) {
    if(totalSeasonalCandles < 5) {
      refreshingCartPage(null, jQuery("#cart-item-33140998307922").find("a[href^='/cart/change']").attr("href"))
    } // no b4g1 seasonal promo? remove
    enablePercentOffPromoDiscount = true;
    percentOffPromoDiscount = 0.10;
    console.log('Has BLACKFRIDAY2020PROMO promo for ' + percentOffPromoDiscount);
  } // has GOODLUCK13PROMO skucode
} // processBlackFridayWeekendPromo

function processMeltWarmerFreeMeltPromo() {
	totalMelts = skuToDiscount['613'][2];
          
  totalMeltsToDiscount = (totalMelts < totalMeltWarmers) ? totalMelts : totalMeltWarmers;

  if(totalMelts >= skuToDiscount['613'][0]) {
    meltWarmerFreeMeltPromoDiscount = (totalMeltsToDiscount * 9) - (totalMeltsToDiscount * skuToDiscount['613'][1]);
  } else {
    meltWarmerFreeMeltPromoDiscount = (totalMeltsToDiscount * 9);
  }
  console.log("meltWarmerFreeMeltPromoDiscount = " + meltWarmerFreeMeltPromoDiscount);
  
  if(totalMelts < totalMeltWarmers) {
  
  	var totalMissingMelts = totalMeltWarmers - totalMelts;
    
      // totalFreeWarmerMeltsMax
      var promoboxhtml = '<h3>Get a Free Melt with a Melt Warmer Purchase!</h3><p>Congratulations!  You are eligibe to receive '
        + totalMissingMelts + ' more Melt/s with your order!<br>'
        + 'You currently have ' + totalMeltsToDiscount + ' Melt/s in your cart.  <a href="/collections/wax-melts">Add ' + totalMissingMelts + ' more to get a total of ' + totalMeltWarmers + ' Melt/s</a> for free on this order!</p>';

      
      jQuery(".page-header h1:first").after('<div class="cart-promo-prompt-box cart-promo-prompt-box-warmermelts">' + promoboxhtml + '</div>');
      jQuery(".cart-promo-prompt-box-warmermelts:first").get(0).scrollIntoView();
    hideTheCheckoutButton = true;
    
    
    } // missing free melts?
  
  
  return meltWarmerFreeMeltPromoDiscount;
} // processMeltWarmerFreeMeltPromo

function processFreeItemsPromoDiscount() {
  totalFreeItemsPromoRequired = getSkucodeQty('73055');
  totalFreeItemsPromoToDiscount = skuToDiscount['717'][2];
  freeItemsPromoDiscount = 0.00;
  if(totalFreeItemsPromoRequired < 1) {
    return freeItemsPromoDiscount;
  }
  
  if(totalFreeItemsPromoToDiscount >= totalFreeItemsPromoRequired) {
    totalFreeItemsPromoToDiscount = totalFreeItemsPromoRequired;
  }

  console.log("totalFreeItemsPromoRequired = " + totalFreeItemsPromoRequired + "; totalFreeItemsPromoToDiscount = " + totalFreeItemsPromoToDiscount);

  console.log("mupRequired = " + skuToDiscount['717'] + ";" + skuToDiscount['717'][0]);
  if(skuToDiscount['717'][2] >= skuToDiscount['717'][0]) {
    freeItemsPromoDiscount = (18.00 - skuToDiscount['717'][1]) * totalFreeItemsPromoToDiscount;
  } else {
    freeItemsPromoDiscount = 18.00 * totalFreeItemsPromoToDiscount;
  }
  console.log("freeItemsPromoDiscount = " + freeItemsPromoDiscount);
  return freeItemsPromoDiscount;
} // processFreeItemsPromoDiscount

function isFfcMemberLoggedIn() {
	var email = getCurrentCustomerEmail();
  
  if(!email) {
    var altxt = ("<div style='padding:2em; margin-right:30px; text-align:center;max-width:500px;'>Must <a href='/account/login'>log into your account on TrappFragrances.com</a> using the same email you used to sign up for Fragrance Fan Club to receive discount.</div>");
    jQuery.colorbox({ open : true, html : altxt});
    return false;
  }
  return email;
} // isFfcMemberLoggedIn


function processMeltWarmerFfcDiscountPromo(promoCode) {
  
  if(!isFfcMemberLoggedIn()) {
  	return false;
  }
  
  if(totalMeltWarmers < 1) {
  	alert("Please add at least 1 Melt Warmer to you cart to use this promo code.");
    return false;
  }
  
  if(hasSkuCodeInCart('WARMFFC25FORUPROMO') || hasSkuCodeInCart('WARMFFCGET20PROMO')) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }
  
  var reVariantId = "";
  
  if(promoCode.indexOf("20") > 0) {
  	reVariantId = "39667983351890";
  } else if(promoCode.indexOf("25") > 0) {
  	reVariantId = "39668010877010";
  } else {
  	alert("Invalid promo code.");
    return false;
  }
  
  refreshingCartPage(null, "/cart/add?id=" + reVariantId + "&qty=1");
} // processMeltWarmerFfcDiscountPromo


function processTrappFamilyPromo(promoCode) {

  if(hasSkuCodeInCart('TRAPPFAMILYPROMO')) {
  	alert("A similar offer is already in your cart.  Please remove this offer and try again.");
    return;
  }

  if(cartGetSubtotalWithDiscount() >= 0.01) {
    if(cartGetSubtotalWithDiscount() > 300) {
      alert("In order to use this promo code, your order total needs to be less than $300.00");
      return;
    }
  } else {
    if(cartGetCurrSubtotal() > 300) {
      alert("In order to use this promo code, your order total needs to be less than $300.00");
      return;
    }
  }
  
  var reVariantId = "";
  reVariantId = "39684896129106";

  var txt = '<div class="cart-promo-prompt-box">' 
                                                      + '<h3>Employees and friends and family only</h3>' + 
                                                '<p>Cannot be resold<br>Closely monitored<br>Maximum order value of $300</p>'
                                                + '<p class="fnfagree-wrapper"><input type="checkbox" id="fnfagree"> <label for="fnfagree">I agree to the terms and conditions of this promo</label></p>'
                                                      + '</div>';
  var cboxWidth = 600;
  if(isOnMobileView()) {
                        cboxWidth = "100%";
                    }
  jQuery.colorbox({ open : true, width : cboxWidth, height : 400, html : txt,
                  onComplete : function() {
            
                    if(isOnMobileView()) {
                        jQuery.colorbox.resize();
                      
                    }
                    jQuery("#fnfagree").click(function(ev) {
                      setTimeout(function() {
                        refreshingCartPage(null, "/cart/add?id=" + reVariantId + "&qty=1");
                      }, 600);
                      
                    });
                  }
                  });
} // processTrappFamilyPromo


var productGridFirstProdHrefSolid = '';

function initHoverDiamondEffect() {
  if(jQuery(".grid__item .card-wrapper a:first[href^='/products/7']")) {
    //console.log(jQuery('.grid__item .card-wrapper a[href^="/products/71307"]').closest(".card-wrapper"));
    //console.log(jQuery('.grid__item .card-wrapper a[href^="/products/71307"]').closest(".card-wrapper").find(".card__inner .media:first"));
    //regCardWrapper(jQuery('.grid__item .card-wrapper a[href^="/products/71307"]').closest(".card-wrapper"));
    jQuery(".grid__item .card-wrapper a[href^='/products/7']").each(function(i, elem) {
        var thishref = jQuery(elem).attr("href");
        if(
            ( thishref.match(/\/(730|714xxx|502|746)/) ) // 202504 added new diffuser kits since no filled in diamond yet // 202406 added new melts and gourmet
             && !thishref.match(/\/73059/) && !thishref.match(/\/73060/)) {
          // don't do diamond
        } else {
          regCardWrapper(jQuery(elem).closest(".card-wrapper"));
        }
    	
    });

    setInterval(function() {
      if(jQuery("#product-grid .card-wrapper").length > 0) {
        if(productGridFirstProdHrefSolid != jQuery("#product-grid .card-wrapper:first a:first").attr("href") + jQuery("#product-grid .card-wrapper:eq(1) a:first").attr("href")) {
            console.log("if products change, re-load solid diamonds = initHoverDiamondEffect");
          productGridFirstProdHrefSolid = jQuery("#product-grid .card-wrapper:first a:first").attr("href") + jQuery("#product-grid .card-wrapper:eq(1) a:first").attr("href");
        	initHoverDiamondEffect();
        } // if products change, re-load solid diamonds

        if(
            (window.location && window.location.search.indexOf("testSaleBadgeForPromo=") > -1)
            || enablePercentOffFragrancePromo
          ) {
            displayPromoSalePrice();
          
        } // testSaleBadgeForPromo
        
      } // in collection page?
    }, 500);
  }
} // initHoverDiamondEffect

function regCardWrapper(cardWrapper) {
  
 
  	var href = jQuery(cardWrapper).find("a").attr("href");
  var hrefs = href.match(/7[0-9]{4}/);
  console.log(hrefs[0]);
  
  var dimg = new Image().src = "https://apps.faultless.com/osg/2022-prod-images/solid/" + hrefs[0] + "_solid.png";
  console.log("dimg = " + dimg);
	jQuery(cardWrapper).on("mouseover", function(elem) {
      elem = elem.currentTarget;
      console.log(elem);
      console.log(jQuery(elem).find(".card__inner .media"));
    	jQuery(elem).find(".card__inner .media:first").css("background", "url('https://apps.faultless.com/osg/2022-prod-images/solid/" + hrefs[0] + "_solid.png') no-repeat center")
        .css("background-size", "cover")
        .addClass("solidbg")
        ;
    });
  
  	jQuery(cardWrapper).on("mouseout", function(elem) {
      elem = elem.currentTarget;
      console.log(elem);
      console.log(jQuery(elem).find(".card__inner .media"));
    	jQuery(elem).find(".card__inner .media:first").css("background", "none")
        .css("background-size", "cover")
        .removeClass("solidbg")
        ;
    }); 
} // regCardWrapper

function initProductImagesSlider() {

	/*
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>
    */
  console.log('initProductImagesSlider');
  jQuery(".grid__item.product__media-wrapper").prepend('<div id="mainImageHolder" style="margin-right:50px;"></div>');
  var firstImage = jQuery(".product__media.media img").attr("src");
  jQuery("#mainImageHolder").append('<img src="' + firstImage + '">');
  
  
  regProductMainImageHolder();
  
  
 // jQuery("#mainImageHolder").after('<slider-component>' + jQuery("slider-component").html() + '</slider-component>');
  jQuery(".product__media-item.grid__item").css("width", "calc(33.33% - 5rem * 2 / 3)").css("max-width", "calc(33.33% - 5rem * 2 / 3)").css("margin", "0");
  jQuery(".product__media-list.grid").css("justify-content", "center");
  jQuery(".product__media-item.grid__item:gt(2)").css("display", "none");
  jQuery(".product__media-item.grid__item button").css("display", "none");
  jQuery(".product__media-item.grid__item img").click(function(ev) {
    var thisimg = jQuery(this).attr("src");
    console.log(thisimg);
    jQuery("#mainImageHolder img:first").addClass("animate-lh-left");
  	jQuery("#mainImageHolder").append('<img src="' + thisimg + '" class="animate-lh-right">');
    jQuery("#mainImageHolder img:first").remove();
    
    regProductMainImageHolder();
    
  }).css("cursor", "zoom-in");
  jQuery("ul.product__media-list.grid:first").prepend('<span id="icon-prev-imgs" style="position:absolute;top:70px;left:50px;height:30px;transform:rotate(90deg);color:gray;z-index:9999;display:block;"><svg id="icon-prev-imgs" aria-hidden="true" style="height:30px;color:gray;" focusable="false" role="presentation" class="icon icon-caret icon-prev" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></span>');
  jQuery("ul.product__media-list.grid:first").prepend('<span id="icon-next-imgs" style="position:absolute;top:70px;right:20px;height:30px;transform:rotate(270deg);color:gray;z-index:9999;display:block;"><svg style="height:30px;color:gray;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret icon-next" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></span>');

  jQuery(".product__media-item.grid__item img").each(function(i, elem) {
  	var dimg = new Image().src = elem.src;
  });
  
  var currPageIndex = 0;
  
  jQuery("#icon-next-imgs").click(function(ev) {
    
    if(currPageIndex + 3 >= jQuery(".product__media-item.grid__item").length) {
    	return;
    }
    currPageIndex += 3;
    jQuery(".product__media-item.grid__item").hide();
    jQuery(".product__media-item.grid__item").slice(currPageIndex, currPageIndex + 3).fadeIn();
    
    console.log("clicked!");
    refreshProductImageArrows();
  });
  
  jQuery("#icon-prev-imgs").click(function(ev) {
    currPageIndex -= 3;
    if(currPageIndex < 0) {
    	currPageIndex = 0;
    }
    jQuery(".product__media-item.grid__item").hide();
    jQuery(".product__media-item.grid__item").slice(currPageIndex, currPageIndex + 3).fadeIn();
    
    console.log("clicked!");
    refreshProductImageArrows();
  });
  
  	function refreshProductImageArrows() {
      if(currPageIndex < 1) {
		jQuery("#icon-prev-imgs").css("visibility", "hidden");
      } else {
      	jQuery("#icon-prev-imgs").css("visibility", "visible");
      }
      if(currPageIndex + 3 >= jQuery(".product__media-item.grid__item").length) {
    	jQuery("#icon-next-imgs").css("visibility", "hidden");
      } else {
      	jQuery("#icon-next-imgs").css("visibility", "visible");
      }
	} // refreshProductImageArrows
  
  refreshProductImageArrows();
}

function regProductMainImageHolder() {
	jQuery("#mainImageHolder img").click(function(ev) {
      console.log(this.src);
    	var dimg = new Image().src = this.src;
      	
      	jQuery.colorbox({ open : true, html : '<img src="' + this.src + '">'});
    });
} // regProductMainImageHolder

function initCandleDiamondFilters() {
console.log("!!!initCandleDiamondFilters!!!");
  jQuery(".fragrance-diamond").click(function(ev) {
    console.log("CLICKED!!!");
    var href = jQuery(this).closest("div").find("a:first").attr("href");
    console.log(href);
    window.location = href;
  });
  
  if(jQuery("#candle-size-filter-wrapper").length) {
    jQuery("#candle-size-filter-wrapper button, #candle-size-filter-wrapper div").each(function(i, elem) {
    	var thisa = jQuery(elem).find("a").attr("href");
      if(thisa.indexOf(currentCollectionHandle) > -1) {
      	jQuery(elem).find(".fragrance-diamond").addClass("active");
      }
    });
  }
  return;
    jQuery("#candle-size-filter-wrapper button, #candle-size-filter-wrapper a").off("click");
    jQuery("#candle-size-filter-wrapper button, #candle-size-filter-wrapper a").click(function(ev) {
    	ev.preventDefault();
      console.log('clicked!');
    });
    jQuery("#candle-size-filter-wrapper a").mouseover(function(ev) {
      console.log('mouseover!');
    });
   // alert('!!!');
} // initCandleDiamondFilters

function initCarouselWrapperArrows() {
	jQuery("#carouselWrapper").append('<span id="icon-prev-imgs" style="position:absolute;top:300px;left:20px;height:30px;transform:rotate(90deg);color:gray;z-index:9999;display:block;"><svg id="icon-prev-imgs" aria-hidden="true" style="height:30px;color:gray;" focusable="false" role="presentation" class="icon icon-caret icon-prev" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></span>');
  jQuery("#carouselWrapper").append('<span id="icon-next-imgs" style="position:absolute;top:300px;right:20px;height:30px;transform:rotate(270deg);color:gray;z-index:9999;display:block;"><svg style="height:30px;color:gray;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret icon-next" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></span>');
	
  jQuery("#icon-next-imgs").click(function(ev) {
    console.log("initCarouselWrapperArrows " + $("#carouselWrapper:first .container-dots .dot.active").index());
    if($("#carouselWrapper:first .container-dots .dot.active").index() >= $("#carouselWrapper .container-dots .dot").length - 1) {
      jQuery(this).closest("#carouselWrapper").find(".container-dots .dot:eq(0)").click();
      return;
    }
    jQuery(this).closest("#carouselWrapper").find(".container-dots .dot.active").next().click();
  });
  
  jQuery("#icon-prev-imgs").click(function(ev) {
    jQuery(this).closest("#carouselWrapper").find(".container-dots .dot.active").prev().click();
  });
}